var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/utils/items/ArtboardUtils.ts
var ArtboardUtils_exports = {};
__export(ArtboardUtils_exports, {
  create: () => create10,
  mSetSize: () => mSetSize
});

// src/utils/maths/MatrixUtils.ts
var MatrixUtils_exports = {};
__export(MatrixUtils_exports, {
  create: () => create2,
  divideLeft: () => divideLeft,
  divideRight: () => divideRight,
  getDeterminant: () => getDeterminant,
  getRotationAngle: () => getRotationAngle,
  getScaling: () => getScaling,
  getTranslation: () => getTranslation,
  invert: () => invert,
  isInvertible: () => isInvertible,
  multiply: () => multiply2,
  rotate: () => rotate2,
  scale: () => scale,
  shiftLeft: () => shiftLeft,
  translate: () => translate
});

// src/utils/maths/NumberUtils.ts
var NumberUtils_exports = {};
__export(NumberUtils_exports, {
  degToRad: () => degToRad,
  epsilon: () => epsilon,
  isCloseTo: () => isCloseTo,
  isCloseToInt: () => isCloseToInt,
  quantize: () => quantize,
  radToDeg: () => radToDeg,
  roundToNearest: () => roundToNearest
});
function isCloseTo(a, b, precision = 6) {
  if (a === Infinity && b === Infinity)
    return true;
  if (a === -Infinity && b === -Infinity)
    return true;
  const acceptableDiff = 10 ** -precision / 2;
  const actualDiff = Math.abs(a - b);
  return actualDiff < acceptableDiff;
}
function isCloseToInt(a, precision = 6) {
  return isCloseTo(a % 1, 0, precision);
}
function quantize(val, n) {
  return Math.floor(val * (n + 0.999));
}
function degToRad(degrees) {
  return degrees * Math.PI / 180;
}
function radToDeg(radians) {
  return radians * 180 / Math.PI;
}
var epsilon = 1e-6;
function roundToNearest(number, n = 1, error = epsilon) {
  let coefficient;
  const factor = number / n;
  const mantissa = factor % 1;
  const mid = factor < 0 ? -0.5 : 0.5;
  if (mantissa < mid - error) {
    coefficient = Math.floor(factor);
  } else {
    coefficient = Math.ceil(factor);
  }
  return coefficient * n;
}

// src/utils/maths/PointUtils.ts
var PointUtils_exports = {};
__export(PointUtils_exports, {
  MIN_SIZE: () => MIN_SIZE,
  abs: () => abs,
  add: () => add,
  coerce: () => coerce,
  create: () => create,
  distance: () => distance,
  divide: () => divide,
  getAngleBetween: () => getAngleBetween,
  getCenter: () => getCenter,
  hasZero: () => hasZero,
  isCloseTo: () => isCloseTo2,
  isZero: () => isZero,
  max: () => max,
  min: () => min,
  multiply: () => multiply,
  negate: () => negate,
  pointOnCircle: () => pointOnCircle,
  reciprocal: () => reciprocal,
  rotate: () => rotate,
  round: () => round,
  roundToNearest: () => roundToNearest2,
  sign: () => sign,
  snap: () => snap,
  subtract: () => subtract,
  transform: () => transform
});

// src/types/design/v1.ts
var v1_exports = {};
__export(v1_exports, {
  AssetUploadStatus: () => AssetUploadStatus,
  BlendMode: () => BlendMode,
  ColorFormat: () => ColorFormat,
  FillRule: () => FillRule,
  GradientType: () => GradientType,
  ItemClass: () => ItemClass,
  LineDecoration: () => LineDecoration,
  PatternType: () => PatternType,
  PropertyClass: () => PropertyClass,
  ShapeType: () => ShapeType,
  StrokeAlign: () => StrokeAlign,
  StrokeCap: () => StrokeCap,
  StrokeJoin: () => StrokeJoin,
  StrokePosition: () => StrokePosition,
  TextAlign: () => TextAlign,
  TextDecoration: () => TextDecoration,
  TextSizing: () => TextSizing,
  TextUnit: () => TextUnit,
  TokenType: () => TokenType,
  VAlign: () => VAlign
});
var PropertyClass = /* @__PURE__ */ ((PropertyClass2) => {
  PropertyClass2["Fill"] = "Fill";
  PropertyClass2["Color"] = "Color";
  PropertyClass2["Gradient"] = "Gradient";
  PropertyClass2["Shadow"] = "Shadow";
  PropertyClass2["Stroke"] = "Stroke";
  PropertyClass2["Pattern"] = "Pattern";
  return PropertyClass2;
})(PropertyClass || {});
var ColorFormat = /* @__PURE__ */ ((ColorFormat2) => {
  ColorFormat2["Hex"] = "HEX";
  ColorFormat2["Hsla"] = "HSLA";
  ColorFormat2["Hsba"] = "HSBA";
  ColorFormat2["Rgba"] = "RGBA";
  return ColorFormat2;
})(ColorFormat || {});
var BlendMode = /* @__PURE__ */ ((BlendMode2) => {
  BlendMode2["Normal"] = "normal";
  BlendMode2["Multiply"] = "multiply";
  BlendMode2["Screen"] = "screen";
  BlendMode2["Overlay"] = "overlay";
  BlendMode2["Darken"] = "darken";
  BlendMode2["Lighten"] = "lighten";
  BlendMode2["ColorDodge"] = "color-dodge";
  BlendMode2["ColorBurn"] = "color-burn";
  BlendMode2["HardLight"] = "hard-light";
  BlendMode2["SoftLight"] = "soft-light";
  BlendMode2["Difference"] = "difference";
  BlendMode2["Exclusion"] = "exclusion";
  BlendMode2["Hue"] = "hue";
  BlendMode2["Saturation"] = "saturation";
  BlendMode2["Color"] = "color";
  BlendMode2["Luminosity"] = "luminosity";
  return BlendMode2;
})(BlendMode || {});
var GradientType = /* @__PURE__ */ ((GradientType2) => {
  GradientType2["Linear"] = "linear";
  GradientType2["Angular"] = "angular";
  GradientType2["Radial"] = "radial";
  return GradientType2;
})(GradientType || {});
var PatternType = /* @__PURE__ */ ((PatternType2) => {
  PatternType2["Fill"] = "fill";
  PatternType2["Fit"] = "fit";
  PatternType2["Stretch"] = "stretch";
  PatternType2["Tile"] = "tile";
  return PatternType2;
})(PatternType || {});
var FillRule = /* @__PURE__ */ ((FillRule2) => {
  FillRule2["Nonzero"] = "nonzero";
  FillRule2["Evenodd"] = "evenodd";
  return FillRule2;
})(FillRule || {});
var TokenType = /* @__PURE__ */ ((TokenType2) => {
  TokenType2["Color"] = "color";
  TokenType2["Group"] = "group";
  return TokenType2;
})(TokenType || {});
var StrokePosition = /* @__PURE__ */ ((StrokePosition2) => {
  StrokePosition2["Center"] = "center";
  StrokePosition2["Inside"] = "inside";
  StrokePosition2["Outside"] = "outside";
  return StrokePosition2;
})(StrokePosition || {});
var StrokeAlign = /* @__PURE__ */ ((StrokeAlign2) => {
  StrokeAlign2["Center"] = "center";
  return StrokeAlign2;
})(StrokeAlign || {});
var StrokeCap = /* @__PURE__ */ ((StrokeCap2) => {
  StrokeCap2["Butt"] = "butt";
  StrokeCap2["Round"] = "round";
  StrokeCap2["Square"] = "square";
  return StrokeCap2;
})(StrokeCap || {});
var StrokeJoin = /* @__PURE__ */ ((StrokeJoin2) => {
  StrokeJoin2["Bevel"] = "bevel";
  StrokeJoin2["Miter"] = "miter";
  StrokeJoin2["Round"] = "round";
  return StrokeJoin2;
})(StrokeJoin || {});
var AssetUploadStatus = /* @__PURE__ */ ((AssetUploadStatus2) => {
  AssetUploadStatus2["Uploading"] = "uploading";
  AssetUploadStatus2["Uploaded"] = "uploaded";
  return AssetUploadStatus2;
})(AssetUploadStatus || {});
var ItemClass = /* @__PURE__ */ ((ItemClass2) => {
  ItemClass2["Canvas"] = "Canvas";
  ItemClass2["Group"] = "Group";
  ItemClass2["Mask"] = "Mask";
  ItemClass2["Raster"] = "Raster";
  ItemClass2["Shape"] = "Shape";
  ItemClass2["Path"] = "Path";
  ItemClass2["CompoundPath"] = "CompoundPath";
  ItemClass2["Slice"] = "Slice";
  ItemClass2["Text"] = "Text";
  return ItemClass2;
})(ItemClass || {});
var LineDecoration = /* @__PURE__ */ ((LineDecoration2) => {
  LineDecoration2["None"] = "none";
  LineDecoration2["TriangleArrow"] = "triangleArrow";
  return LineDecoration2;
})(LineDecoration || {});
var ShapeType = /* @__PURE__ */ ((ShapeType2) => {
  ShapeType2["Rectangle"] = "rectangle";
  ShapeType2["Ellipse"] = "ellipse";
  return ShapeType2;
})(ShapeType || {});
var TextAlign = /* @__PURE__ */ ((TextAlign2) => {
  TextAlign2["Left"] = "left";
  TextAlign2["Right"] = "right";
  TextAlign2["Center"] = "center";
  TextAlign2["Justify"] = "justify";
  return TextAlign2;
})(TextAlign || {});
var TextSizing = /* @__PURE__ */ ((TextSizing2) => {
  TextSizing2["Absolute"] = "absolute";
  TextSizing2["Auto"] = "auto";
  return TextSizing2;
})(TextSizing || {});
var TextUnit = /* @__PURE__ */ ((TextUnit2) => {
  TextUnit2["Pixel"] = "px";
  TextUnit2["Percent"] = "%";
  return TextUnit2;
})(TextUnit || {});
var TextDecoration = /* @__PURE__ */ ((TextDecoration2) => {
  TextDecoration2["None"] = "none";
  TextDecoration2["Strikethrough"] = "strikethrough";
  TextDecoration2["Underline"] = "underline";
  return TextDecoration2;
})(TextDecoration || {});
var VAlign = /* @__PURE__ */ ((VAlign2) => {
  VAlign2["Top"] = "top";
  VAlign2["Center"] = "center";
  VAlign2["Bottom"] = "bottom";
  return VAlign2;
})(VAlign || {});

// src/types/math.ts
var Axis = /* @__PURE__ */ ((Axis2) => {
  Axis2[Axis2["X"] = 0] = "X";
  Axis2[Axis2["Y"] = 1] = "Y";
  return Axis2;
})(Axis || {});
var AXES = [0 /* X */, 1 /* Y */];
var OuterEdge = /* @__PURE__ */ ((OuterEdge2) => {
  OuterEdge2["Left"] = "left";
  OuterEdge2["Right"] = "right";
  OuterEdge2["Top"] = "top";
  OuterEdge2["Bottom"] = "bottom";
  return OuterEdge2;
})(OuterEdge || {});
var InnerEdge = /* @__PURE__ */ ((InnerEdge2) => {
  InnerEdge2["HMid"] = "hmid";
  InnerEdge2["VMid"] = "vmid";
  return InnerEdge2;
})(InnerEdge || {});
var OUTER_EDGES = [
  "left" /* Left */,
  "right" /* Right */,
  "top" /* Top */,
  "bottom" /* Bottom */
];
var INNER_EDGES = ["hmid" /* HMid */, "vmid" /* VMid */];
var ALL_EDGES = [...OUTER_EDGES, ...INNER_EDGES];

// src/types/fonts.ts
var FontStyle = /* @__PURE__ */ ((FontStyle2) => {
  FontStyle2["Italic"] = "italic";
  FontStyle2["Normal"] = "normal";
  return FontStyle2;
})(FontStyle || {});
var fontWeightNames = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
};

// src/utils/maths/PointUtils.ts
var DEFAULT_AXES = {
  [0 /* X */]: true,
  [1 /* Y */]: true
};
function coerce(value) {
  if (typeof value === "number") {
    return [value, value];
  }
  return value;
}
function create(x = 0, y = 0) {
  return [x, y];
}
function add([x, y], value) {
  const [x2, y2] = coerce(value);
  return create(x + x2, y + y2);
}
function divide([x, y], value) {
  const [x2, y2] = coerce(value);
  return create(x / x2, y / y2);
}
function isZero([x, y]) {
  return x === 0 && y === 0;
}
function hasZero([x, y]) {
  return x === 0 || y === 0;
}
function abs([x, y]) {
  return create(Math.abs(x), Math.abs(y));
}
function max([x1, y1], [x2, y2]) {
  return create(Math.max(x1, x2), Math.max(y1, y2));
}
function min([x1, y1], [x2, y2]) {
  return create(Math.min(x1, x2), Math.min(y1, y2));
}
function multiply([x, y], value) {
  const [x2, y2] = coerce(value);
  return create(x * x2, y * y2);
}
function negate([x, y]) {
  return create(-x, -y);
}
function sign([x, y]) {
  return create(x < 0 ? -1 : 1, y < 0 ? -1 : 1);
}
function subtract([x, y], value) {
  const [x2, y2] = coerce(value);
  return create(x - x2, y - y2);
}
function reciprocal([x, y]) {
  return create(1 / x, 1 / y);
}
function transform([x, y], [a, b, c, d, tx, ty]) {
  return create(x * a + y * c + tx, x * b + y * d + ty);
}
function isCloseTo2([x1, y1], [x2, y2], precision) {
  return isCloseTo(x1, x2, precision) && isCloseTo(y1, y2, precision);
}
function round([x, y]) {
  return create(Math.round(x), Math.round(y));
}
function roundToNearest2([x, y], n, error) {
  return create(roundToNearest(x, n, error), roundToNearest(y, n, error));
}
function distance([x1, y1], [x2, y2]) {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
}
function getCenter(a, b) {
  const minValues = min(a, b);
  const maxValues = max(a, b);
  const length = subtract(maxValues, minValues);
  const halfLength = divide(length, 2);
  return add(minValues, halfLength);
}
function rotate([x, y], radians, [cx, cy] = [0, 0]) {
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const tx = x - cx;
  const ty = y - cy;
  return [tx * cos + ty * sin + cx, -tx * sin + ty * cos + cy];
}
function pointOnCircle(radius, angle, cx = 0, cy = 0) {
  const x = cx + radius * Math.sin(angle);
  const y = cy + radius * Math.cos(angle);
  return [x, y];
}
function snap([x, y], n = 1, { axes = DEFAULT_AXES } = {}) {
  return [
    axes[0 /* X */] ? roundToNearest(x, n) : x,
    axes[1 /* Y */] ? roundToNearest(y, n) : y
  ];
}
function getAngleBetween(p1, p2, center = [0, 0]) {
  const [x1, y1] = subtract(p1, center);
  const [x2, y2] = subtract(p2, center);
  return Math.atan2(x1 * x2 + y1 * y2, y1 * x2 - x1 * y2) - Math.PI / 2;
}
var MIN_SIZE = [Number.EPSILON, Number.EPSILON];

// src/utils/maths/MatrixUtils.ts
function create2(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0) {
  return [a, b, c, d, tx, ty];
}
function divideLeft(matrixA, matrixB) {
  return multiply2(matrixA, invert(matrixB));
}
function divideRight(matrixA, matrixB) {
  return multiply2(invert(matrixB), matrixA);
}
function getDeterminant([a, b, c, d]) {
  return a * d - c * b;
}
function getScaling(matrix) {
  const [a, b, c, d] = matrix;
  const determinant = getDeterminant(matrix);
  if (a !== 0 || b !== 0) {
    const r = Math.sqrt(a * a + b * b);
    return [r, determinant / r];
  }
  if (c !== 0 || d !== 0) {
    const s = Math.sqrt(c * c + d * d);
    return [determinant / s, s];
  }
  return [0, 0];
}
function multiply2([a1, b1, c1, d1, tx1, ty1], [a2, b2, c2, d2, tx2, ty2]) {
  return create2(a2 * a1 + b2 * c1, a2 * b1 + b2 * d1, c2 * a1 + d2 * c1, c2 * b1 + d2 * d1, tx1 + tx2 * a1 + ty2 * c1, ty1 + tx2 * b1 + ty2 * d1);
}
function invert(matrix) {
  const determinant = getDeterminant(matrix);
  const [a, b, c, d, tx, ty] = matrix;
  return create2(d / determinant + 0, -b / determinant + 0, -c / determinant + 0, a / determinant + 0, (c * ty - d * tx) / determinant + 0, (b * tx - a * ty) / determinant + 0);
}
function isInvertible(matrix) {
  const determinant = getDeterminant(matrix);
  const [, , , , tx, ty] = matrix;
  return !!determinant && !isCloseTo(determinant, 0) && !Number.isNaN(determinant) && !isCloseTo(determinant, 0) && Number.isFinite(tx) && Number.isFinite(ty);
}
function scale(matrix, scaleAmount, center) {
  const [scaleX, scaleY] = coerce(scaleAmount);
  const [a, b, c, d, tx, ty] = center ? translate(matrix, center) : matrix;
  const scaledMatrix = [
    a * scaleX,
    b * scaleX,
    c * scaleY,
    d * scaleY,
    tx,
    ty
  ];
  return center ? translate(scaledMatrix, negate(center)) : scaledMatrix;
}
function shiftLeft(matrixA, matrixB) {
  return multiply2(divideRight(matrixA, matrixB), matrixB);
}
function translate([a, b, c, d, tx, ty], p, out = create2(a, b, c, d)) {
  const [x, y] = coerce(p);
  out[4] = tx + (x * a + y * c);
  out[5] = ty + (x * b + y * d);
  return out;
}
function rotate2([a, b, c, d, tx, ty], theta, [x, y] = [0, 0]) {
  const cos = Math.cos(theta);
  const sin = Math.sin(theta);
  const txOffset = x - x * cos + y * sin;
  const tyOffset = y - x * sin - y * cos;
  return [
    cos * a + sin * c,
    cos * b + sin * d,
    -sin * a + cos * c,
    -sin * b + cos * d,
    tx + txOffset * a + tyOffset * c,
    ty + txOffset * b + tyOffset * d
  ];
}
function getRotationAngle([a, b, c, d]) {
  if (a !== 0 || b !== 0) {
    const r = Math.sqrt(a * a + b * b);
    return Math.acos(a / r) * (b > 0 ? 1 : -1);
  }
  if (c !== 0 || d !== 0) {
    const s = Math.sqrt(c * c + d * d);
    return Math.asin(c / s) * (d > 0 ? 1 : -1);
  }
  return 0;
}
function getTranslation([_a, _b, _c, _d, tx, ty]) {
  return [tx, ty];
}

// src/utils/maths/RectangleUtils.ts
var RectangleUtils_exports = {};
__export(RectangleUtils_exports, {
  containing: () => containing,
  contains: () => contains,
  create: () => create3,
  expand: () => expand,
  getAspectRatio: () => getAspectRatio,
  getCenter: () => getCenter2,
  getCorners: () => getCorners,
  getEdgeAxis: () => getEdgeAxis,
  getEdgeVector: () => getEdgeVector,
  getEdgeVectorValue: () => getEdgeVectorValue,
  getEdgeVectors: () => getEdgeVectors,
  getLineEdgeVectors: () => getLineEdgeVectors,
  getMatrixBetween: () => getMatrixBetween,
  intersects: () => intersects,
  matchAspectRatio: () => matchAspectRatio,
  minSize: () => minSize,
  scale: () => scale2,
  setCenter: () => setCenter,
  setSize: () => setSize,
  snap: () => snap2,
  transform: () => transform2,
  unite: () => unite,
  uniteAll: () => uniteAll
});

// src/common/utils.ts
var enumArrayToDict = (arr) => arr.reduce((dict, edge) => {
  dict[edge] = true;
  return dict;
}, {});

// src/utils/maths/RectangleUtils.ts
var OUTER_EDGE_DICT = enumArrayToDict(OUTER_EDGES);
var ALL_EDGE_DICT = enumArrayToDict(ALL_EDGES);
function create3(point = create(), size = create()) {
  return {
    point,
    size
  };
}
function coerceOptionDict(value) {
  if (Array.isArray(value))
    return enumArrayToDict(value);
  return value;
}
function expand(rectangle, amount, { edges = OUTER_EDGE_DICT } = {}) {
  const amountAsPoint = coerce(amount);
  if (isZero(amountAsPoint))
    return rectangle;
  const edgeOptions = coerceOptionDict(edges);
  const expandLeft = edgeOptions["left" /* Left */];
  const expandRight = edgeOptions["right" /* Right */];
  const expandTop = edgeOptions["top" /* Top */];
  const expandBottom = edgeOptions["bottom" /* Bottom */];
  const hCount = (Number(expandLeft) || 0) + (Number(expandRight) || 0);
  const vCount = (Number(expandTop) || 0) + (Number(expandBottom) || 0);
  const { point, size } = rectangle;
  const [hAmount, vAmount] = divide(amountAsPoint, [hCount, vCount]);
  const newPoint = subtract(point, [
    expandLeft ? hAmount : 0,
    expandTop ? vAmount : 0
  ]);
  const newSize = add(size, [
    hCount ? amountAsPoint[0] : 0,
    vCount ? amountAsPoint[1] : 0
  ]);
  return create3(newPoint, newSize);
}
function getCorners({ point, size }) {
  return [
    create(point[0], point[1]),
    create(point[0] + size[0], point[1]),
    create(point[0], point[1] + size[1]),
    create(point[0] + size[0], point[1] + size[1])
  ];
}
function getEdgeVectors({ point, size }, { edges = ALL_EDGE_DICT } = {}) {
  const edgeOptions = coerceOptionDict(edges);
  const left = point[0];
  const right = point[0] + size[0];
  const top = point[1];
  const bottom = point[1] + size[1];
  const hMid = point[0] + size[0] / 2;
  const vMid = point[1] + size[1] / 2;
  return [
    {
      start: [left, top],
      end: [left, bottom],
      edge: "left" /* Left */
    },
    {
      start: [right, top],
      end: [right, bottom],
      edge: "right" /* Right */
    },
    {
      start: [hMid, top],
      end: [hMid, bottom],
      edge: "hmid" /* HMid */
    },
    {
      start: [left, top],
      end: [right, top],
      edge: "top" /* Top */
    },
    {
      start: [left, bottom],
      end: [right, bottom],
      edge: "bottom" /* Bottom */
    },
    {
      start: [left, vMid],
      end: [right, vMid],
      edge: "vmid" /* VMid */
    }
  ].filter(({ edge }) => edgeOptions[edge]);
}
function getLineEdgeVectors({ start, end }, { edges = ALL_EDGE_DICT } = {}) {
  const edgeOptions = coerceOptionDict(edges);
  const isStraight = isCloseTo(start[0], end[0]) || isCloseTo(start[1], end[1]);
  const leftPoint = start[0] < end[0] ? start : end;
  const rightPoint = start[0] > end[0] ? start : end;
  const topPoint = start[1] < end[1] ? start : end;
  const bottomPoint = start[1] > end[1] ? start : end;
  if (isStraight) {
    return getEdgeVectors({
      point: [leftPoint[0], topPoint[1]],
      size: [rightPoint[0] - leftPoint[0], bottomPoint[1] - topPoint[1]]
    }, { edges });
  }
  const midPoint = divide(add(start, end), 2);
  return [
    {
      start: leftPoint,
      end: leftPoint,
      edge: "left" /* Left */
    },
    {
      start: rightPoint,
      end: rightPoint,
      edge: "right" /* Right */
    },
    {
      start: midPoint,
      end: midPoint,
      edge: "hmid" /* HMid */
    },
    {
      start: topPoint,
      end: topPoint,
      edge: "top" /* Top */
    },
    {
      start: bottomPoint,
      end: bottomPoint,
      edge: "bottom" /* Bottom */
    },
    {
      start: midPoint,
      end: midPoint,
      edge: "vmid" /* VMid */
    }
  ].filter(({ edge }) => edgeOptions[edge]);
}
function getEdgeVector(rect, edge) {
  return getEdgeVectors(rect, { edges: [edge] })[0];
}
function getEdgeAxis(edge) {
  if (edge === "left" /* Left */ || edge === "right" /* Right */ || edge === "hmid" /* HMid */)
    return 0 /* X */;
  return 1 /* Y */;
}
function getEdgeVectorValue(edgeVector) {
  const axis = getEdgeAxis(edgeVector.edge);
  return edgeVector.start[axis];
}
function getCenter2({ point, size }) {
  return create(point[0] + size[0] / 2, point[1] + size[1] / 2);
}
function containing(points) {
  const { min: min2, max: max2 } = points.reduce((acc, [x, y]) => {
    return {
      min: min(acc.min, [x, y]),
      max: max(acc.max, [x, y])
    };
  }, {
    min: [Infinity, Infinity],
    max: [-Infinity, -Infinity]
  });
  return create3(min2, subtract(max2, min2));
}
function contains({ point: [left, top], size: [width, height] }, [x, y]) {
  const right = left + width;
  const bottom = top + height;
  return x >= left && x <= right && y >= top && y <= bottom;
}
function intersects({ point: pointA, size: sizeA }, { point: pointB, size: sizeB }) {
  return !(pointA[0] > pointB[0] + sizeB[0] || pointA[0] + sizeA[0] < pointB[0] || pointA[1] > pointB[1] + sizeB[1] || pointA[1] + sizeA[1] < pointB[1]);
}
function getMatrixBetween({ point: pointA, size: sizeA }, { point: pointB, size: sizeB }) {
  const cappedSizeA = max(sizeA, MIN_SIZE);
  const cappedSizeB = max(sizeB, MIN_SIZE);
  const scaleFactor = divide(cappedSizeB, cappedSizeA);
  return translate(scale(translate(create2(), pointB), scaleFactor), negate(pointA));
}
function minSize(rectangle, min2) {
  const [minWidth, minHeight] = coerce(min2);
  const amountToExpand = [
    rectangle.size[0] < minWidth ? minWidth - rectangle.size[0] : 0,
    rectangle.size[1] < minHeight ? minHeight - rectangle.size[1] : 0
  ];
  return expand(rectangle, amountToExpand);
}
function unite({ point: point1, size: size1 }, { point: point2, size: size2 }, out = create3()) {
  const topLeft = min(point1, point2);
  const bottomRight = max(add(point1, size1), add(point2, size2));
  out.point = topLeft;
  out.size = subtract(bottomRight, topLeft);
  return out;
}
function uniteAll(rectangles, out = create3(rectangles[0].point, rectangles[0].size)) {
  return rectangles.reduce((acc, bounds) => unite(acc, bounds, acc), out);
}
function scale2(rectangle, scaleAmount, center) {
  const scaleMatrix = scale(create2(), scaleAmount, center);
  return transform2(rectangle, scaleMatrix);
}
function transform2(rect, matrix) {
  const corners = getCorners(rect).map((point) => transform(point, matrix));
  const { minX, maxX, minY, maxY } = corners.reduce((acc, [x, y]) => ({
    minX: Math.min(acc.minX, x),
    minY: Math.min(acc.minY, y),
    maxX: Math.max(acc.maxX, x),
    maxY: Math.max(acc.maxY, y)
  }), {
    minX: Infinity,
    minY: Infinity,
    maxX: -Infinity,
    maxY: -Infinity
  });
  return create3([minX, minY], [maxX - minX, maxY - minY]);
}
function setCenter({ size }, center, out = create3(void 0, size)) {
  out.point = [center[0] - size[0] / 2, center[1] - size[1] / 2];
  return out;
}
function setSize({ point }, size, out = create3(point)) {
  out.size = size;
  return out;
}
function getAspectRatio({ size: [width, height] }) {
  return height / width;
}
function snap2(rectangle, n = 1, { edges = OUTER_EDGE_DICT, aspectRatioLocked = false } = {}) {
  const { size, point } = rectangle;
  const edgeOptions = coerceOptionDict(edges);
  const snapLeft = edgeOptions["left" /* Left */];
  const snapRight = edgeOptions["right" /* Right */];
  const snapTop = edgeOptions["top" /* Top */];
  const snapBottom = edgeOptions["bottom" /* Bottom */];
  const snappedPoint = [
    snapLeft ? roundToNearest(point[0], n) : point[0],
    snapTop ? roundToNearest(point[1], n) : point[1]
  ];
  const [oldRight, oldBottom] = add(point, size);
  const [newRight, newBottom] = add(snappedPoint, size);
  const snappedEnd = [
    snapRight ? roundToNearest(newRight, n) : oldRight,
    snapBottom ? roundToNearest(newBottom, n) : oldBottom
  ];
  const snappedSize = subtract(snappedEnd, snappedPoint);
  const snappedRect = {
    point: snappedPoint,
    size: snappedSize
  };
  if (!aspectRatioLocked)
    return snappedRect;
  return matchAspectRatio(snappedRect, rectangle, { edges });
}
function matchAspectRatio(newRect, originalRect, { edges = OUTER_EDGE_DICT, ignoreZero = false } = {}) {
  const aspectRatio = getAspectRatio(originalRect);
  const edgeOptions = coerceOptionDict(edges);
  const hasHorizontalEdge = edgeOptions["left" /* Left */] || edgeOptions["right" /* Right */];
  const hasVerticalEdge = edgeOptions["top" /* Top */] || edgeOptions["bottom" /* Bottom */];
  const originalSize = originalRect.size;
  const newSize = newRect.size;
  const targetHeight = newSize[0] * aspectRatio;
  const targetWidth = newSize[1] / aspectRatio;
  const heightDelta = targetHeight - newSize[1];
  const widthDelta = targetWidth - newSize[0];
  if (heightDelta === 0 && widthDelta === 0)
    return newRect;
  if (hasHorizontalEdge && hasVerticalEdge) {
    const [horizontalDelta, verticalDelta] = abs(subtract(newSize, originalSize)).map((value) => value === 0 && ignoreZero ? Infinity : 0);
    if (horizontalDelta < verticalDelta) {
      return expand(newRect, [0, heightDelta], { edges });
    }
    return expand(newRect, [widthDelta, 0], { edges });
  }
  if (hasHorizontalEdge) {
    return expand(newRect, [0, heightDelta]);
  }
  return expand(newRect, [widthDelta, 0]);
}

// src/utils/maths/SizeUtils.ts
var SizeUtils_exports = {};
__export(SizeUtils_exports, {
  MIN_SIZE: () => MIN_SIZE,
  abs: () => abs,
  add: () => add,
  coerce: () => coerce,
  create: () => create,
  distance: () => distance,
  divide: () => divide,
  getAngleBetween: () => getAngleBetween,
  getCenter: () => getCenter,
  hasZero: () => hasZero,
  isCloseTo: () => isCloseTo2,
  isZero: () => isZero,
  max: () => max,
  min: () => min,
  multiply: () => multiply,
  negate: () => negate,
  pointOnCircle: () => pointOnCircle,
  reciprocal: () => reciprocal,
  rotate: () => rotate,
  round: () => round,
  roundToNearest: () => roundToNearest2,
  sign: () => sign,
  snap: () => snap,
  subtract: () => subtract,
  transform: () => transform
});

// src/utils/properties/ColorUtils.ts
var ColorUtils_exports = {};
__export(ColorUtils_exports, {
  colorToVariant: () => colorToVariant,
  create: () => create4,
  createColorVariant: () => createColorVariant,
  createFromCSSHsla: () => createFromCSSHsla,
  createFromCSSRgb: () => createFromCSSRgb,
  createFromCSSRgba: () => createFromCSSRgba,
  createFromHex: () => createFromHex,
  createFromHsba: () => createFromHsba,
  createFromHsla: () => createFromHsla,
  createFromRgba: () => createFromRgba,
  getCssRgba: () => getCssRgba,
  getHex: () => getHex,
  getHsba: () => getHsba,
  getHsla: () => getHsla,
  getLuminance: () => getLuminance,
  getOpacity: () => getOpacity,
  getRgba: () => getRgba,
  getTextColorForBackground: () => getTextColorForBackground,
  getVariantOpacity: () => getVariantOpacity,
  hexToRgba: () => hexToRgba,
  hsbaToHsla: () => hsbaToHsla,
  hsbaToRgba: () => hsbaToRgba,
  hslaToHsba: () => hslaToHsba,
  hslaToRgba: () => hslaToRgba,
  isCloseTo: () => isCloseTo3,
  isColor: () => isColor,
  isValidHex: () => isValidHex,
  longFormatHex: () => longFormatHex,
  parseHex: () => parseHex,
  rgbaToHex: () => rgbaToHex,
  rgbaToHsba: () => rgbaToHsba,
  rgbaToHsla: () => rgbaToHsla,
  setOpacity: () => setOpacity,
  setVariantOpacity: () => setVariantOpacity,
  variantToColor: () => variantToColor,
  variantToVariant: () => variantToVariant
});
import update from "immutability-helper";
function create4(options = {}) {
  return Object.assign({
    className: "Color" /* Color */,
    rgbaValues: [0, 0, 0, 1]
  }, options);
}
function createFromRgba(rgbaValues = [0, 0, 0, 1]) {
  return create4({
    className: "Color" /* Color */,
    rgbaValues
  });
}
function createFromHex(hex = "#000000", opacity) {
  return create4({
    className: "Color" /* Color */,
    rgbaValues: hexToRgba(hex, opacity) || void 0
  });
}
function createFromHsla([H, S, L, A]) {
  return create4({
    className: "Color" /* Color */,
    rgbaValues: hslaToRgba([H, S, L, A])
  });
}
function createFromHsba([H, S, B, A]) {
  return create4({
    className: "Color" /* Color */,
    rgbaValues: hsbaToRgba([H, S, B, A])
  });
}
function createFromCSSRgb(cssRgb) {
  const parts = cssRgb.split("(")[1].replace(")", "").split(",").map((n) => Number(n) / 255);
  return createFromRgba([
    parts[0],
    parts[1],
    parts[2],
    1
  ]);
}
function setOpacity(color, opacity) {
  return update(color, {
    rgbaValues: {
      "3": {
        $set: opacity
      }
    }
  });
}
function getHex(color) {
  return rgbaToHex(color.rgbaValues);
}
function getRgba(color) {
  return color.rgbaValues;
}
function getOpacity(color) {
  return color.rgbaValues[3];
}
function getHsla(color) {
  return rgbaToHsla(color.rgbaValues);
}
function getHsba(color) {
  return rgbaToHsba(color.rgbaValues);
}
function variantToColor(variant) {
  switch (variant.format) {
    case "HEX" /* Hex */:
      return createFromHex(variant.value.hex, variant.value.opacity);
    case "HSLA" /* Hsla */:
      return createFromHsla(variant.value);
    case "HSBA" /* Hsba */:
      return createFromHsba(variant.value);
    case "RGBA" /* Rgba */:
      return createFromRgba(variant.value);
  }
}
function colorToVariant(color, colorFormat) {
  switch (colorFormat) {
    case "HEX" /* Hex */:
      return {
        format: colorFormat,
        value: { hex: getHex(color), opacity: getOpacity(color) }
      };
    case "HSLA" /* Hsla */:
      return { format: colorFormat, value: getHsla(color) };
    case "HSBA" /* Hsba */:
      return { format: colorFormat, value: getHsba(color) };
    case "RGBA" /* Rgba */:
      return { format: colorFormat, value: [...getRgba(color)] };
  }
}
function variantToVariant(variant, toFormat) {
  const { format: currentFormat, value } = variant;
  if (currentFormat === toFormat)
    return variant;
  if (currentFormat === "HSBA" /* Hsba */ && toFormat === "HSLA" /* Hsla */) {
    return {
      format: "HSLA" /* Hsla */,
      value: hsbaToHsla(value)
    };
  }
  if (currentFormat === "HSLA" /* Hsla */ && toFormat === "HSBA" /* Hsba */) {
    return {
      format: "HSBA" /* Hsba */,
      value: hslaToHsba(value)
    };
  }
  return colorToVariant(variantToColor(variant), toFormat);
}
function getVariantOpacity(variant) {
  switch (variant.format) {
    case "HEX" /* Hex */:
      return variant.value.opacity;
    case "RGBA" /* Rgba */:
    case "HSLA" /* Hsla */:
    case "HSBA" /* Hsba */:
      return variant.value[3];
  }
}
function createColorVariant(format, value) {
  return {
    format,
    value
  };
}
function setVariantOpacity(anyVariant, opacity) {
  const variant = anyVariant;
  switch (variant.format) {
    case "HEX" /* Hex */: {
      return __spreadProps(__spreadValues({}, variant), {
        value: {
          hex: variant.value.hex,
          opacity
        }
      });
    }
    case "RGBA" /* Rgba */:
    case "HSLA" /* Hsla */:
    case "HSBA" /* Hsba */: {
      const newValue = [...variant.value];
      newValue[3] = opacity;
      return __spreadProps(__spreadValues({}, variant), { value: newValue });
    }
  }
}
function getCssRgba(color) {
  const [r, g, b, a] = getRgba(color);
  const rVal = NumberUtils_exports.quantize(r, 255);
  const gVal = NumberUtils_exports.quantize(g, 255);
  const bVal = NumberUtils_exports.quantize(b, 255);
  return `rgba(${rVal}, ${gVal}, ${bVal}, ${a})`;
}
function createFromCSSRgba(cssRgb) {
  const rgba = cssRgb.split("(")[1].replace(")", "").split(",").map((n, i) => i < 3 ? Number(n) / 255 : Number(n));
  return createFromRgba(rgba);
}
function createFromCSSHsla(cssHsl) {
  const parts = cssHsl.split("(")[1].replace(")", "").split(" ");
  const h = parseFloat(parts[0]) / 360;
  const s = parseFloat(parts[1]) / 100;
  const l = parseFloat(parts[2]) / 100;
  const a = parts[3] ? Number(parts[3]) : 1;
  return createFromHsla([h, s, l, a]);
}
function getTextColorForBackground(bgColor) {
  const luminance = getLuminance(bgColor);
  const textColor = luminance > 0.179 ? "#000" : "#fff";
  return createFromHex(textColor);
}
function hexToRgba(hex, opacity) {
  const longHex = longFormatHex(hex);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(longHex);
  return result ? [
    parseInt(result[1], 16) / 255,
    parseInt(result[2], 16) / 255,
    parseInt(result[3], 16) / 255,
    opacity || 1
  ] : null;
}
function rgbaToHex([r, g, b]) {
  const rHex = NumberUtils_exports.quantize(r, 255).toString(16);
  const gHex = NumberUtils_exports.quantize(g, 255).toString(16);
  const bHex = NumberUtils_exports.quantize(b, 255).toString(16);
  const pad = (s) => s.length < 2 ? `0${s}` : s;
  return `#${pad(rHex)}${pad(gHex)}${pad(bHex)}`.toUpperCase();
}
function isValidHex(hex) {
  return /^#(?:[0-9A-F]{3}|[0-9A-F]{6})$/i.test(hex);
}
function rgbaToHsla([r, g, b, a]) {
  const max2 = Math.max(r, g, b);
  const min2 = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max2 + min2) / 2;
  if (max2 === min2) {
    h = 0;
    s = 0;
  } else {
    const d = max2 - min2;
    s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
    switch (max2) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
    }
    h /= 6;
  }
  return [h, s, l, a];
}
function hslaToRgba([h, s, l, a]) {
  let r;
  let g;
  let b;
  const hue2rgb = (p, q, t) => {
    if (t < 0)
      t += 1;
    if (t > 1)
      t -= 1;
    if (t < 1 / 6)
      return p + (q - p) * 6 * t;
    if (t < 1 / 2)
      return q;
    if (t < 2 / 3)
      return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };
  if (s === 0) {
    r = l;
    g = l;
    b = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r, g, b, a];
}
function rgbaToHsba([r, g, b, a]) {
  const max2 = Math.max(r, g, b);
  const min2 = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const v = max2;
  const d = max2 - min2;
  if (max2 === 0) {
    s = 0;
  } else {
    s = d / max2;
  }
  if (max2 === min2) {
    h = 0;
  } else {
    switch (max2) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
    }
    h /= 6;
  }
  return [h, s, v, a];
}
function hsbaToRgba([h, s, v, a]) {
  let r = 0;
  let g = 0;
  let b = 0;
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
    default:
  }
  return [r, g, b, a];
}
function hsbaToHsla([h, s, v, a]) {
  const l = (2 - s) * v / 2;
  let _s = s;
  if (l !== 0) {
    if (l === 1) {
      _s = 0;
    } else if (l < 0.5) {
      _s = s * v / (l * 2);
    } else {
      _s = s * v / (2 - l * 2);
    }
  }
  return [h, _s, l, a];
}
function hslaToHsba([h, s, l, a]) {
  if (l === 0) {
    return [h, s, 0, a];
  }
  const b = l + s * Math.min(l, 1 - l);
  const _s = b === 0 ? 0 : 2 * (1 - l / b);
  return [h, _s, b, a];
}
function parseHex(text) {
  var _a;
  const regexMatch = (_a = text.match(/[A-Fa-f0-9]{1,6}/)) == null ? void 0 : _a[0];
  if (!regexMatch)
    return null;
  const match = regexMatch.toUpperCase();
  const matchLength = match.length;
  if (matchLength === 6)
    return `#${match}`;
  if (matchLength >= 3 && matchLength <= 5) {
    return `#${match.slice(0, 3).split("").map((c) => `${c}${c}`).join("")}`;
  }
  if (matchLength === 2)
    return `#${match.repeat(3)}`;
  if (matchLength === 1)
    return `#${match.repeat(6)}`;
  return null;
}
function isColor(object) {
  return object.className === "Color" /* Color */;
}
function isCloseTo3(colorA, colorB, precision) {
  return colorA.rgbaValues.every((valueA, i) => NumberUtils_exports.isCloseTo(valueA, colorB.rgbaValues[i], precision));
}
function longFormatHex(hex) {
  return hex.length === 4 ? hex.replace(/^#(.)(.)(.)$/, "#$1$1$2$2$3$3") : hex;
}
function getLuminance(color) {
  const [r, g, b] = color.rgbaValues;
  return 0.213 * r + 0.715 * g + 0.072 * b;
}

// src/utils/properties/FillUtils.ts
var FillUtils_exports = {};
__export(FillUtils_exports, {
  colorFillToHex: () => colorFillToHex,
  createColorFill: () => createColorFill,
  createFillStyle: () => createFillStyle,
  createImageFill: () => createImageFill,
  getContent: () => getContent,
  getEnabled: () => getEnabled,
  getOpacity: () => getOpacity2,
  hexToColorFill: () => hexToColorFill,
  isColorFill: () => isColorFill,
  isPatternFill: () => isPatternFill,
  isTokenInstanceFill: () => isTokenInstanceFill
});

// src/utils/properties/PatternUtils.ts
var PatternUtils_exports = {};
__export(PatternUtils_exports, {
  create: () => create5
});
function create5(source, size, patternPartial) {
  return __spreadValues({
    className: "Pattern" /* Pattern */,
    type: "fill" /* Fill */,
    size,
    source
  }, patternPartial);
}

// src/utils/properties/FillUtils.ts
function create6(content, fillPartial = {}) {
  return __spreadValues({
    blendMode: "normal" /* Normal */,
    className: "Fill" /* Fill */,
    content,
    enabled: true
  }, fillPartial);
}
function createFillStyle(partial = {}) {
  return __spreadValues({
    fillRule: "nonzero" /* Nonzero */,
    fills: []
  }, partial);
}
function createColorFill(fromColor = create4(), options = {}) {
  return create6(fromColor, __spreadValues({}, options));
}
function createImageFill(url, size, options = {}) {
  return create6(create5(url, size), __spreadValues({}, options));
}
function getOpacity2(fill) {
  return getOpacity(fill.content);
}
function getContent(fill) {
  return fill.content;
}
function getEnabled(fill) {
  return fill.enabled;
}
function colorFillToHex(fill) {
  return rgbaToHex(fill.content.rgbaValues);
}
function hexToColorFill(hex) {
  return createColorFill(createFromHex(hex));
}
function isColorFill(fill) {
  return fill.content.className === "Color" /* Color */;
}
function isPatternFill(fill) {
  return fill.content.className === "Pattern" /* Pattern */;
}
function isTokenInstanceFill(fill) {
  return isPatternFill(fill) && !fill.content.source.startsWith("http");
}

// src/utils/properties/FontUtils.ts
var FontUtils_exports = {};
__export(FontUtils_exports, {
  createFontVariant: () => createFontVariant,
  findClosestVariant: () => findClosestVariant,
  getFont: () => getFont,
  getFontFamily: () => getFontFamily,
  hasFont: () => hasFont
});
import { capitalize, groupBy, has, keyBy, memoize } from "lodash-es";
var getFontListsByFamily = memoize((fontFaces) => groupBy(fontFaces, ({ fontFamily }) => fontFamily));
var getFontsByFullName = memoize((fontFaces) => keyBy(fontFaces, (fontFace) => fontFace.fullName));
var getFontsByPostScriptName = memoize((fontFaces) => keyBy(fontFaces, (fontFace) => fontFace.postScriptName));
function hasFont(fontFaces, fontDescriptor) {
  return getFontFamily(fontFaces, fontDescriptor) !== null;
}
function getFontFamily(fontFaces, fontDescriptor) {
  const fontListsByFamily = getFontListsByFamily(fontFaces);
  if (has(fontListsByFamily, fontDescriptor)) {
    return fontDescriptor;
  }
  const fontsByPostScriptName = getFontsByPostScriptName(fontFaces);
  if (has(fontsByPostScriptName, fontDescriptor)) {
    return fontsByPostScriptName[fontDescriptor].fontFamily;
  }
  const fontsByFullName = getFontsByFullName(fontFaces);
  if (has(fontsByFullName, fontDescriptor)) {
    return fontsByFullName[fontDescriptor].fontFamily;
  }
  return null;
}
function getFont(fontFaces, fontDescriptor, variant) {
  const fontListsByFamily = getFontListsByFamily(fontFaces);
  if (has(fontListsByFamily, fontDescriptor)) {
    return findClosestVariant(fontListsByFamily[fontDescriptor], variant);
  }
  const fontsByPostScriptName = getFontsByPostScriptName(fontFaces);
  if (has(fontsByPostScriptName, fontDescriptor)) {
    return fontsByPostScriptName[fontDescriptor];
  }
  const fontsByFullName = getFontsByFullName(fontFaces);
  if (has(fontsByFullName, fontDescriptor)) {
    return fontsByFullName[fontDescriptor];
  }
  return null;
}
function createFontVariant({
  fontStyle,
  fontWeight
}) {
  const fontVariantStyle = fontStyle === "italic" /* Italic */ ? ` ${capitalize(fontStyle)}` : "";
  const isRegularItalicFont = fontWeight === 400 && fontStyle === "italic" /* Italic */;
  const name = isRegularItalicFont ? fontVariantStyle.trim() : `${fontWeightNames[fontWeight]}${fontVariantStyle}`;
  return {
    fontStyle,
    fontWeight,
    name
  };
}
function findClosestVariant(variants, { fontStyle, fontWeight }) {
  const isFontItalic = fontStyle === "italic" /* Italic */;
  const styleOrder = isFontItalic ? ["italic" /* Italic */, "normal" /* Normal */] : ["normal" /* Normal */, "italic" /* Italic */];
  let variantsThatMatchFontStyle = [];
  styleOrder.some((styleName) => {
    const matches = variants.filter((font) => font.fontStyle === styleName);
    if (matches.length) {
      variantsThatMatchFontStyle = matches;
      return true;
    }
    return false;
  });
  if (!variantsThatMatchFontStyle.length)
    return null;
  if (fontWeight < 100 || fontWeight > 900 || fontWeight % 100) {
    throw new TypeError(`Invalid weight argument supplied to FontFamily#resolve(), expected a multiple of 100 inclusively from 100 to 900, received: ${fontWeight}`);
  }
  const weightSortFn = fontWeight <= 500 ? (a, b) => {
    if (a.fontWeight === fontWeight)
      return -1;
    if (b.fontWeight === fontWeight)
      return 1;
    if (fontWeight === 400) {
      if (a.fontWeight === 500)
        return -1;
      if (b.fontWeight === 500)
        return 1;
    }
    if (fontWeight === 500) {
      if (a.fontWeight === 400)
        return -1;
      if (b.fontWeight === 400)
        return 1;
    }
    if (a.fontWeight < fontWeight && b.fontWeight < fontWeight)
      return b.fontWeight - a.fontWeight;
    if (a.fontWeight < fontWeight)
      return -1;
    if (b.fontWeight < fontWeight)
      return 1;
    return a.fontWeight - b.fontWeight;
  } : (a, b) => {
    if (a.fontWeight === fontWeight)
      return -1;
    if (b.fontWeight === fontWeight)
      return 1;
    if (a.fontWeight > fontWeight && b.fontWeight > fontWeight)
      return a.fontWeight - b.fontWeight;
    if (a.fontWeight > fontWeight)
      return -1;
    if (b.fontWeight > fontWeight)
      return 1;
    return b.fontWeight - a.fontWeight;
  };
  return variantsThatMatchFontStyle.sort(weightSortFn)[0];
}

// src/utils/properties/GradientUtils.ts
var GradientUtils_exports = {};
__export(GradientUtils_exports, {
  create: () => create7,
  createLinear: () => createLinear,
  createStop: () => createStop,
  mAddStop: () => mAddStop,
  mRemoveStops: () => mRemoveStops,
  mSetStopColor: () => mSetStopColor,
  mSetStopPosition: () => mSetStopPosition
});
function create7() {
  throw new Error("TODO");
}
function createLinear({
  from = [0.5, 0],
  to = [1, 1]
} = {}) {
  return {
    className: "Gradient" /* Gradient */,
    type: "linear" /* Linear */,
    smoothenOpacity: false,
    stops: [],
    from,
    to
  };
}
function createStop(color = create4(), position = 0) {
  return {
    color,
    stopPosition: position
  };
}
function mAddStop(gradient, stop) {
  gradient.stops.push(stop);
  return gradient;
}
function mRemoveStops(gradient, index, count = 1) {
  gradient.stops.splice(index, count);
  return gradient;
}
function mSetStopPosition(mutable, position) {
  mutable.stopPosition = position;
  return mutable;
}
function mSetStopColor(mutable, color) {
  mutable.color = color;
  return mutable;
}

// src/utils/properties/ShadowUtils.ts
var ShadowUtils_exports = {};
__export(ShadowUtils_exports, {
  create: () => create8
});
function create8(partial = {}) {
  return __spreadValues({
    className: "Shadow" /* Shadow */,
    blur: 0,
    color: create4(),
    enabled: true,
    offset: [0, 0],
    shadowSpread: 0
  }, partial);
}

// src/utils/properties/StrokeUtils.ts
var StrokeUtils_exports = {};
__export(StrokeUtils_exports, {
  colorStrokeToHex: () => colorStrokeToHex,
  create: () => create9,
  createColorStroke: () => createColorStroke,
  createStrokeStyle: () => createStrokeStyle,
  getColor: () => getColor,
  getOpacity: () => getOpacity3,
  getPosition: () => getPosition,
  getWidth: () => getWidth,
  hexToColorStroke: () => hexToColorStroke,
  mSetWidth: () => mSetWidth
});
function create9(partial = {}) {
  return __spreadValues({
    className: "Stroke" /* Stroke */,
    color: create4(),
    enabled: true,
    strokePosition: "center" /* Center */,
    width: 1
  }, partial);
}
function createStrokeStyle(partial = {}) {
  return __spreadValues({
    dashArray: [],
    dashOffset: 0,
    miterLimit: 10,
    strokeCap: "butt" /* Butt */,
    strokeJoin: "miter" /* Miter */
  }, partial);
}
function createColorStroke(fromColor = create4(), options = {}) {
  return create9(__spreadProps(__spreadValues({}, options), {
    color: fromColor
  }));
}
function getPosition(stroke) {
  return stroke.strokePosition;
}
function getWidth(stroke) {
  return stroke.width;
}
function getColor(stroke) {
  return stroke.color;
}
function getOpacity3(stroke) {
  return stroke.color.rgbaValues[3];
}
function hexToColorStroke(hex) {
  return createColorStroke(createFromHex(hex));
}
function colorStrokeToHex(stroke) {
  return rgbaToHex(stroke.color.rgbaValues);
}
function mSetWidth(mutable, width) {
  mutable.width = width;
  return mutable;
}

// src/utils/properties/TokenUtils.ts
var TokenUtils_exports = {};
__export(TokenUtils_exports, {
  createInstance: () => createInstance,
  getColor: () => getColor2,
  isColorToken: () => isColorToken,
  isToken: () => isToken
});
function getColor2(token) {
  if (token.type === "color" /* Color */) {
    return createFromRgba(token.value.split(",").map((n) => +n));
  }
  return create4();
}
function createInstance(token) {
  return {
    className: "Pattern" /* Pattern */,
    type: "fit",
    size: [1, 1],
    source: token.uuid
  };
}
function isToken(object) {
  if ("type" in object && "value" in object && "uuid" in object && "name" in object) {
    return true;
  }
  return false;
}
function isColorToken(object) {
  return isToken(object) && object.type === "color" /* Color */;
}

// src/utils/items/ArtboardUtils.ts
function create10(partial = {}) {
  return __spreadValues({
    fills: [FillUtils_exports.createColorFill(ColorUtils_exports.createFromRgba([1, 1, 1, 1]))],
    point: PointUtils_exports.create(0, 0),
    size: SizeUtils_exports.create(1, 1),
    pixelRatio: 1,
    designRatio: 1
  }, partial);
}
function mSetSize(mutable, newSize) {
  mutable.size = newSize;
  return mutable;
}

// src/utils/items/CanvasUtils.ts
var CanvasUtils_exports = {};
__export(CanvasUtils_exports, {
  create: () => create11,
  isCanvas: () => isCanvas,
  mAddArtboard: () => mAddArtboard
});
function create11(partial = {}) {
  return __spreadValues({
    className: "Canvas" /* Canvas */,
    artboard: create10(),
    children: [],
    id: "",
    title: ""
  }, partial);
}
function mAddArtboard(mutable, canvasArtboard) {
  mutable.artboard = canvasArtboard;
  return mutable;
}
function isCanvas(data) {
  return (data == null ? void 0 : data.className) === "Canvas";
}

// src/utils/items/CompoundPathUtils.ts
var CompoundPathUtils_exports = {};
__export(CompoundPathUtils_exports, {
  create: () => create12
});
function create12() {
  throw new Error("Create compound path function");
}

// src/utils/items/FragmentUtils.ts
var FragmentUtils_exports = {};
__export(FragmentUtils_exports, {
  clone: () => clone2,
  create: () => create14,
  mAppendFragments: () => mAppendFragments,
  mAppendItems: () => mAppendItems,
  mApplyGlobalMatrix: () => mApplyGlobalMatrix,
  mDeleteItems: () => mDeleteItems,
  mGroup: () => mGroup,
  mInsertFragmentsAtIndex: () => mInsertFragmentsAtIndex,
  mInsertItemsAtIndex: () => mInsertItemsAtIndex,
  mLocalizeMatrix: () => mLocalizeMatrix,
  mMove: () => mMove,
  mPrependFragments: () => mPrependFragments,
  mPrependItems: () => mPrependItems,
  mUngroup: () => mUngroup,
  slice: () => slice
});
import { cloneDeep as cloneDeep2, intersection as intersection2, noop, remove } from "lodash-es";

// src/state/fragment/selectors.ts
var selectors_exports = {};
__export(selectors_exports, {
  getItemById: () => getItemById,
  getRoot: () => getRoot,
  getRootId: () => getRootId,
  isNotRoot: () => isNotRoot
});
function getRoot(fragment) {
  return fragment.root;
}
function getRootId(fragment) {
  return getRoot(fragment).id;
}
function isNotRoot(fragment, item2) {
  return fragment.root.id !== item2.id;
}
function getItemById(fragment, id) {
  const item2 = fragment.items[id];
  if (item2) {
    return item2;
  }
  const { root } = fragment;
  if (root.className !== "Canvas" /* Canvas */ && root.id === id) {
    return root;
  }
  return null;
}

// src/constants/clientId.ts
import { v4 as uuidv4 } from "uuid";
var CLIENT_ID = uuidv4();
function getClientId() {
  return CLIENT_ID;
}

// src/state/canvas/types.ts
var CanvasActionType = /* @__PURE__ */ ((CanvasActionType2) => {
  CanvasActionType2["DesignSetId"] = "DESIGN_SET_ID";
  CanvasActionType2["DesignImport"] = "DESIGN_IMPORT";
  CanvasActionType2["DesignReset"] = "DESIGN_RESET";
  return CanvasActionType2;
})(CanvasActionType || {});

// src/state/fill/types.ts
var FillActionType = /* @__PURE__ */ ((FillActionType2) => {
  FillActionType2["ToggleFillVisibility"] = "ITEM_TOGGLE_FILL_VISIBILITY";
  FillActionType2["ReplaceFillContent"] = "ITEM_REPLACE_FILL_CONTENT";
  FillActionType2["AddFill"] = "ITEM_ADD_FILL";
  FillActionType2["RemoveFill"] = "ITEM_REMOVE_FILL";
  FillActionType2["SetFillOpacity"] = "ITEM_SET_FILL_OPACITY";
  FillActionType2["SetFillEnabled"] = "ITEM_SET_FILL_ENABLED";
  return FillActionType2;
})(FillActionType || {});

// src/state/history/types.ts
var HistoryActionType = /* @__PURE__ */ ((HistoryActionType2) => {
  HistoryActionType2["HistoryRedo"] = "HISTORY_REDO";
  HistoryActionType2["HistoryUndo"] = "HISTORY_UNDO";
  HistoryActionType2["HistoryClear"] = "HISTORY_CLEAR";
  return HistoryActionType2;
})(HistoryActionType || {});

// src/state/item/types.ts
var ItemActionType = /* @__PURE__ */ ((ItemActionType2) => {
  ItemActionType2["ItemsInsert"] = "ITEMS_INSERT";
  ItemActionType2["ItemTransform"] = "ITEM_TRANSFORM";
  ItemActionType2["ItemSetAspectRatioLock"] = "ITEM_SET_ASPECT_RATIO_LOCK";
  ItemActionType2["ItemSetCachedExtrema"] = "ITEM_SET_CACHED_EXTREMA";
  ItemActionType2["ItemsArrange"] = "ITEMS_ARRANGE";
  ItemActionType2["ItemsDelete"] = "ITEMS_DELETE";
  ItemActionType2["ItemsGroup"] = "ITEMS_GROUP";
  ItemActionType2["ItemUngroup"] = "ITEM_UNGROUP";
  ItemActionType2["ItemSetMatrix"] = "ITEM_SET_MATRIX";
  ItemActionType2["ItemRename"] = "ITEM_RENAME";
  return ItemActionType2;
})(ItemActionType || {});

// src/state/text/types.ts
var TextActionType = /* @__PURE__ */ ((TextActionType2) => {
  TextActionType2["TextSetFontFamily"] = "TEXT_SET_FONT_FAMILY";
  TextActionType2["TextSetFontWeight"] = "TEXT_SET_FONT_WEIGHT";
  TextActionType2["TextSetColor"] = "TEXT_SET_COLOR";
  TextActionType2["TextSetColorOpacity"] = "TEXT_SET_COLOR_OPACITY";
  TextActionType2["TextSetFontSize"] = "TEXT_SET_FONT_SIZE";
  TextActionType2["TextSetLetterSpacing"] = "TEXT_SET_LETTER_SPACING";
  TextActionType2["TextSetAutoLineHeight"] = "TEXT_SET_AUTO_LINE_HEIGHT";
  TextActionType2["TextSetLineHeight"] = "TEXT_SET_LINE_HEIGHT";
  TextActionType2["TextSetSize"] = "TEXT_SET_SIZE";
  TextActionType2["TextSetAlign"] = "TEXT_SET_ALIGN";
  TextActionType2["TextSetSizing"] = "TEXT_SET_SIZING";
  TextActionType2["TextSetDecoration"] = "TEXT_SET_DECORATION";
  TextActionType2["TextSetBlocksContent"] = "TEXT_SET_BLOCKS_CONTENT";
  TextActionType2["TextSetFontItalic"] = "TEXT_SET_FONT_ITALIC_ACTION";
  return TextActionType2;
})(TextActionType || {});

// src/state/token/types.ts
var TokenActionType = /* @__PURE__ */ ((TokenActionType2) => {
  TokenActionType2["TokenReplaceColor"] = "TOKEN_REPLACE_COLOR";
  TokenActionType2["TokensImport"] = "TOKENS_IMPORT";
  return TokenActionType2;
})(TokenActionType || {});

// src/state/stroke/types.ts
var StrokeActionType = /* @__PURE__ */ ((StrokeActionType2) => {
  StrokeActionType2["SetStrokeEnabled"] = "ITEM_SET_STROKE_ENABLED";
  StrokeActionType2["AddStroke"] = "ITEM_ADD_STROKE";
  StrokeActionType2["SetStrokeWidth"] = "ITEM_SET_STROKE_WIDTH";
  StrokeActionType2["SetStrokeOpacity"] = "ITEM_SET_STROKE_OPACITY";
  StrokeActionType2["SetStrokePosition"] = "ITEM_SET_STROKE_POSITION";
  StrokeActionType2["SetStrokeColor"] = "ITEM_SET_STROKE_COLOR";
  StrokeActionType2["RemoveStroke"] = "ITEM_REMOVE_STROKE";
  return StrokeActionType2;
})(StrokeActionType || {});

// src/state/radius/types.ts
var RadiusActionType = /* @__PURE__ */ ((RadiusActionType2) => {
  RadiusActionType2["ChangeRadius"] = "ITEMS_CHANGE_RADIUS";
  return RadiusActionType2;
})(RadiusActionType || {});

// src/state/types.ts
var ActionMetaKey = /* @__PURE__ */ ((ActionMetaKey2) => {
  ActionMetaKey2["DontUndo"] = "dontUndo";
  ActionMetaKey2["DontPersist"] = "dontPersist";
  ActionMetaKey2["GroupName"] = "groupName";
  ActionMetaKey2["ClientId"] = "clientId";
  return ActionMetaKey2;
})(ActionMetaKey || {});

// src/state/utils/actionUtils.ts
var actionUtils_exports = {};
__export(actionUtils_exports, {
  getMeta: () => getMeta,
  getMetaValue: () => getMetaValue,
  setMeta: () => setMeta,
  setMetaValue: () => setMetaValue
});
import update2 from "immutability-helper";
import { has as has2 } from "lodash-es";
function getMeta(action) {
  return action && action.meta || {};
}
function getMetaValue(action, key, fallback) {
  const meta = getMeta(action);
  return has2(meta, key) ? meta[key] : fallback;
}
function setMeta(action, meta) {
  return update2(action, {
    meta: (currentMeta) => update2(currentMeta || {}, {
      $merge: meta
    })
  });
}
function setMetaValue(action, key, value) {
  return setMeta(action, {
    [key]: value
  });
}

// src/state/utils/createAction.ts
function createAction(action) {
  if (getMetaValue(action, "clientId" /* ClientId */))
    return action;
  return setMetaValue(action, "clientId" /* ClientId */, getClientId());
}

// src/state/item/actions.ts
var insertItems = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEMS_INSERT" /* ItemsInsert */
  });
};
var deleteItems = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEMS_DELETE" /* ItemsDelete */
  });
};
var transformItem = (args, meta) => {
  return createAction({
    meta,
    payload: __spreadValues({
      ignoreAncestorMatrix: false
    }, args),
    type: "ITEM_TRANSFORM" /* ItemTransform */
  });
};
var renameItem = (args, meta) => {
  return createAction({
    meta,
    type: "ITEM_RENAME" /* ItemRename */,
    payload: args
  });
};
var setItemMatrix = (args, meta) => {
  return createAction({
    meta,
    payload: __spreadValues({}, args),
    type: "ITEM_SET_MATRIX" /* ItemSetMatrix */
  });
};
var setAspectRatioLock = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEM_SET_ASPECT_RATIO_LOCK" /* ItemSetAspectRatioLock */
  });
};
var setCachedExtrema = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEM_SET_CACHED_EXTREMA" /* ItemSetCachedExtrema */
  });
};
var insertItem = (args, meta) => {
  const { index, item: item2, parentId } = args;
  return insertItems({ index, items: [item2], parentId }, meta);
};
var translateItem = (args, meta) => {
  return transformItem({
    id: args.id,
    ignoreAncestorMatrix: args.ignoreAncestorMatrix,
    matrix: MatrixUtils_exports.translate(MatrixUtils_exports.create(), args.offset)
  }, meta);
};
var scaleItem = (args, meta) => {
  const { center, id, scale: scale3 } = args;
  const mat = MatrixUtils_exports.scale(MatrixUtils_exports.create(), scale3, center);
  return transformItem({ id, matrix: mat }, meta);
};
var arrangeItems = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEMS_ARRANGE" /* ItemsArrange */
  });
};
var groupItems = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEMS_GROUP" /* ItemsGroup */
  });
};
var ungroupItem = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEM_UNGROUP" /* ItemUngroup */
  });
};

// src/state/item/selectors.ts
var selectors_exports2 = {};
__export(selectors_exports2, {
  getAncestorIds: () => getAncestorIds,
  getAncestorMatrix: () => getAncestorMatrix,
  getAncestors: () => getAncestors,
  getBaseBounds: () => getBaseBounds,
  getBounds: () => getBounds,
  getChildren: () => getChildren,
  getCommonAncestorIds: () => getCommonAncestorIds,
  getDenormalizedItemById: () => getDenormalizedItemById,
  getEntities: () => getEntities,
  getExternalItemIds: () => getExternalItemIds,
  getExternalItems: () => getExternalItems,
  getExtrema: () => getExtrema,
  getGlobalMatrix: () => getGlobalMatrix,
  getItemFills: () => getItemFills,
  getItemIndex: () => getItemIndex,
  getItemPosition: () => getItemPosition,
  getItemRotation: () => getItemRotation,
  getItemStrokes: () => getItemStrokes,
  getItems: () => getItems,
  getItemsById: () => getItemsById,
  getLineRotation: () => getLineRotation,
  getLineWidth: () => getLineWidth,
  getParent: () => getParent,
  getSiblingIds: () => getSiblingIds,
  getSiblings: () => getSiblings,
  getUnitedBounds: () => getUnitedBounds,
  isDescendantOfId: () => isDescendantOfId,
  sortItemsLowestToHighest: () => sortItemsLowestToHighest,
  walk: () => walk
});
import { Bezier } from "bezier-js";
import { intersection } from "lodash-es";

// src/common/serializer/index.ts
var serializer_exports = {};
__export(serializer_exports, {
  denormalizeCanvas: () => denormalizeCanvas,
  denormalizeItem: () => denormalizeItem,
  denormalizeItems: () => denormalizeItems,
  normalizeCanvas: () => normalizeCanvas,
  normalizeItems: () => normalizeItems
});
import { denormalize, normalize } from "normalizr";

// src/common/serializer/schema.ts
import { schema } from "normalizr";
import { v4 as uuidv42 } from "uuid";
var item = new schema.Entity("items", {}, {
  processStrategy: (entity, parent) => {
    Object.assign(entity, {
      id: entity.id || uuidv42(),
      parentId: parent.id && parent.className !== "Canvas" ? parent.id : null
    });
    return __spreadValues({}, entity);
  },
  idAttribute: "id"
});
item.define({
  children: [item]
});
var itemArray = [item];
var design = new schema.Object({
  children: itemArray
});

// src/common/serializer/index.ts
function normalizeItems(data) {
  const { result, entities } = normalize(data, itemArray);
  return { result, items: entities.items };
}
function normalizeCanvas(data) {
  const { result, entities } = normalize(data, design);
  return { root: result, items: entities.items || {}, tokens: {}, data: {} };
}
function denormalizeItem(normalizedItem, entities) {
  const denormalizedData = denormalize(normalizedItem, item, entities);
  walkDenormalized(denormalizedData, mRemoveUndefinedChildren);
  return denormalizedData;
}
function denormalizeItems(normalizedItems, entities) {
  const denormalizedData = denormalize(normalizedItems, itemArray, entities);
  denormalizedData.forEach((denormalizedItem) => walkDenormalized(denormalizedItem, mRemoveUndefinedChildren));
  return denormalizedData;
}
function denormalizeCanvas(d) {
  const denormalizedData = denormalize(d.root, design, d);
  walkDenormalized(denormalizedData, mRemoveUndefinedChildren);
  return denormalizedData;
}
function walkDenormalized(item2, callback) {
  callback(item2);
  if (item2.children) {
    item2.children.forEach(callback);
  }
}
function mRemoveUndefinedChildren(item2) {
  if (!item2 || !item2.children)
    return;
  item2.children = item2.children.filter((child) => child !== void 0);
}

// src/common/mapFilterNullish.ts
function mapFilterNullish(arrOrSet, fn) {
  const arr = arrOrSet instanceof Set ? [...arrOrSet] : arrOrSet;
  return arr.reduce((acc, item2, i) => {
    const result = fn(item2, i, arr);
    if (result !== null && result !== void 0) {
      acc.push(result);
    }
    return acc;
  }, []);
}

// src/common/uuid.ts
import { v4 } from "uuid";

// src/state/item/selectors.ts
function getEntities(fragment) {
  return {
    items: getItems(fragment)
  };
}
function getItems(fragment) {
  return fragment.items;
}
function getItemIndex(fragment, id) {
  const parent = getParent(fragment, id);
  if (!parent)
    return null;
  const itemIndex = parent.children.indexOf(id);
  return itemIndex === -1 ? null : itemIndex;
}
function getParent(fragment, id) {
  const item2 = getItemById(fragment, id);
  if (item2 === null)
    return null;
  return item2.parentId ? getItemById(fragment, item2.parentId) : fragment.root;
}
function getChildren(fragment, id) {
  const item2 = id ? getItemById(fragment, id) : getRoot(fragment);
  if (item2 === null || !ItemUtils_exports.isParent(item2))
    return [];
  return mapFilterNullish(item2.children, (childId) => getItemById(fragment, childId));
}
function getAncestors(fragment, id) {
  const ancestors = [];
  let parent = getParent(fragment, id);
  while (parent !== null && isNotRoot(fragment, parent)) {
    ancestors.push(parent);
    parent = getParent(fragment, parent.id);
  }
  if (parent && !CanvasUtils_exports.isCanvas(parent)) {
    ancestors.push(parent);
  }
  return ancestors;
}
function sortItemsLowestToHighest(fragment, itemIds) {
  const itemIdsSet = new Set(itemIds);
  const sortedItems = [];
  for (const [item2] of walk(fragment, void 0, { inclusive: true })) {
    if (itemIdsSet.has(item2.id)) {
      sortedItems.push(item2.id);
    }
  }
  return sortedItems;
}
function getCommonAncestorIds(fragment, itemIds) {
  const itemAncestorIds = itemIds.map((itemId) => getAncestorIds(fragment, itemId));
  if (itemAncestorIds.length === 1) {
    return itemAncestorIds[0];
  }
  if (itemAncestorIds.every((l) => l.length === 0)) {
    return [];
  }
  return intersection(...itemAncestorIds);
}
function getExternalItems(fragment) {
  return Object.values(fragment.items).filter((item2) => !ItemUtils_exports.isParent(item2) || item2.children.length === 0);
}
function* walk(fragment, id, { inclusive = false } = {}, ctx = {
  depth: 0
}) {
  if (inclusive && id) {
    const root = id ? getItemById(fragment, id) : getRoot(fragment);
    if (root && ItemUtils_exports.isNotOfType(root, "Canvas" /* Canvas */))
      yield [root, ctx];
  }
  const children = getChildren(fragment, id);
  for (const child of children) {
    const delve = (yield [child, ctx]) ?? true;
    if (delve) {
      const childIds = ItemUtils_exports.getChildIds(child);
      if (childIds) {
        yield* walk(fragment, child.id, void 0, {
          depth: ctx.depth + 1
        });
      }
    }
  }
}
function getAncestorIds(fragment, id) {
  return getAncestors(fragment, id).map((item2) => item2.id);
}
function isDescendantOfId(fragment, maybeDescendant, itemId) {
  const ancestors = getAncestorIds(fragment, maybeDescendant);
  return ancestors.includes(itemId);
}
function getExternalItemIds(fragment) {
  return getExternalItems(fragment).map((item2) => item2.id);
}
function getAncestorMatrix(fragment, id) {
  const ancestors = getAncestors(fragment, id);
  const ancestorMatrices = ancestors.map((item2) => item2.itemProps.matrix);
  return ancestorMatrices.reduce((acc, matrix) => MatrixUtils_exports.multiply(matrix, acc), MatrixUtils_exports.create());
}
function getGlobalMatrix(mutable, id) {
  const item2 = getItemById(mutable, id);
  if (!item2)
    return MatrixUtils_exports.create();
  const itemMatrix = ItemUtils_exports.getMatrix(item2);
  const ancestorMatrix = getAncestorMatrix(mutable, id);
  return MatrixUtils_exports.multiply(ancestorMatrix, itemMatrix);
}
function getSiblings(fragment, id) {
  return mapFilterNullish(getSiblingIds(fragment, id), (siblingId) => getItemById(fragment, siblingId));
}
function getSiblingIds(fragment, id) {
  const parent = getParent(fragment, id);
  return (parent == null ? void 0 : parent.children) ?? [];
}
function getItemFills(fragment, id) {
  const item2 = getItemById(fragment, id);
  return item2 ? ItemUtils_exports.getFills(item2) : [];
}
function getItemPosition(fragment, id, global) {
  const bounds = getBounds(fragment, id, global);
  return bounds ? bounds.point : null;
}
function getItemRotation(fragment, id) {
  const item2 = getItemById(fragment, id);
  if (item2 === null)
    return 0;
  const globalMatrix = getGlobalMatrix(fragment, id);
  if (!globalMatrix)
    return 0;
  const itemRotation = MatrixUtils_exports.getRotationAngle(globalMatrix);
  let rotation;
  switch (item2.className) {
    case "Path" /* Path */: {
      rotation = itemRotation - getLineRotation(fragment, id);
      break;
    }
    default: {
      rotation = itemRotation;
    }
  }
  if (rotation < 0) {
    rotation += Math.PI * 2;
  }
  return Math.abs(rotation);
}
function getItemStrokes(fragment, id) {
  const item2 = getItemById(fragment, id);
  return item2 ? ItemUtils_exports.getStrokes(item2) : [];
}
function getItemsById(fragment, idsOrNodes) {
  const items = getItems(fragment);
  return idsOrNodes.map((idOrNode) => typeof idOrNode === "string" ? items[idOrNode] : idOrNode);
}
function getDenormalizedItemById(fragment, id) {
  const normalizedItem = getItemById(fragment, id);
  return serializer_exports.denormalizeItem(normalizedItem, getEntities(fragment));
}
function getBounds(fragment, id, global = false, noCache = false) {
  const item2 = getItemById(fragment, id);
  if (item2 === null)
    return null;
  let bounds = null;
  let matrix;
  if (global) {
    matrix = getGlobalMatrix(fragment, id) ?? void 0;
  }
  if (bounds === null) {
    const extrema = getExtrema(fragment, item2, matrix, noCache);
    bounds = RectangleUtils_exports.containing(extrema);
  }
  return bounds;
}
function getBaseBounds(fragment, item2, matrix) {
  switch (item2.className) {
    case "CompoundPath" /* CompoundPath */:
    case "Group" /* Group */:
      return getGroupBounds(fragment, item2, matrix);
    case "Mask" /* Mask */:
      return getMaskBounds(fragment, item2, matrix);
    case "Path" /* Path */:
      return getPathBounds(fragment, item2, matrix);
    case "Raster" /* Raster */:
    case "Shape" /* Shape */:
      return getSizedBounds(fragment, item2, matrix);
    case "Text" /* Text */:
      return getTextBounds(fragment, item2, matrix);
    default:
      return null;
  }
}
function getUnitedBounds(fragment, itemIds, global = false) {
  const boundsList = mapFilterNullish(itemIds, (id) => getBounds(fragment, id, global));
  if (boundsList.length === 0)
    return null;
  return RectangleUtils_exports.uniteAll(boundsList);
}
function getGroupBounds(fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  if (item2.children.length === 0)
    return null;
  const childrenBounds = getUnitedBounds(fragment, item2.children);
  if (childrenBounds === null) {
    return null;
  }
  return RectangleUtils_exports.transform(childrenBounds, matrix);
}
function getMaskBounds(fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  const bounds = getBounds(fragment, item2.children[0]);
  if (!bounds)
    return null;
  return RectangleUtils_exports.transform(bounds, matrix);
}
function getPathBounds(_fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  if (item2.segments.length === 0)
    return null;
  const { segments } = item2;
  const { min: min2, max: max2 } = segments.reduce((acc, segment, i) => {
    if (segment.length === 2 || i === segments.length - 1) {
      const [x2, y2] = segment;
      return {
        min: PointUtils_exports.min(acc.min, [x2, y2]),
        max: PointUtils_exports.max(acc.max, [x2, y2])
      };
    }
    const [startX, startY, , , cp1X, cp1Y] = segment;
    const [endX, endY, cp2X = 0, cp2Y = 0] = segments[i + 1];
    const bezier = new Bezier(startX, startY, startX + cp1X, startY + cp1Y, endX + cp2X, endY + cp2Y, endX, endY);
    const { x, y } = bezier.bbox();
    return {
      min: PointUtils_exports.min(acc.min, [x.min, y.min]),
      max: PointUtils_exports.max(acc.max, [x.max, y.max])
    };
  }, {
    min: [Infinity, Infinity],
    max: [-Infinity, -Infinity]
  });
  const rectangle = RectangleUtils_exports.create(min2, PointUtils_exports.subtract(max2, min2));
  return RectangleUtils_exports.transform(rectangle, matrix);
}
function getTextBounds(_fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  const { size, sizing } = item2;
  const rectangle = RectangleUtils_exports.create([0, 0], size);
  const transformedSize = RectangleUtils_exports.transform(rectangle, matrix);
  if (sizing[0] === "auto" /* Auto */) {
    transformedSize.size[0] = size[0];
  }
  if (sizing[1] === "auto" /* Auto */) {
    transformedSize.size[1] = size[1];
  }
  return transformedSize;
}
function getSizedBounds(_fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  const { size } = item2;
  const rectangle = RectangleUtils_exports.create([0, 0], size);
  return RectangleUtils_exports.transform(rectangle, matrix);
}
function getLineWidth(fragment, id, global) {
  const [start, end] = getTransformedLineSegments(fragment, id, global);
  return PointUtils_exports.distance(start, end);
}
function getLineRotation(fragment, id) {
  const line = getItemById(fragment, id);
  if (!line || !PathUtils_exports.isLine(line))
    return 0;
  const [start, end] = line.segments;
  return PathUtils_exports.getLineRotation(start, end);
}
function getTransformedLineSegments(fragment, id, global) {
  const line = getItemById(fragment, id);
  if (!line || !PathUtils_exports.isLine(line))
    return [];
  const matrix = global ? getGlobalMatrix(fragment, id) : line.itemProps.matrix;
  if (!matrix) {
    return [];
  }
  return line.segments.map((point) => PointUtils_exports.transform(point, matrix));
}
function getExtrema(fragment, item2, matrix = ItemUtils_exports.getMatrix(item2), noCache = false) {
  if (!noCache) {
    const cachedExtrema = ItemUtils_exports.getCachedExtrema(item2);
    if (cachedExtrema.length > 0) {
      return matrix ? cachedExtrema.map((point) => PointUtils_exports.transform(point, matrix)) : cachedExtrema;
    }
  }
  if (ItemUtils_exports.isRectangle(item2)) {
    return getRectangleExtrema(item2, matrix);
  }
  if (ItemUtils_exports.isOfType(item2, "Group" /* Group */)) {
    return getGroupExtrema(fragment, item2, matrix);
  }
  const bounds = getBaseBounds(fragment, item2, matrix);
  if (bounds === null)
    return [];
  return RectangleUtils_exports.getCorners(bounds);
}
function getGroupExtrema(fragment, item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  const children = getChildren(fragment, item2.id);
  if (!children.length)
    return [];
  const extrema = children.flatMap((child) => getExtrema(fragment, child)).map((point) => PointUtils_exports.transform(point, matrix));
  if (children.length <= 1)
    return extrema;
  return RectangleUtils_exports.getCorners(RectangleUtils_exports.containing(extrema));
}
function getRectangleExtrema(item2, matrix = ItemUtils_exports.getMatrix(item2)) {
  return RectangleUtils_exports.getCorners({ point: [0, 0], size: item2.size }).map((point) => PointUtils_exports.transform(point, matrix));
}

// src/state/utils/extremaCache.ts
function updateExtremaCache(fragment, ids) {
  const itemsByDepth = [];
  function enqueueItemById(id, depth) {
    const item2 = getItemById(fragment, id);
    if (item2 === null)
      return false;
    if (itemsByDepth[depth] === void 0) {
      itemsByDepth[depth] = /* @__PURE__ */ new Set([item2]);
      return true;
    }
    if (itemsByDepth[depth].has(item2))
      return false;
    itemsByDepth[depth].add(item2);
    return true;
  }
  ids.forEach((id) => {
    const ancestorIds = getAncestorIds(fragment, id);
    const depth = ancestorIds.length;
    const added = enqueueItemById(id, depth);
    if (!added)
      return;
    for (let i = 0; i < ancestorIds.length; i++) {
      const ancestorDepth = depth - i - 1;
      const ancestorAdded = enqueueItemById(ancestorIds[i], ancestorDepth);
      if (!ancestorAdded)
        return;
    }
  });
  while (itemsByDepth.length) {
    const items = itemsByDepth.pop();
    items.forEach((item2) => {
      ItemUtils_exports.mSetCachedExtrema(item2, getExtrema(fragment, item2, MatrixUtils_exports.create(), true));
    });
  }
}
function repairExtremaCache(fragment) {
  const idsMissingExtrema = [];
  for (const [item2] of walk(fragment)) {
    if (ItemUtils_exports.getCachedExtrema(item2).length === 0) {
      idsMissingExtrema.push(item2.id);
    }
  }
  if (idsMissingExtrema.length) {
    updateExtremaCache(fragment, idsMissingExtrema);
  }
}

// src/utils/items/GroupUtils.ts
var GroupUtils_exports = {};
__export(GroupUtils_exports, {
  create: () => create13
});
import { merge } from "lodash-es";
import { v4 as uuidv43 } from "uuid";

// src/utils/items/ItemUtils.ts
var ItemUtils_exports = {};
__export(ItemUtils_exports, {
  clone: () => clone,
  createItemProps: () => createItemProps,
  filterByType: () => filterByType,
  getCachedExtrema: () => getCachedExtrema,
  getChildIds: () => getChildIds,
  getClassName: () => getClassName,
  getClientData: () => getClientData,
  getCustomClientData: () => getCustomClientData,
  getData: () => getData,
  getFills: () => getFills,
  getId: () => getId,
  getMatrix: () => getMatrix,
  getName: () => getName,
  getOpacity: () => getOpacity4,
  getRadius: () => getRadius,
  getShapeType: () => getShapeType,
  getStrokes: () => getStrokes,
  getUploadStatus: () => getUploadStatus,
  hasBorderRadiusSupport: () => hasBorderRadiusSupport,
  isAspectRatioLocked: () => isAspectRatioLocked,
  isEllipse: () => isEllipse,
  isFillable: () => isFillable,
  isLocked: () => isLocked,
  isNotOfType: () => isNotOfType,
  isOfType: () => isOfType,
  isParent: () => isParent,
  isRectangle: () => isRectangle,
  isStrokable: () => isStrokable,
  mAddFills: () => mAddFills,
  mAddStrokes: () => mAddStrokes,
  mClearClientData: () => mClearClientData,
  mClearCustomClientData: () => mClearCustomClientData,
  mClearFills: () => mClearFills,
  mClearStrokes: () => mClearStrokes,
  mSetAspectRatioLocked: () => mSetAspectRatioLocked,
  mSetAssetUploadStatus: () => mSetAssetUploadStatus,
  mSetCachedExtrema: () => mSetCachedExtrema,
  mSetClientData: () => mSetClientData,
  mSetCustomClientData: () => mSetCustomClientData,
  mSetId: () => mSetId,
  mSetMatrix: () => mSetMatrix,
  mSetName: () => mSetName,
  mSetOpacity: () => mSetOpacity,
  mSetStrokeStyle: () => mSetStrokeStyle,
  mTransform: () => mTransform,
  mTranslate: () => mTranslate
});
import { clamp, cloneDeep, has as has3 } from "lodash-es";

// src/constants/dataKey.ts
var DATA_KEY = "MARVEL_DESIGN_CREATOR";

// src/utils/items/ItemUtils.ts
var createItemProps = (partial = {}) => {
  return __spreadValues({
    applyMatrix: false,
    assets: [],
    blendMode: "normal" /* Normal */,
    blur: 0,
    data: {},
    flipX: false,
    flipY: false,
    isExportable: false,
    locked: false,
    matrix: MatrixUtils_exports.create(),
    name: "",
    opacity: 1
  }, partial);
};
function getChildIds(item2) {
  return item2.children;
}
function getMatrix(item2) {
  return item2.itemProps.matrix;
}
function isAspectRatioLocked(item2) {
  return !!getClientData(item2).isAspectRatioLocked;
}
function getRadius(item2) {
  if (hasBorderRadiusSupport(item2)) {
    return item2.radius;
  }
  return null;
}
function getName(item2) {
  return item2.itemProps.name;
}
function getId(item2) {
  return item2.id;
}
function isLocked(item2) {
  return item2.itemProps.locked;
}
function getClassName(item2) {
  return item2.className;
}
function getFills(item2) {
  return isFillable(item2) ? item2.fillStyle.fills : [];
}
function getStrokes(item2) {
  return isStrokable(item2) ? item2.strokes : [];
}
function getShapeType(item2) {
  return item2.type;
}
function getOpacity4(item2) {
  return item2.itemProps.opacity;
}
function getCachedExtrema(item2) {
  var _a;
  return ((_a = getClientData(item2)) == null ? void 0 : _a.extrema) ?? [];
}
function mSetCustomClientData(item2, namespace, key, value) {
  const data = getData(item2);
  if (!has3(data, namespace)) {
    data[namespace] = {};
  }
  data[namespace][key] = value;
  return item2;
}
function mSetClientData(item2, key, value) {
  return mSetCustomClientData(item2, DATA_KEY, key, value);
}
function mClearCustomClientData(item2, namespace, key) {
  const data = getData(item2);
  if (!has3(data, namespace)) {
    return item2;
  }
  delete data[namespace][key];
  return item2;
}
function mClearClientData(item2, key) {
  return mClearCustomClientData(item2, DATA_KEY, key);
}
function mSetCachedExtrema(item2, extrema) {
  return mSetClientData(item2, "extrema", extrema);
}
function mSetId(item2, id) {
  item2.id = id;
  return item2;
}
function mSetName(item2, name) {
  item2.itemProps.name = name;
  return item2;
}
function mAddFills(item2, fills) {
  item2.fillStyle.fills.push(...fills);
  return item2;
}
function mClearFills(item2) {
  item2.fillStyle.fills = [];
  return item2;
}
function mAddStrokes(mutable, strokes) {
  mutable.strokes.push(...strokes);
  return mutable;
}
function mClearStrokes(mutable) {
  mutable.strokes = [];
  return mutable;
}
function mSetStrokeStyle(mutable, strokeStyle) {
  mutable.strokeStyle = strokeStyle;
  return mutable;
}
function mTranslate(mutable, point) {
  MatrixUtils_exports.translate(mutable.itemProps.matrix, point, mutable.itemProps.matrix);
  return mutable;
}
function mSetMatrix(mutable, matrix) {
  mutable.itemProps.matrix = matrix;
  return mutable;
}
function mTransform(mutable, matrix) {
  const newMatrix = MatrixUtils_exports.multiply(matrix, getMatrix(mutable));
  mutable.itemProps.matrix = newMatrix;
  return mutable;
}
function mSetOpacity(mutable, opacity) {
  mutable.itemProps.opacity = clamp(opacity, 0, 1);
  return mutable;
}
function getUploadStatus(item2) {
  const uploaded = getClientData(item2).uploaded || {};
  if (typeof uploaded === "boolean") {
    if (isOfType(item2, "Raster" /* Raster */)) {
      return { [item2.source]: uploaded };
    }
    return {};
  }
  return uploaded;
}
function mSetAssetUploadStatus(item2, url, status) {
  const uploadingMap = getUploadStatus(item2);
  mSetClientData(item2, "uploaded", __spreadProps(__spreadValues({}, uploadingMap), {
    [url]: status === "uploaded" /* Uploaded */
  }));
  return item2;
}
function mSetAspectRatioLocked(item2, aspectRatioLocked) {
  mSetClientData(item2, "isAspectRatioLocked", aspectRatioLocked);
  return item2;
}
function isItem(obj) {
  if (Object.hasOwnProperty.call(obj, "itemProps")) {
    return true;
  }
  return false;
}
function isParent(item2) {
  return [
    "Group" /* Group */,
    "Mask" /* Mask */,
    "CompoundPath" /* CompoundPath */,
    "Canvas" /* Canvas */
  ].includes(item2.className);
}
function isFillable(item2) {
  return [
    "Group" /* Group */,
    "Mask" /* Mask */,
    "Raster" /* Raster */,
    "Shape" /* Shape */,
    "Path" /* Path */,
    "CompoundPath" /* CompoundPath */
  ].includes(item2.className);
}
function isStrokable(item2) {
  return [
    "Group" /* Group */,
    "Mask" /* Mask */,
    "Raster" /* Raster */,
    "Shape" /* Shape */,
    "Path" /* Path */,
    "CompoundPath" /* CompoundPath */
  ].includes(item2.className);
}
function hasBorderRadiusSupport(item2) {
  const isImage = isOfType(item2, "Raster" /* Raster */);
  return isImage || isRectangle(item2);
}
function isRectangle(item2) {
  return isOfType(item2, "Shape" /* Shape */) && item2.type === "rectangle" /* Rectangle */;
}
function isEllipse(item2) {
  return isOfType(item2, "Shape" /* Shape */) && item2.type === "ellipse" /* Ellipse */;
}
function isOfType(item2, type) {
  return item2.className === ItemClass[type];
}
function isNotOfType(item2, type) {
  return item2.className !== ItemClass[type];
}
function filterByType(items, ...itemClasses) {
  return items.filter((item2) => itemClasses.some((itemClass) => isOfType(item2, itemClass)));
}
function clone(item2) {
  const newItem = cloneDeep(item2);
  newItem.id = v4();
  return newItem;
}
function getData(obj) {
  if (isItem(obj)) {
    return obj.itemProps.data;
  }
  return obj.data;
}
function getCustomClientData(obj, namespace) {
  return getData(obj)[namespace] ?? {};
}
function getClientData(obj) {
  return getCustomClientData(obj, DATA_KEY);
}

// src/utils/items/GroupUtils.ts
function create13(partial = {}) {
  const groupDefaults = {
    id: uuidv43(),
    parentId: null,
    className: "Group" /* Group */,
    fillStyle: FillUtils_exports.createFillStyle(),
    strokeStyle: StrokeUtils_exports.createStrokeStyle(),
    strokes: [],
    itemProps: createItemProps(),
    children: [],
    shadows: []
  };
  return merge(groupDefaults, partial);
}

// src/utils/items/FragmentUtils.ts
function create14(root) {
  return {
    root,
    items: {}
  };
}
function mInsertFragmentsAtIndex(mutable, childFragments, index, id) {
  assignFragmentsToFragment(mutable, childFragments, index, id);
  return mutable;
}
function mAppendFragments(mutable, childFragments, id) {
  assignFragmentsToFragment(mutable, childFragments, "end", id);
  return mutable;
}
function mPrependFragments(mutable, childFragments, id) {
  assignFragmentsToFragment(mutable, childFragments, "start", id);
  return mutable;
}
function mAssignItemsToFragment(mutable, childItems, position, id) {
  const parent = id === void 0 ? getRoot(mutable) : getItemById(mutable, id);
  if (parent === null || !isParent(parent))
    return;
  const ids = childItems.map((child) => child.id);
  switch (position) {
    case "start":
      parent.children.unshift(...ids);
      break;
    case "end":
      parent.children.push(...ids);
      break;
    default:
      parent.children.splice(position, 0, ...ids);
      break;
  }
  const parentId = parent.className === "Canvas" /* Canvas */ ? null : parent.id;
  childItems.forEach((child) => {
    mutable.items[child.id] = __spreadProps(__spreadValues({}, child), {
      parentId
    });
  });
}
function mDeleteItems(mutable, ids, onBeforeDelete) {
  ids.forEach((id) => {
    mDeleteItem(mutable, id, onBeforeDelete);
  });
  return mutable;
}
function mDeleteItem(mutable, itemId, onBeforeDelete = noop) {
  const itemsQueue = [itemId];
  const idsToRemove = [];
  while (itemsQueue.length) {
    const currentId = itemsQueue.pop();
    const parent = getParent(mutable, currentId);
    if (parent) {
      if (isNotRoot(mutable, parent) && parent.children.length === 1) {
        itemsQueue.push(parent.id);
      } else {
        parent.children = parent.children.filter((id) => id !== currentId);
      }
    }
    for (const [descendant] of walk(mutable, currentId)) {
      onBeforeDelete(descendant.id);
      idsToRemove.push(descendant.id);
    }
    onBeforeDelete(currentId);
    idsToRemove.push(currentId);
  }
  idsToRemove.forEach((id) => {
    delete mutable.items[id];
  });
  return mutable;
}
function assignFragmentsToFragment(mutable, childFragments, position, id) {
  const parent = id === void 0 ? getRoot(mutable) : getItemById(mutable, id);
  if (parent === null || !isParent(parent))
    return;
  const ids = childFragments.map((fragment) => fragment.root.id);
  switch (position) {
    case "start":
      parent.children.unshift(...ids);
      break;
    case "end":
      parent.children.push(...ids);
      break;
    default:
      parent.children.splice(position, 0, ...ids);
      break;
  }
  const parentId = parent.className === "Canvas" /* Canvas */ ? null : parent.id;
  const itemMaps = childFragments.map((fragment) => __spreadProps(__spreadValues({}, fragment.items), {
    [fragment.root.id]: __spreadProps(__spreadValues({}, fragment.root), {
      parentId
    })
  }));
  Object.assign(mutable.items, ...itemMaps);
}
function mAppendItems(mutable, childItems, id) {
  mAssignItemsToFragment(mutable, childItems, "end", id);
  return mutable;
}
function mPrependItems(mutable, childItems, id) {
  mAssignItemsToFragment(mutable, childItems, "start", id);
  return mutable;
}
function mInsertItemsAtIndex(mutable, childItems, idx, id) {
  mAssignItemsToFragment(mutable, childItems, idx, id);
  return mutable;
}
function slice(fragment, id) {
  const item2 = getItemById(fragment, id);
  if (item2 === null)
    return null;
  const currentMatrix = getMatrix(item2);
  const ancestorMatrix = getAncestorMatrix(fragment, item2.id);
  const newMatrix = MatrixUtils_exports.multiply(ancestorMatrix, currentMatrix);
  const newItem = cloneDeep2(item2);
  mSetMatrix(newItem, newMatrix);
  const fragmentSlice = create14(newItem);
  for (const [descendant] of walk(fragment, id)) {
    fragmentSlice.items[descendant.id] = descendant;
  }
  return fragmentSlice;
}
function clone2(fragment) {
  const newRoot = clone(fragment.root);
  const newFragment = create14(newRoot);
  const newIds = {
    [fragment.root.id]: newRoot.id
  };
  const newItems = [newRoot];
  for (const [item2] of walk(fragment)) {
    const newItem = clone(item2);
    newIds[item2.id] = newItem.id;
    if (newItem.parentId) {
      newItem.parentId = newIds[newItem.parentId];
    }
    newItems.push(newItem);
    newFragment.items[newItem.id] = newItem;
  }
  for (const newItem of newItems) {
    if (isParent(newItem)) {
      newItem.children = newItem.children.map((oldId) => newIds[oldId]);
    }
  }
  return newFragment;
}
function mMove(mutable, itemIds, targetId, direction) {
  const targetAncestors = getAncestorIds(mutable, targetId);
  if (intersection2(targetAncestors, itemIds).length) {
    return mutable;
  }
  const sortedIds = sortItemsLowestToHighest(mutable, itemIds);
  const insertionParent = getParent(mutable, targetId);
  if (!insertionParent)
    return mutable;
  const targetIndex = insertionParent.children.indexOf(targetId);
  const splitIndex = direction === "in-front" ? targetIndex + 1 : targetIndex;
  const { children } = insertionParent;
  const itemSet = new Set(itemIds);
  const [left, right] = [
    children.slice(0, splitIndex).filter((c) => !itemSet.has(c)),
    children.slice(splitIndex).filter((c) => !itemSet.has(c))
  ];
  const changedFrameIds = /* @__PURE__ */ new Set();
  itemIds.forEach((itemId) => {
    const item2 = getItemById(mutable, itemId);
    if (!item2)
      return;
    const oldParent = getParent(mutable, itemId);
    const oldParentId = oldParent && isNotRoot(mutable, oldParent) ? item2.parentId : null;
    const newParentId = isNotRoot(mutable, insertionParent) ? insertionParent.id : null;
    if (item2 && oldParent && newParentId !== oldParentId) {
      remove(oldParent.children, (id) => id === itemId);
      changedFrameIds.add(itemId);
      if (oldParentId) {
        changedFrameIds.add(oldParentId);
      }
      if (newParentId !== null) {
        mLocalizeMatrix(mutable, itemId, newParentId);
      } else if (oldParentId) {
        mApplyGlobalMatrix(mutable, itemId, { idOfTransform: oldParentId });
      }
      if (!oldParent.children.length && oldParentId !== null) {
        mDeleteItem(mutable, oldParentId);
      }
      item2.parentId = newParentId;
    }
  });
  insertionParent.children = [...left, ...sortedIds, ...right];
  updateExtremaCache(mutable, Array.from(changedFrameIds));
  return mutable;
}
function mGroup(mutable, groupId, itemIds) {
  const sortedIds = sortItemsLowestToHighest(mutable, itemIds);
  const group = create13({ id: groupId });
  group.children = sortedIds;
  const highestItemId = sortedIds[sortedIds.length - 1];
  const targetIndex = getItemIndex(mutable, highestItemId);
  const insertionIndex = targetIndex !== null ? targetIndex : "end";
  const parent = getParent(mutable, highestItemId);
  const parentId = (parent == null ? void 0 : parent.className) !== "Canvas" /* Canvas */ ? parent == null ? void 0 : parent.id : void 0;
  mAssignItemsToFragment(mutable, [group], insertionIndex, parentId);
  const changedFrameIds = /* @__PURE__ */ new Set();
  changedFrameIds.add(groupId);
  sortedIds.forEach((itemId) => {
    const item2 = getItemById(mutable, itemId);
    const oldParent = getParent(mutable, itemId);
    if (!item2)
      return;
    mLocalizeMatrix(mutable, itemId, group.id);
    item2.parentId = group.id;
    if (oldParent) {
      const itemIndex = oldParent.children.indexOf(itemId);
      if (itemIndex !== -1) {
        oldParent.children.splice(itemIndex, 1);
      }
      changedFrameIds.add(oldParent.id);
    }
    if (oldParent !== null) {
      oldParent.children = oldParent.children.filter((id) => id !== itemId);
      if (oldParent.children.length === 0) {
        mDeleteItem(mutable, oldParent.id);
      }
    }
  });
  updateExtremaCache(mutable, Array.from(changedFrameIds));
  return mutable;
}
function mUngroup(mutable, group) {
  const { children, parentId } = group;
  const groupIndex = getItemIndex(mutable, group.id);
  if (groupIndex === null)
    return mutable;
  const groupMatrix = getMatrix(group);
  children.forEach((childId) => {
    const child = mutable.items[childId];
    mTransform(child, groupMatrix);
    child.parentId = parentId;
  });
  const parent = getParent(mutable, group.id);
  if (parent === null) {
    mutable.root.children.splice(groupIndex, 1, ...children);
  } else {
    parent.children.splice(groupIndex, 1, ...children);
  }
  delete mutable.items[group.id];
  return mutable;
}
function mApplyGlobalMatrix(mutable, id, { idOfTransform = id, inverse = false } = {}) {
  const item2 = getItemById(mutable, id);
  const globalMatrix = getGlobalMatrix(mutable, idOfTransform);
  if (!item2 || !globalMatrix)
    return null;
  const matrixToApply = inverse ? MatrixUtils_exports.invert(globalMatrix) : globalMatrix;
  if (idOfTransform === id) {
    mSetMatrix(item2, matrixToApply);
  } else {
    const itemMatrix = getMatrix(item2);
    mSetMatrix(item2, MatrixUtils_exports.multiply(matrixToApply, itemMatrix));
  }
  return mutable;
}
function mLocalizeMatrix(mutable, id, newParentId) {
  mApplyGlobalMatrix(mutable, id);
  mApplyGlobalMatrix(mutable, id, {
    idOfTransform: newParentId,
    inverse: true
  });
  return mutable;
}

// src/utils/items/MaskUtils.ts
var MaskUtils_exports = {};
__export(MaskUtils_exports, {
  create: () => create15
});
function create15() {
  throw new Error("TODO: Mask create function");
}

// src/utils/items/PathUtils.ts
var PathUtils_exports = {};
__export(PathUtils_exports, {
  create: () => create16,
  createLine: () => createLine,
  createPath: () => createPath,
  createPolygon: () => createPolygon,
  createStar: () => createStar,
  getEndDecoration: () => getEndDecoration,
  getLineRotation: () => getLineRotation2,
  getLineWidth: () => getLineWidth2,
  isDecoratedLine: () => isDecoratedLine,
  isLine: () => isLine,
  mAddSegment: () => mAddSegment,
  mClearDecorations: () => mClearDecorations,
  mSetClosed: () => mSetClosed,
  mSetEndDecoration: () => mSetEndDecoration,
  mSetSegment: () => mSetSegment,
  mSetSegments: () => mSetSegments,
  rotateSegments: () => rotateSegments
});
import { merge as merge2 } from "lodash-es";
import { v4 as uuidv44 } from "uuid";
var END_DECORATION_KEY = "END_DECORATION";
function createPath(partial = {}) {
  return create16(partial);
}
function createLine(start, end, id) {
  return create16({
    id,
    segments: [start, end]
  });
}
function createStar(radius, {
  id,
  innerRatio = 0.382,
  points = 5,
  center = PointUtils_exports.create()
} = {}) {
  const origin = Math.PI;
  const theta = Math.PI / points;
  const segments = [];
  const innerRadius = radius * innerRatio;
  const [cx, cy] = center;
  for (let i = 0; i < points * 2; i++) {
    const isOutside = !(i % 2);
    segments.push(pointOnCircle(isOutside ? radius : innerRadius, origin + theta * i, cx, cy));
  }
  return create16({
    id,
    segments,
    closed: true
  });
}
function createPolygon(radius, { id, points = 3, center = PointUtils_exports.create() } = {}) {
  const origin = Math.PI;
  const theta = Math.PI * 2 / points;
  const segments = [];
  const [cx, cy] = center;
  for (let i = 0; i < points; i++) {
    segments.push(pointOnCircle(radius, origin + theta * i, cx, cy));
  }
  return create16({
    id,
    segments,
    closed: true
  });
}
function create16(partial = {}) {
  const pathDefaults = {
    id: uuidv44(),
    itemProps: createItemProps(),
    parentId: null,
    fillStyle: FillUtils_exports.createFillStyle(),
    strokeStyle: StrokeUtils_exports.createStrokeStyle(),
    strokes: [],
    innerShadows: [],
    shadows: [],
    closed: false,
    className: "Path" /* Path */,
    segments: []
  };
  return merge2(pathDefaults, partial);
}
function mSetClosed(mutable, closed) {
  mutable.closed = closed;
  return mutable;
}
function mSetSegments(mutable, segments) {
  mutable.segments = segments;
  return mutable;
}
function mSetSegment(mutable, index, segment) {
  mutable.segments[index] = segment;
  return mutable;
}
function mAddSegment(mutable, segment) {
  mutable.segments.push(segment);
  return mutable;
}
function getLineWidth2(path) {
  const { matrix } = path.itemProps;
  const [start, end] = path.segments.map((point) => transform(point, matrix));
  return distance(start, end);
}
function isLine(item2) {
  return isOfType(item2, "Path" /* Path */) && item2.segments.length === 2 && item2.segments.every((segment) => segment.length === 2);
}
function rotateSegments(segments, radians) {
  const cx = segments.reduce((sum, [x]) => sum + x, 0) / segments.length;
  const cy = segments.reduce((sum, [, y]) => sum + y, 0) / segments.length;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  return segments.map(([x, y]) => {
    const tx = x - cx;
    const ty = y - cy;
    return [tx * cos + ty * sin + cx, -tx * sin + ty * cos + cy];
  });
}
function getLineRotation2([x1, y1], [x2, y2]) {
  const radians = Math.atan2(y2 - y1, x2 - x1);
  return radians === Math.PI ? radians : -radians;
}
function mSetEndDecoration(mutable, decoration) {
  mSetClientData(mutable, END_DECORATION_KEY, decoration);
  return mutable;
}
function getEndDecoration(path) {
  var _a;
  return ((_a = getClientData(path)) == null ? void 0 : _a[END_DECORATION_KEY]) ?? "none" /* None */;
}
function isDecoratedLine(path) {
  return isLine(path) && getEndDecoration(path) !== "none" /* None */;
}
function mClearDecorations(mutable) {
  mSetClientData(mutable, END_DECORATION_KEY, "none" /* None */);
  return mutable;
}

// src/utils/items/RandomUtils.ts
var RandomUtils_exports = {};
__export(RandomUtils_exports, {
  createRandomItem: () => createRandomItem
});
import { random, sample } from "lodash-es";

// src/utils/items/ShapeUtils.ts
var ShapeUtils_exports = {};
__export(ShapeUtils_exports, {
  createEllipse: () => createEllipse,
  createRectangle: () => createRectangle,
  getType: () => getType,
  mSetCenter: () => mSetCenter,
  mSetRadius: () => mSetRadius,
  mSetSize: () => mSetSize2
});
import { merge as merge3 } from "lodash-es";
import { v4 as uuidv45 } from "uuid";
function create17(partial = {}) {
  const shapeDefaults = {
    id: uuidv45(),
    parentId: null,
    className: "Shape" /* Shape */,
    type: "rectangle" /* Rectangle */,
    fillStyle: FillUtils_exports.createFillStyle(),
    radius: [0, 0, 0, 0],
    shadows: [],
    innerShadows: [],
    size: SizeUtils_exports.create(),
    strokes: [],
    strokeStyle: StrokeUtils_exports.createStrokeStyle(),
    itemProps: createItemProps()
  };
  return merge3(shapeDefaults, partial);
}
function createEllipse(partial = {}) {
  return create17(__spreadValues({ type: "ellipse" /* Ellipse */ }, partial));
}
function createRectangle(partial = {}) {
  return create17(__spreadValues({ type: "rectangle" /* Rectangle */ }, partial));
}
function getType(shape) {
  return shape.type;
}
function mSetCenter(mutable, center) {
  const centerPoint = center || PointUtils_exports.create(0, 0);
  const topLeft = PointUtils_exports.subtract(centerPoint, PointUtils_exports.divide(mutable.size, 2));
  MatrixUtils_exports.translate(mutable.itemProps.matrix, topLeft, mutable.itemProps.matrix);
  return mutable;
}
function mSetRadius(mutable, radius) {
  mutable.radius = radius;
  return mutable;
}
function mSetSize2(mutable, shapeSize) {
  mutable.size = shapeSize;
  if (mutable.type === "ellipse" /* Ellipse */) {
    mutable.radius = [
      shapeSize[0] / 2,
      shapeSize[0] / 2,
      shapeSize[1] / 2,
      shapeSize[1] / 2
    ];
  }
  return mutable;
}

// src/utils/items/TextUtils.ts
var TextUtils_exports = {};
__export(TextUtils_exports, {
  computeTextStylesCss: () => computeTextStylesCss,
  create: () => create18,
  getAlign: () => getAlign,
  getBlock: () => getBlock,
  getColor: () => getColor3,
  getContent: () => getContent2,
  getFontFamily: () => getFontFamily2,
  getFontItalic: () => getFontItalic,
  getFontSize: () => getFontSize,
  getFontWeight: () => getFontWeight,
  getLayoutHash: () => getLayoutHash,
  getLetterSpacing: () => getLetterSpacing,
  getLetterSpacingUnit: () => getLetterSpacingUnit,
  getLineHeight: () => getLineHeight,
  getLineHeightUnit: () => getLineHeightUnit,
  getOpacity: () => getOpacity5,
  getSize: () => getSize,
  getSizing: () => getSizing,
  getStyle: () => getStyle,
  getTextDecoration: () => getTextDecoration,
  isAutoLineHeight: () => isAutoLineHeight,
  isEmpty: () => isEmpty,
  mSetAlign: () => mSetAlign,
  mSetAutoLineHeight: () => mSetAutoLineHeight,
  mSetBlocks: () => mSetBlocks,
  mSetColor: () => mSetColor,
  mSetContent: () => mSetContent,
  mSetDecoration: () => mSetDecoration,
  mSetFontFamily: () => mSetFontFamily,
  mSetFontItalic: () => mSetFontItalic,
  mSetFontSize: () => mSetFontSize,
  mSetFontWeight: () => mSetFontWeight,
  mSetLayoutHash: () => mSetLayoutHash,
  mSetLetterSpacing: () => mSetLetterSpacing,
  mSetLetterSpacingUnit: () => mSetLetterSpacingUnit,
  mSetLineHeight: () => mSetLineHeight,
  mSetLineHeightUnit: () => mSetLineHeightUnit,
  mSetOpacity: () => mSetOpacity2,
  mSetSize: () => mSetSize3,
  mSetSizing: () => mSetSizing,
  mSetStyle: () => mSetStyle,
  stringToBlocks: () => stringToBlocks
});
import { merge as merge4 } from "lodash-es";
import { v4 as uuidv46 } from "uuid";
function create18(partial = {}) {
  const textDefaults = {
    id: uuidv46(),
    parentId: null,
    className: "Text" /* Text */,
    size: SizeUtils_exports.create(),
    sizing: ["auto" /* Auto */, "auto" /* Auto */],
    blocks: [],
    shadows: [],
    innerShadows: [],
    style: {
      fontSize: 16,
      fontSizeUnit: "px",
      fontFamily: "Lato",
      fontWeight: 400,
      lineHeight: 16,
      autoLineHeight: true,
      lineHeightUnit: "px" /* Pixel */,
      color: ColorUtils_exports.create(),
      letterSpacing: 0,
      letterSpacingUnit: "px" /* Pixel */,
      align: "left" /* Left */,
      italic: false,
      underline: false,
      strikethrough: false
    },
    itemProps: createItemProps()
  };
  mSetClientData(textDefaults, "version", 2);
  return merge4(textDefaults, partial);
}
function mSetContent(mutable, content) {
  const blocks = content.split("\n").map((t) => ({
    text: t
  }));
  mutable.blocks = blocks;
  return mutable;
}
function mSetBlocks(mutable, blocks) {
  mutable.blocks = blocks;
  return mutable;
}
function mSetSize3(mutable, textSize) {
  mutable.size = textSize;
  return mutable;
}
function mSetSizing(mutable, sizing) {
  mutable.sizing = sizing;
  return mutable;
}
function mSetFontSize(mutable, fontSize, fontSizeUnit = "px") {
  mutable.style.fontSize = fontSize;
  mutable.style.fontSizeUnit = fontSizeUnit;
  return mutable;
}
function mSetFontWeight(mutable, fontWeight) {
  mutable.style.fontWeight = fontWeight;
  return mutable;
}
function mSetFontFamily(mutable, fontFamily) {
  mutable.style.fontFamily = fontFamily;
  return mutable;
}
function mSetLineHeight(mutable, lineHeight) {
  mutable.style.lineHeight = lineHeight;
  return mutable;
}
function mSetLineHeightUnit(mutable, unit) {
  mutable.style.lineHeightUnit = unit;
  return mutable;
}
function mSetLetterSpacing(mutable, letterSpacing) {
  mutable.style.letterSpacing = letterSpacing;
  return mutable;
}
function mSetLetterSpacingUnit(mutable, unit) {
  mutable.style.letterSpacingUnit = unit;
  return mutable;
}
function mSetFontItalic(mutable, isItalic) {
  mutable.style.italic = isItalic;
  return mutable;
}
function mSetDecoration(mutable, value) {
  mutable.style.underline = value === "underline" /* Underline */;
  mutable.style.strikethrough = value === "strikethrough" /* Strikethrough */;
  return mutable;
}
function mSetAlign(mutable, align) {
  mutable.style.align = align;
  return mutable;
}
function mSetStyle(mutable, style) {
  mutable.style = __spreadValues(__spreadValues({}, mutable.style), style);
  return mutable;
}
function mSetLayoutHash(mutable, layoutHash2) {
  mSetClientData(mutable, "layoutHash", layoutHash2);
  return mutable;
}
function getLayoutHash(text) {
  return getClientData(text).layoutHash;
}
function getFontFamily2(text) {
  return text.style.fontFamily;
}
function getFontWeight(text) {
  return text.style.fontWeight;
}
function getFontItalic(text) {
  return text.style.italic;
}
function getFontSize(text) {
  return text.style.fontSize;
}
function getContent2(text) {
  return text.blocks.map((block) => block.text).join("\n");
}
function isEmpty(text) {
  return getContent2(text).trim() === "";
}
function stringToBlocks(str) {
  const blockContents = str.split(/(\n)/).filter((s) => s).map((s) => s === "\n" ? "" : s);
  return blockContents.map((text) => ({ text }));
}
function getBlock(text, blockIdx) {
  const block = text.blocks[blockIdx];
  return (block == null ? void 0 : block.text) || "";
}
function getOpacity5(text) {
  return text.style.color.rgbaValues[3];
}
function mSetColor(mutable, color) {
  mutable.style.color = color;
  return mutable;
}
function getColor3(text) {
  return text.style.color;
}
function mSetOpacity2(mutable, opacity) {
  mutable.style.color.rgbaValues[3] = opacity;
  return mutable;
}
function mSetAutoLineHeight(mutable, autoLineHeight) {
  mutable.style.autoLineHeight = autoLineHeight;
  return mutable;
}
function getSizing(text) {
  return text.sizing;
}
function getSize(text) {
  return text.size;
}
function isAutoLineHeight(text) {
  const preVersion2 = (getClientData(text).version ?? 1) < 2;
  return preVersion2 ? true : text.style.autoLineHeight ?? false;
}
function getLineHeight(text, lineHeightUnit) {
  if (!lineHeightUnit)
    return text.style.lineHeight;
  return convertTextUnit(text.style.lineHeight, text.style.lineHeightUnit, lineHeightUnit, text.style.fontSize);
}
function getLineHeightUnit(text) {
  return text.style.lineHeightUnit;
}
function getLetterSpacing(text, letterSpacingUnit) {
  if (!letterSpacingUnit)
    return text.style.letterSpacing;
  return convertTextUnit(text.style.letterSpacing, text.style.letterSpacingUnit, letterSpacingUnit, text.style.fontSize);
}
function getLetterSpacingUnit(text) {
  return text.style.letterSpacingUnit;
}
function getUnderlineDecoration(text) {
  return text.style.underline;
}
function getStrikethroughDecoration(text) {
  return text.style.strikethrough;
}
function getTextDecoration(text) {
  if (getUnderlineDecoration(text)) {
    return "underline" /* Underline */;
  }
  if (getStrikethroughDecoration(text)) {
    return "strikethrough" /* Strikethrough */;
  }
  return "none" /* None */;
}
function getAlign(text) {
  return text.style.align;
}
function getStyle(text) {
  if (isAutoLineHeight(text) && !text.style.autoLineHeight) {
    return __spreadProps(__spreadValues({}, text.style), {
      autoLineHeight: true
    });
  }
  return text.style;
}
var valignToJustifyContent = {
  ["top" /* Top */]: "flex-start",
  ["center" /* Center */]: "center",
  ["bottom" /* Bottom */]: "flex-end"
};
function computeTextStylesCss(text, size, fontFaces) {
  const [width, height] = size;
  const [sizingX, sizingY] = getSizing(text);
  const isAbsoluteX = sizingX === "absolute" /* Absolute */;
  const isAbsoluteY = sizingY === "absolute" /* Absolute */;
  const valign = getClientData(text).valign ?? "top" /* Top */;
  const padding = getClientData(text).padding ?? 0;
  const valignStyle = isAbsoluteY ? {
    display: "flex",
    flexDirection: "column",
    justifyContent: valignToJustifyContent[valign]
  } : {};
  const {
    fontFamily: fontDescriptor,
    fontSize,
    fontWeight,
    letterSpacing,
    letterSpacingUnit,
    align: textAlign,
    italic,
    strikethrough,
    underline
  } = getStyle(text);
  const fontFamily = FontUtils_exports.getFontFamily(fontFaces, fontDescriptor) ?? fontDescriptor;
  const lineHeightPx = getLineHeightPx(text, fontFaces);
  const textStyle = __spreadValues({
    display: "inline-block",
    overflow: "visible",
    wordWrap: "break-word",
    WebkitFontSmoothing: "antialiased",
    width: isAbsoluteX ? width : "auto",
    height: isAbsoluteY ? height : "auto",
    fontSize: `${fontSize}px`,
    fontFamily,
    fontWeight: `${fontWeight}`,
    lineHeight: `${lineHeightPx}px`,
    color: ColorUtils_exports.getCssRgba(text.style.color),
    letterSpacing: `${letterSpacing}${letterSpacingUnit}`,
    textAlign,
    fontStyle: italic ? "italic" : "normal",
    textDecoration: getTextDecorationCss(strikethrough, underline),
    textRendering: "optimizeLegibility",
    whiteSpace: isAbsoluteX ? "pre-wrap" : "pre",
    boxSizing: "border-box",
    padding
  }, valignStyle);
  return textStyle;
}
function getLineHeightPx(text, fontFaces) {
  const {
    autoLineHeight,
    lineHeight,
    lineHeightUnit,
    fontFamily: fontDescriptor,
    fontWeight,
    italic,
    fontSize
  } = getStyle(text);
  if (!autoLineHeight) {
    return convertTextUnit(lineHeight, lineHeightUnit, "px" /* Pixel */, fontSize);
  }
  const fontStyle = italic ? "italic" /* Italic */ : "normal" /* Normal */;
  const font = FontUtils_exports.getFont(fontFaces, fontDescriptor, {
    fontWeight,
    fontStyle
  });
  if (!font)
    return convertTextUnit(lineHeight, lineHeightUnit, "px" /* Pixel */, fontSize);
  const lineHeightMultiplier = font.metrics.ascent - font.metrics.descent;
  return fontSize * lineHeightMultiplier;
}
function getTextDecorationCss(strikethrough, underline) {
  if (strikethrough) {
    return "line-through";
  }
  if (underline) {
    return "underline";
  }
}
function convertTextUnit(value, valueUnit, outputUnit, basePx) {
  if (valueUnit === outputUnit)
    return value;
  let valuePx;
  switch (valueUnit) {
    case "px" /* Pixel */:
      valuePx = value;
      break;
    case "%" /* Percent */:
      valuePx = basePx * (value / 100);
      break;
    default:
      throw new Error(`Unsupported unit: ${valueUnit}`);
  }
  switch (outputUnit) {
    case "px" /* Pixel */:
      return valuePx;
    case "%" /* Percent */:
      return valuePx / basePx * 100;
    default:
      throw new Error(`Unsupported unit: ${outputUnit}`);
  }
}

// src/utils/items/RandomUtils.ts
var FILL_COLORS = ["#264653", "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51"];
var STROKE_COLORS = ["#001353", "#004487", "#8E9C49", "#9E814A", "#905244"];
var MIN_DIM = 50;
var MAX_DIM = 200;
var MIN_RADIUS = 3;
var RADIUS_ODDS = 0.3;
var MIN_OPACITY = 0.2;
var MAX_OPACITY = 0.8;
var OPACITY_ODDS = 0.1;
var STROKE_ODDS = 0.3;
var MIN_STROKE_SIZE = 1;
var MAX_STROKE_SIZE = 10;
var MIN_FONT_SIZE = 12;
var MAX_FONT_SIZE = 60;
var sampleText = [
  "Don\u2019t worry, be happy!",
  "The fan is blowing in my face right now.",
  "The devil made me do it!",
  "What a big dog!",
  "Sports knows sports",
  "The wheels are in the motion",
  "Sometimes I get confused where the ball went.",
  "Stand up and catch that ball!",
  "No, I can't clean your house It's too big!.",
  "Keep it up!Let me see",
  "What is that?",
  "This is a big help.",
  "Where can I find the nearest store?",
  "Witness the fruits of your labour!",
  "Racecar backwards is racecar.",
  "Good gracious! Ridiculous!",
  "What does your room look like?",
  "I don't want to make a big deal out of this.",
  "Do you think you're bigger than Tom?",
  "Let's go I'm sick of waiting!",
  "What's the weather like today?",
  "I am doing just wonderful!",
  "I want to take a nap!",
  "Hand me the hammer!",
  "Where is the President right now?",
  "Will you be free tomorrow morning?",
  "No problem !That's all !Time is up",
  "Do you eat ice cream?",
  "Why do you need such a big house?",
  "What are those?",
  "Don\u2019t get too excited!",
  "It's a big universe.",
  "My hat is bigger than Jim's.",
  "When did you come?",
  "How often do you see George?",
  "Come on down!",
  "I've got bigger problems.",
  "His boss might get angry with his tone."
];
function createRandomItem(type, fontFaces) {
  let item2;
  switch (type) {
    case "ellipse":
    case "rectangle": {
      const width = random(MIN_DIM, MAX_DIM);
      const height = random(MIN_DIM, MAX_DIM);
      if (type === "rectangle") {
        item2 = createRectangle();
        if (chance(RADIUS_ODDS)) {
          const radius = random(MIN_RADIUS, Math.min(width, height) / 2);
          mSetRadius(item2, [radius, radius, radius, radius]);
        }
      } else {
        item2 = createEllipse();
      }
      mSetSize2(item2, [width, height]);
      mTranslate(item2, [-width / 2, -height / 2]);
      break;
    }
    case "text": {
      item2 = create18();
      mSetContent(item2, sample(sampleText));
      mSetFontSize(item2, random(MIN_FONT_SIZE, MAX_FONT_SIZE));
      if (fontFaces) {
        const fontFace = sample(fontFaces);
        mSetFontFamily(item2, fontFace.fontFamily);
        mSetFontWeight(item2, fontFace.fontWeight);
      }
      break;
    }
    default:
      return null;
  }
  if (isFillable(item2)) {
    mAddFills(item2, [FillUtils_exports.hexToColorFill(sample(FILL_COLORS))]);
  }
  if (isStrokable(item2) && chance(STROKE_ODDS)) {
    const stroke = StrokeUtils_exports.hexToColorStroke(sample(STROKE_COLORS));
    StrokeUtils_exports.mSetWidth(stroke, random(MIN_STROKE_SIZE, MAX_STROKE_SIZE));
    mAddStrokes(item2, [stroke]);
  }
  if (chance(OPACITY_ODDS)) {
    mSetOpacity(item2, random(MIN_OPACITY, MAX_OPACITY, true));
  }
  return item2;
}
function chance(odds) {
  return odds >= Math.random();
}

// src/utils/items/RasterUtils.ts
var RasterUtils_exports = {};
__export(RasterUtils_exports, {
  create: () => create19,
  getFormat: () => getFormat,
  getSize: () => getSize2,
  mSetCenter: () => mSetCenter2,
  mSetFormat: () => mSetFormat,
  mSetSize: () => mSetSize4,
  mSetSource: () => mSetSource
});
import { merge as merge5 } from "lodash-es";
import { v4 as uuidv47 } from "uuid";
function create19(partial = {}) {
  const rasterDefaults = {
    id: uuidv47(),
    parentId: null,
    className: "Raster" /* Raster */,
    source: "",
    originalSource: "",
    crossOrigin: "anonymous",
    fillStyle: FillUtils_exports.createFillStyle(),
    radius: [0, 0, 0, 0],
    shadows: [],
    innerShadows: [],
    size: SizeUtils_exports.create(),
    strokes: [],
    strokeStyle: StrokeUtils_exports.createStrokeStyle(),
    itemProps: createItemProps()
  };
  return merge5(rasterDefaults, partial);
}
function getSize2(mutable) {
  return mutable.size;
}
function mSetSize4(mutable, size) {
  mutable.size = size;
  return mutable;
}
function mSetSource(mutable, source) {
  mutable.source = source;
  return mutable;
}
function mSetFormat(mutable, format) {
  mSetClientData(mutable, "FORMAT", format);
  return mutable;
}
function getFormat(raster) {
  return getClientData(raster).FORMAT;
}
function mSetCenter2(mutable, center) {
  const centerPoint = center || PointUtils_exports.create(0, 0);
  const topLeft = PointUtils_exports.subtract(centerPoint, PointUtils_exports.divide(mutable.size, 2));
  MatrixUtils_exports.translate(mutable.itemProps.matrix, topLeft, mutable.itemProps.matrix);
  return mutable;
}

// src/utils/items/SliceUtils.ts
var SliceUtils_exports = {};
__export(SliceUtils_exports, {
  create: () => create20
});
function create20() {
  throw new Error("TODO: Slice create function");
}

// src/state/selectors.ts
var selectors_exports5 = {};
__export(selectors_exports5, {
  getAncestorIds: () => getAncestorIds,
  getAncestorMatrix: () => getAncestorMatrix,
  getAncestors: () => getAncestors,
  getArtboard: () => getArtboard,
  getArtboardBounds: () => getArtboardBounds,
  getArtboardCenter: () => getArtboardCenter,
  getArtboardPoint: () => getArtboardPoint,
  getArtboardSize: () => getArtboardSize,
  getBaseBounds: () => getBaseBounds,
  getBounds: () => getBounds,
  getChildren: () => getChildren,
  getCommonAncestorIds: () => getCommonAncestorIds,
  getDenormalizedItemById: () => getDenormalizedItemById,
  getEntities: () => getEntities,
  getExternalItemIds: () => getExternalItemIds,
  getExternalItems: () => getExternalItems,
  getExtrema: () => getExtrema,
  getGlobalMatrix: () => getGlobalMatrix,
  getItemById: () => getItemById,
  getItemFills: () => getItemFills,
  getItemIndex: () => getItemIndex,
  getItemPosition: () => getItemPosition,
  getItemRotation: () => getItemRotation,
  getItemStrokes: () => getItemStrokes,
  getItems: () => getItems,
  getItemsById: () => getItemsById,
  getLineRotation: () => getLineRotation,
  getLineWidth: () => getLineWidth,
  getParent: () => getParent,
  getRoot: () => getRoot,
  getRootId: () => getRootId,
  getSiblingIds: () => getSiblingIds,
  getSiblings: () => getSiblings,
  getTitle: () => getTitle,
  getTokenById: () => getTokenById,
  getTokens: () => getTokens,
  getTokensByType: () => getTokensByType,
  getUnitedBounds: () => getUnitedBounds,
  getVersion: () => getVersion,
  isDescendantOfId: () => isDescendantOfId,
  isNotRoot: () => isNotRoot,
  layoutHash: () => layoutHash,
  sortItemsLowestToHighest: () => sortItemsLowestToHighest,
  walk: () => walk
});

// src/state/canvas/selectors.ts
var selectors_exports3 = {};
__export(selectors_exports3, {
  getArtboard: () => getArtboard,
  getArtboardBounds: () => getArtboardBounds,
  getArtboardCenter: () => getArtboardCenter,
  getArtboardPoint: () => getArtboardPoint,
  getArtboardSize: () => getArtboardSize,
  getTitle: () => getTitle
});
function getArtboard(fragment) {
  return getRoot(fragment).artboard;
}
function getArtboardCenter(fragment) {
  const artboard = getArtboard(fragment);
  return PointUtils_exports.add(artboard.point, PointUtils_exports.divide(artboard.size, 2));
}
function getArtboardSize(fragment) {
  const artboard = getArtboard(fragment);
  return artboard.size;
}
function getArtboardPoint(fragment) {
  const artboard = getArtboard(fragment);
  return artboard.point;
}
function getArtboardBounds(fragment) {
  return {
    size: getArtboardSize(fragment),
    point: getArtboardPoint(fragment)
  };
}
function getTitle(fragment) {
  return getRoot(fragment).title;
}

// src/state/token/selectors.ts
var selectors_exports4 = {};
__export(selectors_exports4, {
  getTokenById: () => getTokenById,
  getTokens: () => getTokens,
  getTokensByType: () => getTokensByType
});
import { createCachedSelector } from "re-reselect";
function getTokens(state) {
  return state.tokens;
}
function getTokenById(state, id) {
  return getTokens(state)[id] || null;
}
var getTokensByType = createCachedSelector([getTokens, (_state, type) => type], (tokens, type) => {
  return Object.values(tokens).filter((token) => token.type === type);
})((_state, type) => type);

// src/state/text/selectors.ts
import hash from "object-hash";
function layoutHash(fragment, text) {
  const {
    fontFamily,
    fontSize,
    fontSizeUnit,
    fontWeight,
    letterSpacing,
    letterSpacingUnit,
    lineHeight,
    lineHeightUnit,
    autoLineHeight,
    italic
  } = TextUtils_exports.getStyle(text);
  const { padding } = ItemUtils_exports.getClientData(text);
  const content = TextUtils_exports.getContent(text);
  const globalMatrix = getGlobalMatrix(fragment, text.id);
  const scaling = globalMatrix && PointUtils_exports.roundToNearest(MatrixUtils_exports.getScaling(globalMatrix), 1e-6);
  return hash({
    content,
    fontFamily,
    fontSize,
    fontSizeUnit,
    fontWeight,
    letterSpacing,
    letterSpacingUnit,
    padding,
    scaling,
    lineHeight: autoLineHeight || `${lineHeight}${lineHeightUnit}`,
    italic
  });
}

// src/state/selectors.ts
function getVersion(state) {
  return ItemUtils_exports.getClientData(state).version;
}

// src/state/actions.ts
var actions_exports = {};
__export(actions_exports, {
  addFill: () => addFill,
  addStroke: () => addStroke,
  arrangeItems: () => arrangeItems,
  clearHistory: () => clearHistory,
  deleteItems: () => deleteItems,
  groupItems: () => groupItems,
  importDesign: () => importDesign,
  importTokens: () => importTokens,
  insertFragments: () => insertFragments,
  insertItem: () => insertItem,
  insertItems: () => insertItems,
  redo: () => redo,
  removeFill: () => removeFill,
  removeStroke: () => removeStroke,
  renameItem: () => renameItem,
  replaceFillContent: () => replaceFillContent,
  replaceOpacity: () => replaceOpacity,
  replaceTokenColor: () => replaceTokenColor,
  resetDesign: () => resetDesign,
  scaleItem: () => scaleItem,
  setAlign: () => setAlign,
  setAspectRatioLock: () => setAspectRatioLock,
  setAssetUploaded: () => setAssetUploaded,
  setAssetUploading: () => setAssetUploading,
  setAutoLineHeight: () => setAutoLineHeight,
  setBorderRadius: () => setBorderRadius,
  setCachedExtrema: () => setCachedExtrema,
  setDesignId: () => setDesignId,
  setFillEnabled: () => setFillEnabled,
  setFontFamily: () => setFontFamily,
  setFontItalic: () => setFontItalic,
  setFontSize: () => setFontSize,
  setFontWeight: () => setFontWeight,
  setItemMatrix: () => setItemMatrix,
  setLetterSpacing: () => setLetterSpacing,
  setLineHeight: () => setLineHeight,
  setSegment: () => setSegment,
  setStrokeColor: () => setStrokeColor,
  setStrokeEnabled: () => setStrokeEnabled,
  setStrokeOpacity: () => setStrokeOpacity,
  setStrokePosition: () => setStrokePosition,
  setStrokeWidth: () => setStrokeWidth,
  setTextBlocksContent: () => setTextBlocksContent,
  setTextColor: () => setTextColor,
  setTextColorOpacity: () => setTextColorOpacity,
  setTextDecoration: () => setTextDecoration,
  setTextSize: () => setTextSize,
  setTextSizing: () => setTextSizing,
  toggleFill: () => toggleFill,
  transformItem: () => transformItem,
  translateItem: () => translateItem,
  undo: () => undo,
  ungroupItem: () => ungroupItem
});

// src/state/canvas/actions.ts
var setDesignId = (args, meta) => ({
  type: "DESIGN_SET_ID" /* DesignSetId */,
  payload: { id: args.id },
  meta: __spreadProps(__spreadValues({}, meta), {
    ["dontPersist" /* DontPersist */]: true,
    ["dontUndo" /* DontUndo */]: true
  })
});
var importDesign = (args, meta) => ({
  type: "DESIGN_IMPORT" /* DesignImport */,
  payload: args,
  meta
});
var resetDesign = (args, meta) => ({
  type: "DESIGN_RESET" /* DesignReset */,
  payload: args,
  meta
});

// src/state/fill/actions.ts
var replaceFillContent = (args, meta) => {
  return createAction({
    type: "ITEM_REPLACE_FILL_CONTENT" /* ReplaceFillContent */,
    meta,
    payload: args
  });
};
var replaceOpacity = (args, meta) => {
  return createAction({
    type: "ITEM_SET_FILL_OPACITY" /* SetFillOpacity */,
    meta,
    payload: args
  });
};
var addFill = (args, meta) => {
  return createAction({
    type: "ITEM_ADD_FILL" /* AddFill */,
    meta,
    payload: args
  });
};
var removeFill = (args, meta) => {
  return createAction({
    type: "ITEM_REMOVE_FILL" /* RemoveFill */,
    meta,
    payload: args
  });
};
var toggleFill = (args, meta) => {
  return createAction({
    type: "ITEM_TOGGLE_FILL_VISIBILITY" /* ToggleFillVisibility */,
    meta,
    payload: args
  });
};
var setFillEnabled = (args, meta) => {
  return createAction({
    type: "ITEM_SET_FILL_ENABLED" /* SetFillEnabled */,
    meta,
    payload: args
  });
};

// src/state/fragment/actions.ts
var insertFragments = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "FRAGMENTS_INSERT" /* FragmentsInsert */
  });
};

// src/state/history/actions.ts
var redo = () => createAction({
  meta: null,
  payload: null,
  type: "HISTORY_REDO" /* HistoryRedo */
});
var undo = () => createAction({
  meta: null,
  payload: null,
  type: "HISTORY_UNDO" /* HistoryUndo */
});
var clearHistory = () => createAction({
  meta: null,
  payload: null,
  type: "HISTORY_CLEAR" /* HistoryClear */
});

// src/state/path/actions.ts
var setSegment = ({ id, index, segment }, meta) => {
  return {
    type: "SET_SEGMENT" /* SetSegment */,
    payload: {
      id,
      index,
      segment
    },
    meta
  };
};

// src/state/radius/actions.ts
var setBorderRadius = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "ITEMS_CHANGE_RADIUS" /* ChangeRadius */
  });
};

// src/state/stroke/actions.ts
var setStrokeEnabled = (args, meta) => {
  return createAction({
    type: "ITEM_SET_STROKE_ENABLED" /* SetStrokeEnabled */,
    meta,
    payload: args
  });
};
var setStrokeWidth = (args, meta) => {
  return createAction({
    type: "ITEM_SET_STROKE_WIDTH" /* SetStrokeWidth */,
    meta,
    payload: args
  });
};
var setStrokeOpacity = (args, meta) => {
  return createAction({
    type: "ITEM_SET_STROKE_OPACITY" /* SetStrokeOpacity */,
    meta,
    payload: args
  });
};
var setStrokeColor = (args, meta) => {
  return createAction({
    type: "ITEM_SET_STROKE_COLOR" /* SetStrokeColor */,
    meta,
    payload: args
  });
};
var setStrokePosition = (args, meta) => {
  return createAction({
    type: "ITEM_SET_STROKE_POSITION" /* SetStrokePosition */,
    meta,
    payload: args
  });
};
var addStroke = (args, meta) => {
  return createAction({
    type: "ITEM_ADD_STROKE" /* AddStroke */,
    meta,
    payload: args
  });
};
var removeStroke = (args, meta) => {
  return createAction({
    type: "ITEM_REMOVE_STROKE" /* RemoveStroke */,
    meta,
    payload: args
  });
};

// src/state/text/actions.ts
var setFontFamily = (args, meta) => {
  return createAction({
    type: "TEXT_SET_FONT_FAMILY" /* TextSetFontFamily */,
    payload: args,
    meta
  });
};
var setFontWeight = (args, meta) => {
  return createAction({
    type: "TEXT_SET_FONT_WEIGHT" /* TextSetFontWeight */,
    payload: args,
    meta
  });
};
var setFontItalic = (args, meta) => {
  return createAction({
    type: "TEXT_SET_FONT_ITALIC_ACTION" /* TextSetFontItalic */,
    payload: args,
    meta
  });
};
var setFontSize = (args, meta) => {
  return createAction({
    type: "TEXT_SET_FONT_SIZE" /* TextSetFontSize */,
    payload: args,
    meta
  });
};
var setLetterSpacing = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_LETTER_SPACING" /* TextSetLetterSpacing */
  });
};
var setAutoLineHeight = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_AUTO_LINE_HEIGHT" /* TextSetAutoLineHeight */
  });
};
var setLineHeight = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_LINE_HEIGHT" /* TextSetLineHeight */
  });
};
var setTextColor = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_COLOR" /* TextSetColor */
  });
};
var setTextSize = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_SIZE" /* TextSetSize */
  });
};
var setTextColorOpacity = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_COLOR_OPACITY" /* TextSetColorOpacity */
  });
};
var setAlign = (args) => {
  return createAction({
    type: "TEXT_SET_ALIGN" /* TextSetAlign */,
    payload: args
  });
};
var setTextSizing = (args, meta) => {
  return createAction({
    meta,
    payload: args,
    type: "TEXT_SET_SIZING" /* TextSetSizing */
  });
};
var setTextBlocksContent = (args, meta) => {
  return createAction({
    type: "TEXT_SET_BLOCKS_CONTENT" /* TextSetBlocksContent */,
    meta,
    payload: args
  });
};
var setTextDecoration = (args) => {
  return createAction({
    payload: args,
    type: "TEXT_SET_DECORATION" /* TextSetDecoration */
  });
};

// src/state/token/actions.ts
var importTokens = (args, meta) => {
  const payload = {
    tokens: args.tokens
  };
  return createAction({
    meta: __spreadProps(__spreadValues({}, meta), {
      ["dontUndo" /* DontUndo */]: true
    }),
    payload,
    type: "TOKENS_IMPORT" /* TokensImport */
  });
};
var replaceTokenColor = (args, meta) => {
  return createAction({
    meta: __spreadProps(__spreadValues({}, meta), {
      ["dontUndo" /* DontUndo */]: true
    }),
    payload: args,
    type: "TOKEN_REPLACE_COLOR" /* TokenReplaceColor */
  });
};

// src/state/asset/actions.ts
function setAssetUploading(id, url) {
  return {
    type: "SET_ASSET_UPLOADING" /* SetAssetUploading */,
    payload: { id, url },
    meta: {
      ["dontUndo" /* DontUndo */]: true
    }
  };
}
function setAssetUploaded(id, url) {
  return {
    type: "SET_ASSET_UPLOADED" /* SetAssetUploaded */,
    payload: { id, url },
    meta: {
      ["dontUndo" /* DontUndo */]: true
    }
  };
}

// src/state/createDesign.ts
import { createProxiedDoc } from "@marvelapp/crdt";

// src/state/defaultState.ts
var defaultState = {
  root: {
    artboard: {
      designRatio: 1,
      fills: [
        FillUtils_exports.createColorFill(ColorUtils_exports.createFromRgba([1, 1, 1, 1]))
      ],
      pixelRatio: 1,
      point: [0, 0],
      size: [800, 600]
    },
    children: [],
    className: "Canvas" /* Canvas */,
    id: "",
    title: ""
  },
  items: {},
  data: {},
  tokens: {}
};
var defaultState_default = defaultState;

// src/state/createDesign.ts
function createDesign(data, proxyOptions) {
  const design2 = createProxiedDoc(data, "design", proxyOptions);
  return design2;
}
function createEmptyDesign(proxyOptions) {
  return createDesign(defaultState_default, proxyOptions);
}

// src/state/reducer.ts
import { $$DOC } from "@marvelapp/crdt";

// src/state/asset/reducer.ts
function assetReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "SET_ASSET_UPLOADING" /* SetAssetUploading */: {
      const {
        payload: { id, url }
      } = action;
      const item2 = getItemById(draft, id);
      if (!item2)
        return draft;
      ItemUtils_exports.mSetAssetUploadStatus(item2, url, "uploading" /* Uploading */);
      return draft;
    }
    case "SET_ASSET_UPLOADED" /* SetAssetUploaded */: {
      const {
        payload: { id, url }
      } = action;
      const item2 = getItemById(draft, id);
      if (!item2)
        return draft;
      ItemUtils_exports.mSetAssetUploadStatus(item2, url, "uploaded" /* Uploaded */);
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/canvas/reducer.ts
import { getDoc } from "@marvelapp/crdt";
function canvasReducer(draft, anyAction) {
  var _a;
  const action = anyAction;
  switch (action.type) {
    case "DESIGN_SET_ID" /* DesignSetId */: {
      const {
        payload: { id }
      } = action;
      draft.root.id = id;
      return draft;
    }
    case "DESIGN_IMPORT" /* DesignImport */: {
      const { design: design2, ignoreId } = action.payload;
      const currentId = (_a = draft.root) == null ? void 0 : _a.id;
      repairExtremaCache(design2);
      Object.assign(draft, {
        tokens: draft.tokens
      }, design2);
      if (ignoreId) {
        draft.root.id = currentId;
      }
      return draft;
    }
    case "DESIGN_RESET" /* DesignReset */: {
      const newDoc = getDoc(action.payload.design);
      const currentDoc = getDoc(draft);
      if (newDoc === currentDoc) {
        return draft;
      }
      currentDoc.destroy();
      repairExtremaCache(action.payload.design);
      return action.payload.design;
    }
    default:
      return draft;
  }
}

// src/state/fill/reducer.ts
function fillsReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "ITEM_REPLACE_FILL_CONTENT" /* ReplaceFillContent */: {
      const {
        payload: { id, content, fillIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isFillable(item2))
        return draft;
      const fill = item2.fillStyle.fills[fillIndex];
      if (!fill)
        return draft;
      fill.content = content;
      return draft;
    }
    case "ITEM_SET_FILL_OPACITY" /* SetFillOpacity */: {
      const {
        payload: { id, opacity, fillIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isFillable(item2))
        return draft;
      const fill = item2.fillStyle.fills[fillIndex];
      if (!fill)
        return draft;
      if (!FillUtils_exports.isColorFill(fill)) {
        console.error("setting opacity on non-color fills is not yet supported");
        return draft;
      }
      fill.content.rgbaValues[3] = Math.min(1, Math.max(0, opacity));
      return draft;
    }
    case "ITEM_ADD_FILL" /* AddFill */: {
      const {
        payload: { id, fill, fillIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isFillable(item2))
        return draft;
      item2.fillStyle.fills[fillIndex] = fill;
      return draft;
    }
    case "ITEM_REMOVE_FILL" /* RemoveFill */: {
      const {
        payload: { id, fillIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isFillable(item2))
        return draft;
      item2.fillStyle.fills.splice(fillIndex, 1);
      return draft;
    }
    case "ITEM_SET_FILL_ENABLED" /* SetFillEnabled */: {
      const {
        payload: { id, fillIndex, isEnabled }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isFillable(item2))
        return draft;
      item2.fillStyle.fills[fillIndex].enabled = isEnabled;
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/fragment/reducer.ts
function fragmentReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "FRAGMENTS_INSERT" /* FragmentsInsert */: {
      const {
        payload: { index, fragments, parentId, ignoreAncestorMatrix }
      } = action;
      fragments.forEach((fragment) => repairExtremaCache(fragment));
      if (index !== void 0) {
        FragmentUtils_exports.mInsertFragmentsAtIndex(draft, fragments, index, parentId);
      } else {
        FragmentUtils_exports.mAppendFragments(draft, fragments, parentId);
      }
      if (ignoreAncestorMatrix) {
        fragments.forEach((fragment) => {
          const ancestorMatrix = getAncestorMatrix(draft, fragment.root.id);
          const inverseAncestorMatrix = MatrixUtils_exports.invert(ancestorMatrix);
          const currentMatrix = draft.items[fragment.root.id].itemProps.matrix;
          draft.items[fragment.root.id].itemProps.matrix = MatrixUtils_exports.multiply(inverseAncestorMatrix, currentMatrix);
        });
        updateExtremaCache(draft, mapFilterNullish(fragments, getRootId));
      }
      if (parentId !== void 0) {
        updateExtremaCache(draft, [parentId]);
      }
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/item/reducer.ts
function itemReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "ITEMS_INSERT" /* ItemsInsert */: {
      const {
        payload: { index, items, parentId }
      } = action;
      if (index) {
        FragmentUtils_exports.mInsertItemsAtIndex(draft, items, index, parentId);
      } else {
        FragmentUtils_exports.mAppendItems(draft, items, parentId);
      }
      if (parentId !== void 0) {
        updateExtremaCache(draft, [parentId]);
      }
      return draft;
    }
    case "ITEMS_DELETE" /* ItemsDelete */: {
      const { ids } = action.payload;
      const parentIds = [];
      const onBeforeDelete = (id) => {
        const parent = getParent(draft, id);
        if (parent) {
          parentIds.push(parent.id);
        }
      };
      FragmentUtils_exports.mDeleteItems(draft, ids, onBeforeDelete);
      updateExtremaCache(draft, parentIds);
      return draft;
    }
    case "ITEM_TRANSFORM" /* ItemTransform */: {
      const {
        payload: { id, matrix, ignoreAncestorMatrix }
      } = action;
      const item2 = draft.items[id];
      const currentMatrix = item2.itemProps.matrix;
      const ancestorMatrix = getAncestorMatrix(draft, id);
      const transformationMatrix = ignoreAncestorMatrix ? MatrixUtils_exports.shiftLeft(matrix, ancestorMatrix) : matrix;
      const newMatrix = MatrixUtils_exports.multiply(transformationMatrix, currentMatrix);
      const scaling = MatrixUtils_exports.getScaling(transformationMatrix);
      const hasXScaling = !NumberUtils_exports.isCloseTo(scaling[0], 1);
      const hasYScaling = !NumberUtils_exports.isCloseTo(scaling[1], 1);
      if (!MatrixUtils_exports.isInvertible(newMatrix))
        return draft;
      const idsToUpdate = [id];
      item2.itemProps.matrix = newMatrix;
      if (hasXScaling || hasYScaling) {
        for (const [walkedItem] of walk(draft, id, { inclusive: true })) {
          if (ItemUtils_exports.isOfType(walkedItem, "Text" /* Text */)) {
            const [xSizing, ySizing] = TextUtils_exports.getSizing(walkedItem);
            const isAutoX = xSizing === "auto" /* Auto */;
            const isAutoY = ySizing === "auto" /* Auto */;
            if (hasYScaling && (isAutoX || isAutoY)) {
              idsToUpdate.push(walkedItem.id);
              TextUtils_exports.mSetSizing(walkedItem, [
                "absolute" /* Absolute */,
                "absolute" /* Absolute */
              ]);
            } else if (hasXScaling && isAutoX) {
              idsToUpdate.push(walkedItem.id);
              TextUtils_exports.mSetSizing(walkedItem, ["absolute" /* Absolute */, ySizing]);
            }
          }
        }
      }
      updateExtremaCache(draft, idsToUpdate);
      return draft;
    }
    case "ITEM_SET_MATRIX" /* ItemSetMatrix */: {
      const {
        payload: { id, matrix }
      } = action;
      ItemUtils_exports.mSetMatrix(draft.items[id], matrix);
      updateExtremaCache(draft, [id]);
      return draft;
    }
    case "ITEM_SET_ASPECT_RATIO_LOCK" /* ItemSetAspectRatioLock */: {
      const {
        payload: { id, isLocked: isLocked2 }
      } = action;
      ItemUtils_exports.mSetAspectRatioLocked(draft.items[id], isLocked2);
      return draft;
    }
    case "ITEM_SET_CACHED_EXTREMA" /* ItemSetCachedExtrema */: {
      const {
        payload: { id, extrema }
      } = action;
      ItemUtils_exports.mSetCachedExtrema(draft.items[id], extrema);
      const parent = getParent(draft, id);
      if (parent) {
        updateExtremaCache(draft, [parent.id]);
      }
      return draft;
    }
    case "ITEMS_ARRANGE" /* ItemsArrange */: {
      const {
        payload: { items, targetIndex, parent, targetDirection }
      } = action;
      const ids = items.map(ItemUtils_exports.getId);
      const toIndex = Math.min(parent.children.length, targetIndex);
      const targetId = parent.children[toIndex];
      FragmentUtils_exports.mMove(draft, ids, targetId, targetDirection);
      return draft;
    }
    case "ITEMS_GROUP" /* ItemsGroup */: {
      const {
        payload: { groupId, ids }
      } = action;
      FragmentUtils_exports.mGroup(draft, groupId, ids);
      updateExtremaCache(draft, ids);
      return draft;
    }
    case "ITEM_UNGROUP" /* ItemUngroup */: {
      const {
        payload: { group }
      } = action;
      const groupChildrenIds = [...group.children];
      FragmentUtils_exports.mUngroup(draft, group);
      updateExtremaCache(draft, groupChildrenIds);
      return draft;
    }
    case "ITEM_RENAME" /* ItemRename */: {
      const {
        payload: { id, name }
      } = action;
      const item2 = draft.items[id];
      if (!item2)
        return draft;
      ItemUtils_exports.mSetName(item2, name);
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/path/reducer.ts
function pathReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "SET_SEGMENT" /* SetSegment */: {
      const { id, index, segment } = action.payload;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Path" /* Path */))
        return draft;
      PathUtils_exports.mSetSegment(item2, index, segment);
      updateExtremaCache(draft, [id]);
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/radius/reducer.ts
import { isNil } from "lodash-es";
function radiusReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "ITEMS_CHANGE_RADIUS" /* ChangeRadius */: {
      const {
        payload: { id, radius, cornerIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.hasBorderRadiusSupport(item2))
        return draft;
      if (!isNil(cornerIndex)) {
        item2.radius[cornerIndex] = radius;
      } else {
        item2.radius = [radius, radius, radius, radius];
      }
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/stroke/reducer.ts
function strokesReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "ITEM_SET_STROKE_ENABLED" /* SetStrokeEnabled */: {
      const {
        payload: { id, strokeIndex, isEnabled }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex].enabled = isEnabled;
      return draft;
    }
    case "ITEM_SET_STROKE_POSITION" /* SetStrokePosition */: {
      const {
        payload: { id, strokeIndex, strokePosition }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex].strokePosition = strokePosition;
      return draft;
    }
    case "ITEM_ADD_STROKE" /* AddStroke */: {
      const {
        payload: { id, strokeIndex, stroke }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex] = stroke;
      return draft;
    }
    case "ITEM_SET_STROKE_WIDTH" /* SetStrokeWidth */: {
      const {
        payload: { id, strokeIndex, width }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex].width = Math.max(0, width);
      return draft;
    }
    case "ITEM_SET_STROKE_OPACITY" /* SetStrokeOpacity */: {
      const {
        payload: { id, strokeIndex, opacity }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex].color.rgbaValues[3] = Math.min(1, Math.max(0, opacity));
      return draft;
    }
    case "ITEM_SET_STROKE_COLOR" /* SetStrokeColor */: {
      const {
        payload: { id, strokeIndex, color }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes[strokeIndex].color = color;
      return draft;
    }
    case "ITEM_REMOVE_STROKE" /* RemoveStroke */: {
      const {
        payload: { id, strokeIndex }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isStrokable(item2))
        return draft;
      item2.strokes.splice(strokeIndex, 1);
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/text/reducer.ts
function textReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "TEXT_SET_FONT_FAMILY" /* TextSetFontFamily */: {
      const {
        payload: { id, fontFamily }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.fontFamily = fontFamily;
      return draft;
    }
    case "TEXT_SET_FONT_WEIGHT" /* TextSetFontWeight */: {
      const {
        payload: { id, fontWeight }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.fontWeight = fontWeight;
      return draft;
    }
    case "TEXT_SET_COLOR" /* TextSetColor */: {
      const {
        payload: { id, color }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.color.rgbaValues = color.rgbaValues;
      return draft;
    }
    case "TEXT_SET_COLOR_OPACITY" /* TextSetColorOpacity */: {
      const {
        payload: { id, opacity }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.color.rgbaValues[3] = Math.min(1, Math.max(0, opacity));
      return draft;
    }
    case "TEXT_SET_FONT_SIZE" /* TextSetFontSize */: {
      const {
        payload: { id, fontSize }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.fontSize = Math.max(fontSize, 1);
      return draft;
    }
    case "TEXT_SET_LETTER_SPACING" /* TextSetLetterSpacing */: {
      const {
        payload: { id, letterSpacing, letterSpacingUnit }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.letterSpacing = letterSpacing;
      item2.style.letterSpacingUnit = letterSpacingUnit;
      return draft;
    }
    case "TEXT_SET_AUTO_LINE_HEIGHT" /* TextSetAutoLineHeight */: {
      const {
        payload: { id, autoLineHeight }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.autoLineHeight = autoLineHeight;
      ItemUtils_exports.mSetClientData(item2, "version", 2);
      return draft;
    }
    case "TEXT_SET_LINE_HEIGHT" /* TextSetLineHeight */: {
      const {
        payload: { id, lineHeight, lineHeightUnit }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.lineHeight = lineHeight;
      item2.style.lineHeightUnit = lineHeightUnit;
      ItemUtils_exports.mSetClientData(item2, "version", 2);
      return draft;
    }
    case "TEXT_SET_SIZE" /* TextSetSize */: {
      const {
        payload: { id, size, layoutHash: layoutHash2 }
      } = action;
      const item2 = draft.items[id];
      if (!item2)
        return draft;
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      if (layoutHash2 !== TextUtils_exports.getLayoutHash(item2))
        TextUtils_exports.mSetLayoutHash(item2, layoutHash2);
      if (SizeUtils_exports.isCloseTo(size, item2.size))
        return draft;
      item2.size = size;
      updateExtremaCache(draft, [id]);
      return draft;
    }
    case "TEXT_SET_ALIGN" /* TextSetAlign */: {
      const {
        payload: { id, align }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.align = align;
      return draft;
    }
    case "TEXT_SET_SIZING" /* TextSetSizing */: {
      const {
        payload: { id, sizing }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      TextUtils_exports.mSetSizing(item2, sizing);
      TextUtils_exports.mSetSize(item2, [...TextUtils_exports.getSize(item2)]);
      const isAutoX = sizing[0] === "auto" /* Auto */;
      const isAutoY = sizing[1] === "auto" /* Auto */;
      if (isAutoX || isAutoY) {
        const currentMatrix = ItemUtils_exports.getMatrix(item2);
        const ancestorMatrix = getAncestorMatrix(draft, id);
        const globalMatrix = MatrixUtils_exports.multiply(ancestorMatrix, currentMatrix);
        const scaling = MatrixUtils_exports.getScaling(globalMatrix);
        const newMatrix = MatrixUtils_exports.scale(currentMatrix, [
          isAutoX ? 1 / scaling[0] : 1,
          isAutoY ? 1 / scaling[1] : 1
        ]);
        ItemUtils_exports.mSetMatrix(item2, newMatrix);
      }
      updateExtremaCache(draft, [id]);
      return draft;
    }
    case "TEXT_SET_DECORATION" /* TextSetDecoration */: {
      const {
        payload: { id, textDecoration }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      item2.style.underline = textDecoration === "underline" /* Underline */;
      item2.style.strikethrough = textDecoration === "strikethrough" /* Strikethrough */;
      return draft;
    }
    case "TEXT_SET_BLOCKS_CONTENT" /* TextSetBlocksContent */: {
      const {
        payload: { id, textBlocks }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      TextUtils_exports.mSetBlocks(item2, textBlocks);
      return draft;
    }
    case "TEXT_SET_FONT_ITALIC_ACTION" /* TextSetFontItalic */: {
      const {
        payload: { id, italic }
      } = action;
      const item2 = draft.items[id];
      if (!ItemUtils_exports.isOfType(item2, "Text" /* Text */))
        return draft;
      TextUtils_exports.mSetFontItalic(item2, italic);
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/token/reducer.ts
import { keyBy as keyBy2 } from "lodash-es";
function tokenReducer(draft, anyAction) {
  const action = anyAction;
  switch (action.type) {
    case "TOKEN_REPLACE_COLOR" /* TokenReplaceColor */: {
      const { payload } = action;
      const token = draft.tokens[payload.id];
      if (token.type !== "color" /* Color */)
        return draft;
      token.value = ColorUtils_exports.getRgba(payload.color).join(",");
      return draft;
    }
    case "TOKENS_IMPORT" /* TokensImport */: {
      draft.tokens = keyBy2(action.payload.tokens, "uuid");
      return draft;
    }
    default:
      return draft;
  }
}

// src/state/utils/createSelectors.ts
import { identity, mapValues } from "lodash-es";
var selectors = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, selectors_exports3), selectors_exports2), selectors_exports4), selectors_exports);
function createSelectors(getDesign = identity) {
  return mapValues(selectors, (selector) => (state, ...args) => selector(getDesign(state), ...args));
}

// src/state/reducer.ts
var allReducers = [
  canvasReducer,
  itemReducer,
  fillsReducer,
  textReducer,
  tokenReducer,
  strokesReducer,
  radiusReducer,
  fragmentReducer,
  pathReducer,
  assetReducer
];
var combinedReducer = (state, action) => {
  return allReducers.reduce((acc, reducer) => reducer(acc, action), state);
};
var createTransactionReducer = (reducer, proxyOptions) => (state = createDesign(void 0, proxyOptions), action) => {
  let newState;
  const dontUndo = actionUtils_exports.getMetaValue(action, "dontUndo" /* DontUndo */, false);
  state[$$DOC].transact(() => {
    newState = reducer(state, action);
  }, dontUndo ? "auto" : null);
  return newState;
};
var designReducer = combinedReducer;
var createDesignReducer = (higherOrderReducers = [], proxyOptions) => {
  return createTransactionReducer([...higherOrderReducers].reverse().reduce((a, b) => {
    return b(a);
  }, combinedReducer), proxyOptions);
};

// src/state/history/enableHistory.ts
import { UndoManager } from "yjs";
import { getDoc as getDoc2 } from "@marvelapp/crdt";
var defaultGetDesign = (state) => state;
function enableHistory(reducer, {
  getDesign = defaultGetDesign,
  captureMetadata,
  applyMetadata
} = {}) {
  let undoManager;
  let lastDesign;
  let currentState;
  function cleanupUndoManager() {
    if (undoManager) {
      undoManager.destroy();
      undoManager = void 0;
    }
  }
  function setupUndoManager(design2) {
    cleanupUndoManager();
    undoManager = new UndoManager(getDoc2(design2).getMap("design"), {
      ignoreRemoteMapChanges: true
    });
    if (captureMetadata)
      undoManager.on("stack-item-added", (event) => {
        captureMetadata(currentState, event.stackItem.meta);
      });
    if (applyMetadata)
      undoManager.on("stack-item-popped", (event) => {
        currentState = applyMetadata(currentState, event.stackItem.meta);
      });
  }
  function historyReducer(state, action) {
    switch (action.type) {
      case "HISTORY_UNDO" /* HistoryUndo */:
        if (undoManager)
          undoManager.undo();
        return state;
      case "HISTORY_CLEAR" /* HistoryClear */:
        if (undoManager)
          undoManager.clear();
        return state;
      case "HISTORY_REDO" /* HistoryRedo */:
        if (undoManager)
          undoManager.redo();
        return state;
      default:
        return state;
    }
  }
  return (state, action) => {
    currentState = state;
    currentState = historyReducer(currentState, action);
    currentState = reducer(currentState, action);
    const design2 = getDesign(currentState);
    if (design2 !== lastDesign) {
      if (design2) {
        setupUndoManager(design2);
      } else {
        cleanupUndoManager();
      }
      lastDesign = design2;
    }
    return currentState;
  };
}

// src/validate/validate.ts
var wrapper0 = { validate: validate14 };
function validate14(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  if (typeof data !== "string") {
    var err0 = { instancePath, schemaPath: "#/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs3 = errors;
    if (!(typeof data == "number" && isFinite(data))) {
      var err1 = { instancePath, schemaPath: "#/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    var _valid0 = _errs3 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      var _errs5 = errors;
      if (data !== null) {
        var err2 = { instancePath, schemaPath: "#/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      var _valid0 = _errs5 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        var _errs7 = errors;
        if (typeof data !== "boolean") {
          var err3 = { instancePath, schemaPath: "#/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        var _valid0 = _errs7 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          var _errs9 = errors;
          if (errors === _errs9) {
            if (Array.isArray(data)) {
              var valid1 = true;
              var len0 = data.length;
              for (var i0 = 0; i0 < len0; i0++) {
                var _errs11 = errors;
                if (!wrapper0.validate(data[i0], { instancePath: instancePath + "/" + i0, parentData: data, parentDataProperty: i0, rootData })) {
                  vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs11 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              var err4 = { instancePath, schemaPath: "#/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
          var _valid0 = _errs9 === errors;
          valid0 = valid0 || _valid0;
        }
      }
    }
  }
  if (!valid0) {
    var err5 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
    validate14.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate14.errors = vErrors;
  return errors === 0;
}
var wrapper1 = { validate: validate13 };
function validate13(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      for (var key0 in data) {
        var data0 = data[key0];
        var _errs2 = errors;
        var _errs3 = errors;
        var valid1 = false;
        var _errs4 = errors;
        var _errs5 = errors;
        var valid2 = false;
        var _errs6 = errors;
        if (typeof data0 !== "string") {
          var err0 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        var _valid1 = _errs6 === errors;
        valid2 = valid2 || _valid1;
        if (!valid2) {
          var _errs8 = errors;
          if (!(typeof data0 == "number" && isFinite(data0))) {
            var err1 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          var _valid1 = _errs8 === errors;
          valid2 = valid2 || _valid1;
          if (!valid2) {
            var _errs10 = errors;
            if (data0 !== null) {
              var err2 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var _valid1 = _errs10 === errors;
            valid2 = valid2 || _valid1;
            if (!valid2) {
              var _errs12 = errors;
              if (typeof data0 !== "boolean") {
                var err3 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var _valid1 = _errs12 === errors;
              valid2 = valid2 || _valid1;
              if (!valid2) {
                var _errs14 = errors;
                if (errors === _errs14) {
                  if (Array.isArray(data0)) {
                    var valid3 = true;
                    var len0 = data0.length;
                    for (var i0 = 0; i0 < len0; i0++) {
                      var _errs16 = errors;
                      if (!validate14(data0[i0], { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i0, parentData: data0, parentDataProperty: i0, rootData })) {
                        vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                        errors = vErrors.length;
                      }
                      var valid3 = _errs16 === errors;
                      if (!valid3) {
                        break;
                      }
                    }
                  } else {
                    var err4 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                }
                var _valid1 = _errs14 === errors;
                valid2 = valid2 || _valid1;
              }
            }
          }
        }
        if (!valid2) {
          var err5 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          errors = _errs5;
          if (vErrors !== null) {
            if (_errs5) {
              vErrors.length = _errs5;
            } else {
              vErrors = null;
            }
          }
        }
        var _valid0 = _errs4 === errors;
        valid1 = valid1 || _valid0;
        if (!valid1) {
          var _errs17 = errors;
          if (!wrapper1.validate(data0, { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data, parentDataProperty: key0, rootData })) {
            vErrors = vErrors === null ? wrapper1.validate.errors : vErrors.concat(wrapper1.validate.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs17 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            var _errs18 = errors;
            if (errors === _errs18) {
              if (Array.isArray(data0)) {
                var valid4 = true;
                var len1 = data0.length;
                for (var i1 = 0; i1 < len1; i1++) {
                  var _errs20 = errors;
                  if (!wrapper1.validate(data0[i1], { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data0, parentDataProperty: i1, rootData })) {
                    vErrors = vErrors === null ? wrapper1.validate.errors : vErrors.concat(wrapper1.validate.errors);
                    errors = vErrors.length;
                  }
                  var valid4 = _errs20 === errors;
                  if (!valid4) {
                    break;
                  }
                }
              } else {
                var err6 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            var _valid0 = _errs18 === errors;
            valid1 = valid1 || _valid0;
          }
        }
        if (!valid1) {
          var err7 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
          validate13.errors = vErrors;
          return false;
        } else {
          errors = _errs3;
          if (vErrors !== null) {
            if (_errs3) {
              vErrors.length = _errs3;
            } else {
              vErrors = null;
            }
          }
        }
        var valid0 = _errs2 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate13.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
function validate12(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var _errs1 = errors;
      for (var key0 in data) {
        if (!(key0 === "MARVEL_DESIGN_CREATOR")) {
          var _errs2 = errors;
          if (!validate13(data[key0], { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data, parentDataProperty: key0, rootData })) {
            vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs2 === errors;
          if (!valid0) {
            break;
          }
        }
      }
      if (_errs1 === errors) {
        if (data.MARVEL_DESIGN_CREATOR !== void 0) {
          var data1 = data.MARVEL_DESIGN_CREATOR;
          var _errs3 = errors;
          if (errors === _errs3) {
            if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
              var _errs5 = errors;
              for (var key1 in data1) {
                if (!(key1 === "version")) {
                  var data2 = data1[key1];
                  var _errs6 = errors;
                  var _errs7 = errors;
                  var valid3 = false;
                  var _errs8 = errors;
                  var _errs9 = errors;
                  var valid4 = false;
                  var _errs10 = errors;
                  if (typeof data2 !== "string") {
                    var err0 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err0];
                    } else {
                      vErrors.push(err0);
                    }
                    errors++;
                  }
                  var _valid1 = _errs10 === errors;
                  valid4 = valid4 || _valid1;
                  if (!valid4) {
                    var _errs12 = errors;
                    if (!(typeof data2 == "number" && isFinite(data2))) {
                      var err1 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                    var _valid1 = _errs12 === errors;
                    valid4 = valid4 || _valid1;
                    if (!valid4) {
                      var _errs14 = errors;
                      if (data2 !== null) {
                        var err2 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                        if (vErrors === null) {
                          vErrors = [err2];
                        } else {
                          vErrors.push(err2);
                        }
                        errors++;
                      }
                      var _valid1 = _errs14 === errors;
                      valid4 = valid4 || _valid1;
                      if (!valid4) {
                        var _errs16 = errors;
                        if (typeof data2 !== "boolean") {
                          var err3 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        var _valid1 = _errs16 === errors;
                        valid4 = valid4 || _valid1;
                        if (!valid4) {
                          var _errs18 = errors;
                          if (errors === _errs18) {
                            if (Array.isArray(data2)) {
                              var valid5 = true;
                              var len0 = data2.length;
                              for (var i0 = 0; i0 < len0; i0++) {
                                var _errs20 = errors;
                                if (!validate14(data2[i0], { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i0, parentData: data2, parentDataProperty: i0, rootData })) {
                                  vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                  errors = vErrors.length;
                                }
                                var valid5 = _errs20 === errors;
                                if (!valid5) {
                                  break;
                                }
                              }
                            } else {
                              var err4 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                              if (vErrors === null) {
                                vErrors = [err4];
                              } else {
                                vErrors.push(err4);
                              }
                              errors++;
                            }
                          }
                          var _valid1 = _errs18 === errors;
                          valid4 = valid4 || _valid1;
                        }
                      }
                    }
                  }
                  if (!valid4) {
                    var err5 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  } else {
                    errors = _errs9;
                    if (vErrors !== null) {
                      if (_errs9) {
                        vErrors.length = _errs9;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var _valid0 = _errs8 === errors;
                  valid3 = valid3 || _valid0;
                  if (!valid3) {
                    var _errs21 = errors;
                    if (!validate13(data2, { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data1, parentDataProperty: key1, rootData })) {
                      vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                      errors = vErrors.length;
                    }
                    var _valid0 = _errs21 === errors;
                    valid3 = valid3 || _valid0;
                    if (!valid3) {
                      var _errs22 = errors;
                      if (!Array.isArray(data2)) {
                        var err6 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                      var _valid0 = _errs22 === errors;
                      valid3 = valid3 || _valid0;
                    }
                  }
                  if (!valid3) {
                    var err7 = { instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                    validate12.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs7;
                    if (vErrors !== null) {
                      if (_errs7) {
                        vErrors.length = _errs7;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid2 = _errs6 === errors;
                  if (!valid2) {
                    break;
                  }
                }
              }
              if (_errs5 === errors) {
                if (data1.version !== void 0) {
                  if (typeof data1.version !== "string") {
                    validate12.errors = [{ instancePath: instancePath + "/MARVEL_DESIGN_CREATOR/version", schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                }
              }
            } else {
              validate12.errors = [{ instancePath: instancePath + "/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
              return false;
            }
          }
        }
      }
    } else {
      validate12.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate12.errors = vErrors;
  return errors === 0;
}
function validate21(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  var _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.name === void 0 && (missing0 = "name") || data.uuid === void 0 && (missing0 = "uuid") || data.type === void 0 && (missing0 = "type") || data.value === void 0 && (missing0 = "value")) {
        var err0 = { instancePath, schemaPath: "#/definitions/GroupToken/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        var _errs4 = errors;
        for (var key0 in data) {
          if (!(key0 === "name" || key0 === "uuid" || key0 === "type" || key0 === "value")) {
            var err1 = { instancePath, schemaPath: "#/definitions/GroupToken/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs4 === errors) {
          if (data.name !== void 0) {
            var _errs5 = errors;
            if (typeof data.name !== "string") {
              var err2 = { instancePath: instancePath + "/name", schemaPath: "#/definitions/GroupToken/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.uuid !== void 0) {
              var _errs7 = errors;
              if (typeof data.uuid !== "string") {
                var err3 = { instancePath: instancePath + "/uuid", schemaPath: "#/definitions/GroupToken/properties/uuid/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.type !== void 0) {
                var data2 = data.type;
                var _errs9 = errors;
                if (typeof data2 !== "string") {
                  var err4 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/GroupToken/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                if (data2 !== "group") {
                  var err5 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/GroupToken/properties/type/const", keyword: "const", params: { allowedValue: "group" }, message: "must be equal to constant" };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.value !== void 0) {
                  var data3 = data.value;
                  var _errs11 = errors;
                  if (errors === _errs11) {
                    if (Array.isArray(data3)) {
                      var valid3 = true;
                      var len0 = data3.length;
                      for (var i0 = 0; i0 < len0; i0++) {
                        var _errs13 = errors;
                        if (typeof data3[i0] !== "string") {
                          var err6 = { instancePath: instancePath + "/value/" + i0, schemaPath: "#/definitions/GroupToken/properties/value/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                        }
                        var valid3 = _errs13 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    } else {
                      var err7 = { instancePath: instancePath + "/value", schemaPath: "#/definitions/GroupToken/properties/value/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                      if (vErrors === null) {
                        vErrors = [err7];
                      } else {
                        vErrors.push(err7);
                      }
                      errors++;
                    }
                  }
                  var valid2 = _errs11 === errors;
                } else {
                  var valid2 = true;
                }
              }
            }
          }
        }
      }
    } else {
      var err8 = { instancePath, schemaPath: "#/definitions/GroupToken/type", keyword: "type", params: { type: "object" }, message: "must be object" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs15 = errors;
    var _errs16 = errors;
    if (errors === _errs16) {
      if (data && typeof data == "object" && !Array.isArray(data)) {
        var missing1 = void 0;
        if (data.name === void 0 && (missing1 = "name") || data.uuid === void 0 && (missing1 = "uuid") || data.type === void 0 && (missing1 = "type") || data.value === void 0 && (missing1 = "value")) {
          var err9 = { instancePath, schemaPath: "#/definitions/ColorToken/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        } else {
          var _errs18 = errors;
          for (var key1 in data) {
            if (!(key1 === "name" || key1 === "uuid" || key1 === "type" || key1 === "value")) {
              var err10 = { instancePath, schemaPath: "#/definitions/ColorToken/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
              break;
            }
          }
          if (_errs18 === errors) {
            if (data.name !== void 0) {
              var _errs19 = errors;
              if (typeof data.name !== "string") {
                var err11 = { instancePath: instancePath + "/name", schemaPath: "#/definitions/ColorToken/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              var valid5 = _errs19 === errors;
            } else {
              var valid5 = true;
            }
            if (valid5) {
              if (data.uuid !== void 0) {
                var _errs21 = errors;
                if (typeof data.uuid !== "string") {
                  var err12 = { instancePath: instancePath + "/uuid", schemaPath: "#/definitions/ColorToken/properties/uuid/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                var valid5 = _errs21 === errors;
              } else {
                var valid5 = true;
              }
              if (valid5) {
                if (data.type !== void 0) {
                  var data7 = data.type;
                  var _errs23 = errors;
                  if (typeof data7 !== "string") {
                    var err13 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/ColorToken/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                  if (data7 !== "color") {
                    var err14 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/ColorToken/properties/type/const", keyword: "const", params: { allowedValue: "color" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err14];
                    } else {
                      vErrors.push(err14);
                    }
                    errors++;
                  }
                  var valid5 = _errs23 === errors;
                } else {
                  var valid5 = true;
                }
                if (valid5) {
                  if (data.value !== void 0) {
                    var _errs25 = errors;
                    if (typeof data.value !== "string") {
                      var err15 = { instancePath: instancePath + "/value", schemaPath: "#/definitions/ColorToken/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                    var valid5 = _errs25 === errors;
                  } else {
                    var valid5 = true;
                  }
                }
              }
            }
          }
        }
      } else {
        var err16 = { instancePath, schemaPath: "#/definitions/ColorToken/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    var _valid0 = _errs15 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    var err17 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
    validate21.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate21.errors = vErrors;
  return errors === 0;
}
function validate20(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      for (var key0 in data) {
        var _errs2 = errors;
        if (!validate21(data[key0], { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data, parentDataProperty: key0, rootData })) {
          vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs2 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate20.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate20.errors = vErrors;
  return errors === 0;
}
var schema23 = { "type": "string", "enum": ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"] };
function validate28(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.rgbaValues === void 0 && (missing0 = "rgbaValues")) {
        validate28.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "className" || key0 === "rgbaValues")) {
            validate28.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate28.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Color") {
              validate28.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Color" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.rgbaValues !== void 0) {
              var data1 = data.rgbaValues;
              var _errs4 = errors;
              var _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data1)) {
                  if (data1.length > 4) {
                    validate28.errors = [{ instancePath: instancePath + "/rgbaValues", schemaPath: "#/definitions/RgbaColor/maxItems", keyword: "maxItems", params: { limit: 4 }, message: "must NOT have more than 4 items" }];
                    return false;
                  } else {
                    if (data1.length < 4) {
                      validate28.errors = [{ instancePath: instancePath + "/rgbaValues", schemaPath: "#/definitions/RgbaColor/minItems", keyword: "minItems", params: { limit: 4 }, message: "must NOT have fewer than 4 items" }];
                      return false;
                    } else {
                      var valid2 = true;
                      var len0 = data1.length;
                      for (var i0 = 0; i0 < len0; i0++) {
                        var data2 = data1[i0];
                        var _errs7 = errors;
                        if (!(typeof data2 == "number" && isFinite(data2))) {
                          validate28.errors = [{ instancePath: instancePath + "/rgbaValues/" + i0, schemaPath: "#/definitions/RgbaColor/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate28.errors = [{ instancePath: instancePath + "/rgbaValues", schemaPath: "#/definitions/RgbaColor/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate28.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate28.errors = vErrors;
  return errors === 0;
}
function validate32(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.color === void 0 && (missing0 = "color") || data.stopPosition === void 0 && (missing0 = "stopPosition")) {
        validate32.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "color" || key0 === "stopPosition")) {
            validate32.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.color !== void 0) {
            var _errs2 = errors;
            if (!validate28(data.color, { instancePath: instancePath + "/color", parentData: data, parentDataProperty: "color", rootData })) {
              vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.stopPosition !== void 0) {
              var data1 = data.stopPosition;
              var _errs3 = errors;
              if (!(typeof data1 == "number" && isFinite(data1))) {
                validate32.errors = [{ instancePath: instancePath + "/stopPosition", schemaPath: "#/properties/stopPosition/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate32.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
function validate31(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.from === void 0 && (missing0 = "from") || data.smoothenOpacity === void 0 && (missing0 = "smoothenOpacity") || data.stops === void 0 && (missing0 = "stops") || data.to === void 0 && (missing0 = "to") || data.type === void 0 && (missing0 = "type")) {
        validate31.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "type" || key0 === "from" || key0 === "to" || key0 === "smoothenOpacity" || key0 === "className" || key0 === "stops")) {
            validate31.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== void 0) {
            var data0 = data.type;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate31.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "linear") {
              validate31.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "linear" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.from !== void 0) {
              var data1 = data.from;
              var _errs4 = errors;
              var _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data1)) {
                  if (data1.length > 2) {
                    validate31.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                    return false;
                  } else {
                    if (data1.length < 2) {
                      validate31.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                      return false;
                    } else {
                      var valid2 = true;
                      var len0 = data1.length;
                      for (var i0 = 0; i0 < len0; i0++) {
                        var data2 = data1[i0];
                        var _errs7 = errors;
                        if (!(typeof data2 == "number" && isFinite(data2))) {
                          validate31.errors = [{ instancePath: instancePath + "/from/" + i0, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate31.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.to !== void 0) {
                var data3 = data.to;
                var _errs9 = errors;
                var _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data3)) {
                    if (data3.length > 2) {
                      validate31.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data3.length < 2) {
                        validate31.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid4 = true;
                        var len1 = data3.length;
                        for (var i1 = 0; i1 < len1; i1++) {
                          var data4 = data3[i1];
                          var _errs12 = errors;
                          if (!(typeof data4 == "number" && isFinite(data4))) {
                            validate31.errors = [{ instancePath: instancePath + "/to/" + i1, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid4 = _errs12 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate31.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.smoothenOpacity !== void 0) {
                  var _errs14 = errors;
                  if (typeof data.smoothenOpacity !== "boolean") {
                    validate31.errors = [{ instancePath: instancePath + "/smoothenOpacity", schemaPath: "#/properties/smoothenOpacity/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                    return false;
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.className !== void 0) {
                    var data6 = data.className;
                    var _errs16 = errors;
                    if (typeof data6 !== "string") {
                      validate31.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if (data6 !== "Gradient") {
                      validate31.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Gradient" }, message: "must be equal to constant" }];
                      return false;
                    }
                    var valid0 = _errs16 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.stops !== void 0) {
                      var data7 = data.stops;
                      var _errs18 = errors;
                      if (errors === _errs18) {
                        if (Array.isArray(data7)) {
                          var valid5 = true;
                          var len2 = data7.length;
                          for (var i2 = 0; i2 < len2; i2++) {
                            var _errs20 = errors;
                            if (!validate32(data7[i2], { instancePath: instancePath + "/stops/" + i2, parentData: data7, parentDataProperty: i2, rootData })) {
                              vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
                              errors = vErrors.length;
                            }
                            var valid5 = _errs20 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        } else {
                          validate31.errors = [{ instancePath: instancePath + "/stops", schemaPath: "#/properties/stops/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs18 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate31.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
function validate36(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.stops === void 0 && (missing0 = "stops") || data.type === void 0 && (missing0 = "type")) {
        validate36.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "type" || key0 === "className" || key0 === "stops")) {
            validate36.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== void 0) {
            var data0 = data.type;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate36.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "angular") {
              validate36.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "angular" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.className !== void 0) {
              var data1 = data.className;
              var _errs4 = errors;
              if (typeof data1 !== "string") {
                validate36.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (data1 !== "Gradient") {
                validate36.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Gradient" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.stops !== void 0) {
                var data2 = data.stops;
                var _errs6 = errors;
                if (errors === _errs6) {
                  if (Array.isArray(data2)) {
                    var valid1 = true;
                    var len0 = data2.length;
                    for (var i0 = 0; i0 < len0; i0++) {
                      var _errs8 = errors;
                      if (!validate32(data2[i0], { instancePath: instancePath + "/stops/" + i0, parentData: data2, parentDataProperty: i0, rootData })) {
                        vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs8 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                  } else {
                    validate36.errors = [{ instancePath: instancePath + "/stops", schemaPath: "#/properties/stops/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate36.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate36.errors = vErrors;
  return errors === 0;
}
function validate39(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.ellipseLength === void 0 && (missing0 = "ellipseLength") || data.from === void 0 && (missing0 = "from") || data.stops === void 0 && (missing0 = "stops") || data.to === void 0 && (missing0 = "to") || data.type === void 0 && (missing0 = "type")) {
        validate39.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "type" || key0 === "from" || key0 === "to" || key0 === "ellipseLength" || key0 === "className" || key0 === "stops")) {
            validate39.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== void 0) {
            var data0 = data.type;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate39.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "radial") {
              validate39.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/properties/type/const", keyword: "const", params: { allowedValue: "radial" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.from !== void 0) {
              var data1 = data.from;
              var _errs4 = errors;
              var _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data1)) {
                  if (data1.length > 2) {
                    validate39.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                    return false;
                  } else {
                    if (data1.length < 2) {
                      validate39.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                      return false;
                    } else {
                      var valid2 = true;
                      var len0 = data1.length;
                      for (var i0 = 0; i0 < len0; i0++) {
                        var data2 = data1[i0];
                        var _errs7 = errors;
                        if (!(typeof data2 == "number" && isFinite(data2))) {
                          validate39.errors = [{ instancePath: instancePath + "/from/" + i0, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate39.errors = [{ instancePath: instancePath + "/from", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.to !== void 0) {
                var data3 = data.to;
                var _errs9 = errors;
                var _errs10 = errors;
                if (errors === _errs10) {
                  if (Array.isArray(data3)) {
                    if (data3.length > 2) {
                      validate39.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data3.length < 2) {
                        validate39.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid4 = true;
                        var len1 = data3.length;
                        for (var i1 = 0; i1 < len1; i1++) {
                          var data4 = data3[i1];
                          var _errs12 = errors;
                          if (!(typeof data4 == "number" && isFinite(data4))) {
                            validate39.errors = [{ instancePath: instancePath + "/to/" + i1, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid4 = _errs12 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate39.errors = [{ instancePath: instancePath + "/to", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.ellipseLength !== void 0) {
                  var data5 = data.ellipseLength;
                  var _errs14 = errors;
                  if (!(typeof data5 == "number" && isFinite(data5))) {
                    validate39.errors = [{ instancePath: instancePath + "/ellipseLength", schemaPath: "#/properties/ellipseLength/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.className !== void 0) {
                    var data6 = data.className;
                    var _errs16 = errors;
                    if (typeof data6 !== "string") {
                      validate39.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    if (data6 !== "Gradient") {
                      validate39.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Gradient" }, message: "must be equal to constant" }];
                      return false;
                    }
                    var valid0 = _errs16 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.stops !== void 0) {
                      var data7 = data.stops;
                      var _errs18 = errors;
                      if (errors === _errs18) {
                        if (Array.isArray(data7)) {
                          var valid5 = true;
                          var len2 = data7.length;
                          for (var i2 = 0; i2 < len2; i2++) {
                            var _errs20 = errors;
                            if (!validate32(data7[i2], { instancePath: instancePath + "/stops/" + i2, parentData: data7, parentDataProperty: i2, rootData })) {
                              vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
                              errors = vErrors.length;
                            }
                            var valid5 = _errs20 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        } else {
                          validate39.errors = [{ instancePath: instancePath + "/stops", schemaPath: "#/properties/stops/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs18 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate39.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate39.errors = vErrors;
  return errors === 0;
}
function validate30(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  if (!validate31(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs2 = errors;
    if (!validate36(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      var _errs3 = errors;
      if (!validate39(data, { instancePath, parentData, parentDataProperty, rootData })) {
        vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs3 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    var err0 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate30.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
var schema37 = { "type": "string", "enum": ["fill", "fit", "stretch", "tile"] };
function validate43(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.type === void 0 && (missing0 = "type") || data.size === void 0 && (missing0 = "size") || data.source === void 0 && (missing0 = "source")) {
        validate43.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "className" || key0 === "type" || key0 === "size" || key0 === "source")) {
            validate43.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate43.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Pattern") {
              validate43.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Pattern" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.type !== void 0) {
              var data1 = data.type;
              var _errs4 = errors;
              if (typeof data1 !== "string") {
                validate43.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/definitions/PatternType/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "fill" || data1 === "fit" || data1 === "stretch" || data1 === "tile")) {
                validate43.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/definitions/PatternType/enum", keyword: "enum", params: { allowedValues: schema37.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.size !== void 0) {
                var data2 = data.size;
                var _errs7 = errors;
                var _errs8 = errors;
                if (errors === _errs8) {
                  if (Array.isArray(data2)) {
                    if (data2.length > 2) {
                      validate43.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data2.length < 2) {
                        validate43.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid3 = true;
                        var len0 = data2.length;
                        for (var i0 = 0; i0 < len0; i0++) {
                          var data3 = data2[i0];
                          var _errs10 = errors;
                          if (!(typeof data3 == "number" && isFinite(data3))) {
                            validate43.errors = [{ instancePath: instancePath + "/size/" + i0, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid3 = _errs10 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate43.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.source !== void 0) {
                  var _errs12 = errors;
                  if (typeof data.source !== "string") {
                    validate43.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate43.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate43.errors = vErrors;
  return errors === 0;
}
function validate27(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  if (!validate28(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs2 = errors;
    if (!validate30(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      var _errs3 = errors;
      if (!validate43(data, { instancePath, parentData, parentDataProperty, rootData })) {
        vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs3 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        var _errs4 = errors;
        var _errs5 = errors;
        if (errors === _errs5) {
          if (data && typeof data == "object" && !Array.isArray(data)) {
            var missing0 = void 0;
            if (data.className === void 0 && (missing0 = "className") || data.type === void 0 && (missing0 = "type") || data.size === void 0 && (missing0 = "size") || data.source === void 0 && (missing0 = "source")) {
              var err0 = { instancePath, schemaPath: "#/definitions/TokenInstance/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            } else {
              var _errs7 = errors;
              for (var key0 in data) {
                if (!(key0 === "className" || key0 === "type" || key0 === "size" || key0 === "source")) {
                  var err1 = { instancePath, schemaPath: "#/definitions/TokenInstance/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                  break;
                }
              }
              if (_errs7 === errors) {
                if (data.className !== void 0) {
                  var data0 = data.className;
                  var _errs8 = errors;
                  if (typeof data0 !== "string") {
                    var err2 = { instancePath: instancePath + "/className", schemaPath: "#/definitions/TokenInstance/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  if (data0 !== "Pattern") {
                    var err3 = { instancePath: instancePath + "/className", schemaPath: "#/definitions/TokenInstance/properties/className/const", keyword: "const", params: { allowedValue: "Pattern" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var valid2 = _errs8 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.type !== void 0) {
                    var data1 = data.type;
                    var _errs10 = errors;
                    if (typeof data1 !== "string") {
                      var err4 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/TokenInstance/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    if (data1 !== "fit") {
                      var err5 = { instancePath: instancePath + "/type", schemaPath: "#/definitions/TokenInstance/properties/type/const", keyword: "const", params: { allowedValue: "fit" }, message: "must be equal to constant" };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                    }
                    var valid2 = _errs10 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data.size !== void 0) {
                      var data2 = data.size;
                      var _errs12 = errors;
                      if (errors === _errs12) {
                        if (Array.isArray(data2)) {
                          if (data2.length > 2) {
                            var err6 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/TokenInstance/properties/size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                            if (vErrors === null) {
                              vErrors = [err6];
                            } else {
                              vErrors.push(err6);
                            }
                            errors++;
                          } else {
                            if (data2.length < 2) {
                              var err7 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/TokenInstance/properties/size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" };
                              if (vErrors === null) {
                                vErrors = [err7];
                              } else {
                                vErrors.push(err7);
                              }
                              errors++;
                            } else {
                              var valid3 = true;
                              var len0 = data2.length;
                              for (var i0 = 0; i0 < len0; i0++) {
                                var data3 = data2[i0];
                                var _errs14 = errors;
                                if (!(typeof data3 == "number" && isFinite(data3))) {
                                  var err8 = { instancePath: instancePath + "/size/" + i0, schemaPath: "#/definitions/TokenInstance/properties/size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                  if (vErrors === null) {
                                    vErrors = [err8];
                                  } else {
                                    vErrors.push(err8);
                                  }
                                  errors++;
                                }
                                if (data3 !== 1) {
                                  var err9 = { instancePath: instancePath + "/size/" + i0, schemaPath: "#/definitions/TokenInstance/properties/size/items/const", keyword: "const", params: { allowedValue: 1 }, message: "must be equal to constant" };
                                  if (vErrors === null) {
                                    vErrors = [err9];
                                  } else {
                                    vErrors.push(err9);
                                  }
                                  errors++;
                                }
                                var valid3 = _errs14 === errors;
                                if (!valid3) {
                                  break;
                                }
                              }
                            }
                          }
                        } else {
                          var err10 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/TokenInstance/properties/size/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        }
                      }
                      var valid2 = _errs12 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data.source !== void 0) {
                        var _errs16 = errors;
                        if (typeof data.source !== "string") {
                          var err11 = { instancePath: instancePath + "/source", schemaPath: "#/definitions/TokenInstance/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err11];
                          } else {
                            vErrors.push(err11);
                          }
                          errors++;
                        }
                        var valid2 = _errs16 === errors;
                      } else {
                        var valid2 = true;
                      }
                    }
                  }
                }
              }
            }
          } else {
            var err12 = { instancePath, schemaPath: "#/definitions/TokenInstance/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        var _valid0 = _errs4 === errors;
        valid0 = valid0 || _valid0;
      }
    }
  }
  if (!valid0) {
    var err13 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
    validate27.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
function validate26(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.blendMode === void 0 && (missing0 = "blendMode") || data.enabled === void 0 && (missing0 = "enabled") || data.content === void 0 && (missing0 = "content")) {
        validate26.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "className" || key0 === "blendMode" || key0 === "enabled" || key0 === "content")) {
            validate26.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate26.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Fill") {
              validate26.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Fill" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.blendMode !== void 0) {
              var data1 = data.blendMode;
              var _errs4 = errors;
              if (typeof data1 !== "string") {
                validate26.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "normal" || data1 === "multiply" || data1 === "screen" || data1 === "overlay" || data1 === "darken" || data1 === "lighten" || data1 === "color-dodge" || data1 === "color-burn" || data1 === "hard-light" || data1 === "soft-light" || data1 === "difference" || data1 === "exclusion" || data1 === "hue" || data1 === "saturation" || data1 === "color" || data1 === "luminosity")) {
                validate26.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.enabled !== void 0) {
                var _errs7 = errors;
                if (typeof data.enabled !== "boolean") {
                  validate26.errors = [{ instancePath: instancePath + "/enabled", schemaPath: "#/properties/enabled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.content !== void 0) {
                  var _errs9 = errors;
                  if (!validate27(data.content, { instancePath: instancePath + "/content", parentData: data, parentDataProperty: "content", rootData })) {
                    vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate26.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate26.errors = vErrors;
  return errors === 0;
}
function validate47(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      for (var key0 in data) {
        var _errs2 = errors;
        if (!validate13(data[key0], { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data, parentDataProperty: key0, rootData })) {
          vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs2 === errors;
        if (!valid0) {
          break;
        }
      }
    } else {
      validate47.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate47.errors = vErrors;
  return errors === 0;
}
function validate25(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.fills === void 0 && (missing0 = "fills") || data.point === void 0 && (missing0 = "point") || data.size === void 0 && (missing0 = "size") || data.pixelRatio === void 0 && (missing0 = "pixelRatio") || data.designRatio === void 0 && (missing0 = "designRatio")) {
        validate25.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "fills" || key0 === "point" || key0 === "size" || key0 === "pixelRatio" || key0 === "designRatio" || key0 === "className" || key0 === "layout")) {
            validate25.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.fills !== void 0) {
            var data0 = data.fills;
            var _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                var len0 = data0.length;
                for (var i0 = 0; i0 < len0; i0++) {
                  var _errs4 = errors;
                  if (!validate26(data0[i0], { instancePath: instancePath + "/fills/" + i0, parentData: data0, parentDataProperty: i0, rootData })) {
                    vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate25.errors = [{ instancePath: instancePath + "/fills", schemaPath: "#/properties/fills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.point !== void 0) {
              var data2 = data.point;
              var _errs5 = errors;
              var _errs6 = errors;
              if (errors === _errs6) {
                if (Array.isArray(data2)) {
                  if (data2.length > 2) {
                    validate25.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                    return false;
                  } else {
                    if (data2.length < 2) {
                      validate25.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                      return false;
                    } else {
                      var valid3 = true;
                      var len1 = data2.length;
                      for (var i1 = 0; i1 < len1; i1++) {
                        var data3 = data2[i1];
                        var _errs8 = errors;
                        if (!(typeof data3 == "number" && isFinite(data3))) {
                          validate25.errors = [{ instancePath: instancePath + "/point/" + i1, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid3 = _errs8 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate25.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.size !== void 0) {
                var data4 = data.size;
                var _errs10 = errors;
                var _errs11 = errors;
                if (errors === _errs11) {
                  if (Array.isArray(data4)) {
                    if (data4.length > 2) {
                      validate25.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data4.length < 2) {
                        validate25.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid5 = true;
                        var len2 = data4.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var data5 = data4[i2];
                          var _errs13 = errors;
                          if (!(typeof data5 == "number" && isFinite(data5))) {
                            validate25.errors = [{ instancePath: instancePath + "/size/" + i2, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid5 = _errs13 === errors;
                          if (!valid5) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate25.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.pixelRatio !== void 0) {
                  var data6 = data.pixelRatio;
                  var _errs15 = errors;
                  if (!(typeof data6 == "number" && isFinite(data6))) {
                    validate25.errors = [{ instancePath: instancePath + "/pixelRatio", schemaPath: "#/properties/pixelRatio/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.designRatio !== void 0) {
                    var data7 = data.designRatio;
                    var _errs17 = errors;
                    if (!(typeof data7 == "number" && isFinite(data7))) {
                      validate25.errors = [{ instancePath: instancePath + "/designRatio", schemaPath: "#/properties/designRatio/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                      return false;
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.className !== void 0) {
                      var data8 = data.className;
                      var _errs19 = errors;
                      if (typeof data8 !== "string") {
                        validate25.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      if (data8 !== "Artboard") {
                        validate25.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Artboard" }, message: "must be equal to constant" }];
                        return false;
                      }
                      var valid0 = _errs19 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.layout !== void 0) {
                        var _errs21 = errors;
                        if (!validate47(data.layout, { instancePath: instancePath + "/layout", parentData: data, parentDataProperty: "layout", rootData })) {
                          vErrors = vErrors === null ? validate47.errors : vErrors.concat(validate47.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs21 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate25.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate25.errors = vErrors;
  return errors === 0;
}
function validate24(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.artboard === void 0 && (missing0 = "artboard") || data.children === void 0 && (missing0 = "children") || data.className === void 0 && (missing0 = "className") || data.id === void 0 && (missing0 = "id") || data.title === void 0 && (missing0 = "title")) {
        validate24.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "children" || key0 === "className" || key0 === "artboard" || key0 === "title" || key0 === "size" || key0 === "id")) {
            validate24.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.children !== void 0) {
            var data0 = data.children;
            var _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                var len0 = data0.length;
                for (var i0 = 0; i0 < len0; i0++) {
                  var _errs4 = errors;
                  if (typeof data0[i0] !== "string") {
                    validate24.errors = [{ instancePath: instancePath + "/children/" + i0, schemaPath: "#/properties/children/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate24.errors = [{ instancePath: instancePath + "/children", schemaPath: "#/properties/children/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.className !== void 0) {
              var data2 = data.className;
              var _errs6 = errors;
              if (typeof data2 !== "string") {
                validate24.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (data2 !== "Canvas") {
                validate24.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Canvas" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.artboard !== void 0) {
                var _errs8 = errors;
                if (!validate25(data.artboard, { instancePath: instancePath + "/artboard", parentData: data, parentDataProperty: "artboard", rootData })) {
                  vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.title !== void 0) {
                  var _errs9 = errors;
                  if (typeof data.title !== "string") {
                    validate24.errors = [{ instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.size !== void 0) {
                    var data5 = data.size;
                    var _errs11 = errors;
                    var _errs12 = errors;
                    if (errors === _errs12) {
                      if (Array.isArray(data5)) {
                        if (data5.length > 2) {
                          validate24.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                          return false;
                        } else {
                          if (data5.length < 2) {
                            validate24.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                            return false;
                          } else {
                            var valid3 = true;
                            var len1 = data5.length;
                            for (var i1 = 0; i1 < len1; i1++) {
                              var data6 = data5[i1];
                              var _errs14 = errors;
                              if (!(typeof data6 == "number" && isFinite(data6))) {
                                validate24.errors = [{ instancePath: instancePath + "/size/" + i1, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                return false;
                              }
                              var valid3 = _errs14 === errors;
                              if (!valid3) {
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        validate24.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.id !== void 0) {
                      var _errs16 = errors;
                      if (typeof data.id !== "string") {
                        validate24.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                        return false;
                      }
                      var valid0 = _errs16 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate24.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate24.errors = vErrors;
  return errors === 0;
}
var schema45 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "Group" }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "children": { "type": "array", "items": { "type": "string" } }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalGroupData%2CJsonObject%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["children", "className", "fillStyle", "id", "itemProps", "parentId", "shadows", "strokeStyle", "strokes"] };
var func2 = Object.prototype.hasOwnProperty;
function validate54(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.blur === void 0 && (missing0 = "blur") || data.color === void 0 && (missing0 = "color") || data.enabled === void 0 && (missing0 = "enabled") || data.offset === void 0 && (missing0 = "offset") || data.shadowSpread === void 0 && (missing0 = "shadowSpread")) {
        validate54.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "className" || key0 === "blur" || key0 === "color" || key0 === "enabled" || key0 === "offset" || key0 === "shadowSpread")) {
            validate54.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate54.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Shadow") {
              validate54.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Shadow" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.blur !== void 0) {
              var data1 = data.blur;
              var _errs4 = errors;
              if (!(typeof data1 == "number" && isFinite(data1))) {
                validate54.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.color !== void 0) {
                var _errs6 = errors;
                if (!validate28(data.color, { instancePath: instancePath + "/color", parentData: data, parentDataProperty: "color", rootData })) {
                  vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.enabled !== void 0) {
                  var _errs7 = errors;
                  if (typeof data.enabled !== "boolean") {
                    validate54.errors = [{ instancePath: instancePath + "/enabled", schemaPath: "#/properties/enabled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.offset !== void 0) {
                    var data4 = data.offset;
                    var _errs9 = errors;
                    var _errs10 = errors;
                    if (errors === _errs10) {
                      if (Array.isArray(data4)) {
                        if (data4.length > 2) {
                          validate54.errors = [{ instancePath: instancePath + "/offset", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                          return false;
                        } else {
                          if (data4.length < 2) {
                            validate54.errors = [{ instancePath: instancePath + "/offset", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                            return false;
                          } else {
                            var valid2 = true;
                            var len0 = data4.length;
                            for (var i0 = 0; i0 < len0; i0++) {
                              var data5 = data4[i0];
                              var _errs12 = errors;
                              if (!(typeof data5 == "number" && isFinite(data5))) {
                                validate54.errors = [{ instancePath: instancePath + "/offset/" + i0, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                              if (!valid2) {
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        validate54.errors = [{ instancePath: instancePath + "/offset", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs9 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.shadowSpread !== void 0) {
                      var data6 = data.shadowSpread;
                      var _errs14 = errors;
                      if (!(typeof data6 == "number" && isFinite(data6))) {
                        validate54.errors = [{ instancePath: instancePath + "/shadowSpread", schemaPath: "#/properties/shadowSpread/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate54.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
var schema49 = { "type": "string", "enum": ["butt", "round", "square"] };
var schema50 = { "type": "string", "enum": ["bevel", "miter", "round"] };
function validate58(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.dashArray === void 0 && (missing0 = "dashArray") || data.dashOffset === void 0 && (missing0 = "dashOffset") || data.miterLimit === void 0 && (missing0 = "miterLimit") || data.strokeCap === void 0 && (missing0 = "strokeCap") || data.strokeJoin === void 0 && (missing0 = "strokeJoin")) {
        validate58.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "borderStyle" || key0 === "strokeAlign" || key0 === "strokeScaling" || key0 === "dashArray" || key0 === "dashOffset" || key0 === "miterLimit" || key0 === "strokeCap" || key0 === "strokeJoin")) {
            validate58.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.borderStyle !== void 0) {
            var _errs2 = errors;
            if (typeof data.borderStyle !== "string") {
              validate58.errors = [{ instancePath: instancePath + "/borderStyle", schemaPath: "#/properties/borderStyle/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.strokeAlign !== void 0) {
              var data1 = data.strokeAlign;
              var _errs4 = errors;
              if (typeof data1 !== "string") {
                validate58.errors = [{ instancePath: instancePath + "/strokeAlign", schemaPath: "#/properties/strokeAlign/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (data1 !== "center") {
                validate58.errors = [{ instancePath: instancePath + "/strokeAlign", schemaPath: "#/properties/strokeAlign/const", keyword: "const", params: { allowedValue: "center" }, message: "must be equal to constant" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.strokeScaling !== void 0) {
                var _errs6 = errors;
                if (typeof data.strokeScaling !== "boolean") {
                  validate58.errors = [{ instancePath: instancePath + "/strokeScaling", schemaPath: "#/properties/strokeScaling/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.dashArray !== void 0) {
                  var data3 = data.dashArray;
                  var _errs8 = errors;
                  if (errors === _errs8) {
                    if (Array.isArray(data3)) {
                      var valid1 = true;
                      var len0 = data3.length;
                      for (var i0 = 0; i0 < len0; i0++) {
                        var data4 = data3[i0];
                        var _errs10 = errors;
                        if (!(typeof data4 == "number" && isFinite(data4))) {
                          validate58.errors = [{ instancePath: instancePath + "/dashArray/" + i0, schemaPath: "#/properties/dashArray/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid1 = _errs10 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate58.errors = [{ instancePath: instancePath + "/dashArray", schemaPath: "#/properties/dashArray/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.dashOffset !== void 0) {
                    var data5 = data.dashOffset;
                    var _errs12 = errors;
                    if (!(typeof data5 == "number" && isFinite(data5))) {
                      validate58.errors = [{ instancePath: instancePath + "/dashOffset", schemaPath: "#/properties/dashOffset/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.miterLimit !== void 0) {
                      var data6 = data.miterLimit;
                      var _errs14 = errors;
                      if (!(typeof data6 == "number" && isFinite(data6))) {
                        validate58.errors = [{ instancePath: instancePath + "/miterLimit", schemaPath: "#/properties/miterLimit/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.strokeCap !== void 0) {
                        var data7 = data.strokeCap;
                        var _errs16 = errors;
                        if (typeof data7 !== "string") {
                          validate58.errors = [{ instancePath: instancePath + "/strokeCap", schemaPath: "#/definitions/StrokeCap/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                          return false;
                        }
                        if (!(data7 === "butt" || data7 === "round" || data7 === "square")) {
                          validate58.errors = [{ instancePath: instancePath + "/strokeCap", schemaPath: "#/definitions/StrokeCap/enum", keyword: "enum", params: { allowedValues: schema49.enum }, message: "must be equal to one of the allowed values" }];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.strokeJoin !== void 0) {
                          var data8 = data.strokeJoin;
                          var _errs19 = errors;
                          if (typeof data8 !== "string") {
                            validate58.errors = [{ instancePath: instancePath + "/strokeJoin", schemaPath: "#/definitions/StrokeJoin/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                          }
                          if (!(data8 === "bevel" || data8 === "miter" || data8 === "round")) {
                            validate58.errors = [{ instancePath: instancePath + "/strokeJoin", schemaPath: "#/definitions/StrokeJoin/enum", keyword: "enum", params: { allowedValues: schema50.enum }, message: "must be equal to one of the allowed values" }];
                            return false;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate58.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate58.errors = vErrors;
  return errors === 0;
}
var schema52 = { "type": "string", "enum": ["center", "inside", "outside"] };
function validate60(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.color === void 0 && (missing0 = "color") || data.enabled === void 0 && (missing0 = "enabled") || data.strokePosition === void 0 && (missing0 = "strokePosition") || data.width === void 0 && (missing0 = "width")) {
        validate60.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "className" || key0 === "color" || key0 === "enabled" || key0 === "strokePosition" || key0 === "width")) {
            validate60.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate60.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Stroke") {
              validate60.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Stroke" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.color !== void 0) {
              var _errs4 = errors;
              if (!validate28(data.color, { instancePath: instancePath + "/color", parentData: data, parentDataProperty: "color", rootData })) {
                vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.enabled !== void 0) {
                var _errs5 = errors;
                if (typeof data.enabled !== "boolean") {
                  validate60.errors = [{ instancePath: instancePath + "/enabled", schemaPath: "#/properties/enabled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.strokePosition !== void 0) {
                  var data3 = data.strokePosition;
                  var _errs7 = errors;
                  if (typeof data3 !== "string") {
                    validate60.errors = [{ instancePath: instancePath + "/strokePosition", schemaPath: "#/definitions/StrokePosition/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (!(data3 === "center" || data3 === "inside" || data3 === "outside")) {
                    validate60.errors = [{ instancePath: instancePath + "/strokePosition", schemaPath: "#/definitions/StrokePosition/enum", keyword: "enum", params: { allowedValues: schema52.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.width !== void 0) {
                    var data4 = data.width;
                    var _errs10 = errors;
                    if (!(typeof data4 == "number" && isFinite(data4))) {
                      validate60.errors = [{ instancePath: instancePath + "/width", schemaPath: "#/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate60.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate60.errors = vErrors;
  return errors === 0;
}
var schema54 = { "type": "string", "enum": ["nonzero", "evenodd"] };
function validate63(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.fills === void 0 && (missing0 = "fills") || data.fillRule === void 0 && (missing0 = "fillRule")) {
        validate63.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "fills" || key0 === "fillRule")) {
            validate63.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.fills !== void 0) {
            var data0 = data.fills;
            var _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                var len0 = data0.length;
                for (var i0 = 0; i0 < len0; i0++) {
                  var _errs4 = errors;
                  if (!validate26(data0[i0], { instancePath: instancePath + "/fills/" + i0, parentData: data0, parentDataProperty: i0, rootData })) {
                    vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate63.errors = [{ instancePath: instancePath + "/fills", schemaPath: "#/properties/fills/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.fillRule !== void 0) {
              var data2 = data.fillRule;
              var _errs5 = errors;
              if (typeof data2 !== "string") {
                validate63.errors = [{ instancePath: instancePath + "/fillRule", schemaPath: "#/definitions/FillRule/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data2 === "nonzero" || data2 === "evenodd")) {
                validate63.errors = [{ instancePath: instancePath + "/fillRule", schemaPath: "#/definitions/FillRule/enum", keyword: "enum", params: { allowedValues: schema54.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate63.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate63.errors = vErrors;
  return errors === 0;
}
var schema55 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
function validate71(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.point === void 0 && (missing0 = "point") || data.size === void 0 && (missing0 = "size")) {
        validate71.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "point" || key0 === "size")) {
            validate71.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.point !== void 0) {
            var data0 = data.point;
            var _errs2 = errors;
            var _errs3 = errors;
            if (errors === _errs3) {
              if (Array.isArray(data0)) {
                if (data0.length > 2) {
                  validate71.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                  return false;
                } else {
                  if (data0.length < 2) {
                    validate71.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                    return false;
                  } else {
                    var valid2 = true;
                    var len0 = data0.length;
                    for (var i0 = 0; i0 < len0; i0++) {
                      var data1 = data0[i0];
                      var _errs5 = errors;
                      if (!(typeof data1 == "number" && isFinite(data1))) {
                        validate71.errors = [{ instancePath: instancePath + "/point/" + i0, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                        return false;
                      }
                      var valid2 = _errs5 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  }
                }
              } else {
                validate71.errors = [{ instancePath: instancePath + "/point", schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.size !== void 0) {
              var data2 = data.size;
              var _errs7 = errors;
              var _errs8 = errors;
              if (errors === _errs8) {
                if (Array.isArray(data2)) {
                  if (data2.length > 2) {
                    validate71.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                    return false;
                  } else {
                    if (data2.length < 2) {
                      validate71.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                      return false;
                    } else {
                      var valid4 = true;
                      var len1 = data2.length;
                      for (var i1 = 0; i1 < len1; i1++) {
                        var data3 = data2[i1];
                        var _errs10 = errors;
                        if (!(typeof data3 == "number" && isFinite(data3))) {
                          validate71.errors = [{ instancePath: instancePath + "/size/" + i1, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                          return false;
                        }
                        var valid4 = _errs10 === errors;
                        if (!valid4) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate71.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate71.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
function validate66(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate66.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema55.properties, key0)) {
            validate66.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate66.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate66.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema55.properties.assets.items.properties, key1)) {
                              validate66.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate66.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate66.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate66.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate66.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate66.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate66.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                          vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                          errors = vErrors.length;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                        if (!valid7) {
                                          var _errs58 = errors;
                                          if (!Array.isArray(data18)) {
                                            var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                            if (vErrors === null) {
                                              vErrors = [err6];
                                            } else {
                                              vErrors.push(err6);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs58 === errors;
                                          valid7 = valid7 || _valid0;
                                        }
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate66.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.frame !== void 0) {
                                    var data20 = data17.frame;
                                    var _errs60 = errors;
                                    var _errs61 = errors;
                                    var valid11 = false;
                                    var _errs62 = errors;
                                    if (!validate71(data20, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                      vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                      errors = vErrors.length;
                                    }
                                    var _valid2 = _errs62 === errors;
                                    valid11 = valid11 || _valid2;
                                    if (!valid11) {
                                      var _errs63 = errors;
                                      if (data20 !== null) {
                                        var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err8];
                                        } else {
                                          vErrors.push(err8);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs63 === errors;
                                      valid11 = valid11 || _valid2;
                                    }
                                    if (!valid11) {
                                      var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err9];
                                      } else {
                                        vErrors.push(err9);
                                      }
                                      errors++;
                                      validate66.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs61;
                                      if (vErrors !== null) {
                                        if (_errs61) {
                                          vErrors.length = _errs61;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid10 = _errs60 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.extrema !== void 0) {
                                      var data21 = data17.extrema;
                                      var _errs65 = errors;
                                      if (errors === _errs65) {
                                        if (Array.isArray(data21)) {
                                          var valid12 = true;
                                          var len2 = data21.length;
                                          for (var i2 = 0; i2 < len2; i2++) {
                                            var data22 = data21[i2];
                                            var _errs67 = errors;
                                            var _errs68 = errors;
                                            if (errors === _errs68) {
                                              if (Array.isArray(data22)) {
                                                if (data22.length > 2) {
                                                  validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                  return false;
                                                } else {
                                                  if (data22.length < 2) {
                                                    validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                    return false;
                                                  } else {
                                                    var valid14 = true;
                                                    var len3 = data22.length;
                                                    for (var i3 = 0; i3 < len3; i3++) {
                                                      var data23 = data22[i3];
                                                      var _errs70 = errors;
                                                      if (!(typeof data23 == "number" && isFinite(data23))) {
                                                        validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                        return false;
                                                      }
                                                      var valid14 = _errs70 === errors;
                                                      if (!valid14) {
                                                        break;
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                return false;
                                              }
                                            }
                                            var valid12 = _errs67 === errors;
                                            if (!valid12) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                          return false;
                                        }
                                      }
                                      var valid10 = _errs65 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.isAspectRatioLocked !== void 0) {
                                        var _errs72 = errors;
                                        if (typeof data17.isAspectRatioLocked !== "boolean") {
                                          validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                          return false;
                                        }
                                        var valid10 = _errs72 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.uploaded !== void 0) {
                                          var data25 = data17.uploaded;
                                          var _errs74 = errors;
                                          var _errs75 = errors;
                                          var valid15 = false;
                                          var _errs76 = errors;
                                          if (errors === _errs76) {
                                            if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                                              for (var key4 in data25) {
                                                var _errs79 = errors;
                                                if (typeof data25[key4] !== "boolean") {
                                                  var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                  if (vErrors === null) {
                                                    vErrors = [err10];
                                                  } else {
                                                    vErrors.push(err10);
                                                  }
                                                  errors++;
                                                }
                                                var valid16 = _errs79 === errors;
                                                if (!valid16) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                              if (vErrors === null) {
                                                vErrors = [err11];
                                              } else {
                                                vErrors.push(err11);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid3 = _errs76 === errors;
                                          valid15 = valid15 || _valid3;
                                          if (!valid15) {
                                            var _errs81 = errors;
                                            if (typeof data25 !== "boolean") {
                                              var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                              if (vErrors === null) {
                                                vErrors = [err12];
                                              } else {
                                                vErrors.push(err12);
                                              }
                                              errors++;
                                            }
                                            var _valid3 = _errs81 === errors;
                                            valid15 = valid15 || _valid3;
                                          }
                                          if (!valid15) {
                                            var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                            validate66.errors = vErrors;
                                            return false;
                                          } else {
                                            errors = _errs75;
                                            if (vErrors !== null) {
                                              if (_errs75) {
                                                vErrors.length = _errs75;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate66.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate66.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs83 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate66.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs83 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs85 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate66.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs85 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs87 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate66.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs87 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs89 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate66.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs89 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data31 = data.matrix;
                              var _errs91 = errors;
                              var _errs92 = errors;
                              if (errors === _errs92) {
                                if (Array.isArray(data31)) {
                                  if (data31.length > 6) {
                                    validate66.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data31.length < 6) {
                                      validate66.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid18 = true;
                                      var len4 = data31.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data32 = data31[i4];
                                        var _errs94 = errors;
                                        if (!(typeof data32 == "number" && isFinite(data32))) {
                                          validate66.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid18 = _errs94 === errors;
                                        if (!valid18) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate66.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs91 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs96 = errors;
                                if (typeof data.name !== "string") {
                                  validate66.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs96 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data34 = data.opacity;
                                  var _errs98 = errors;
                                  if (!(typeof data34 == "number" && isFinite(data34))) {
                                    validate66.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs98 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate66.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate66.errors = vErrors;
  return errors === 0;
}
function validate53(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.children === void 0 && (missing0 = "children") || data.className === void 0 && (missing0 = "className") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.shadows === void 0 && (missing0 = "shadows") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes")) {
        validate53.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema45.properties, key0)) {
            validate53.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate53.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Group") {
              validate53.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Group" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.innerShadows !== void 0) {
              var data1 = data.innerShadows;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var _errs6 = errors;
                    if (!validate54(data1[i0], { instancePath: instancePath + "/innerShadows/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
                      vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate53.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.shadows !== void 0) {
                var data3 = data.shadows;
                var _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data3)) {
                    var valid2 = true;
                    var len1 = data3.length;
                    for (var i1 = 0; i1 < len1; i1++) {
                      var _errs9 = errors;
                      if (!validate54(data3[i1], { instancePath: instancePath + "/shadows/" + i1, parentData: data3, parentDataProperty: i1, rootData })) {
                        vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate53.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.strokeStyle !== void 0) {
                  var _errs10 = errors;
                  if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                    vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.strokes !== void 0) {
                    var data6 = data.strokes;
                    var _errs11 = errors;
                    if (errors === _errs11) {
                      if (Array.isArray(data6)) {
                        var valid3 = true;
                        var len2 = data6.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var _errs13 = errors;
                          if (!validate60(data6[i2], { instancePath: instancePath + "/strokes/" + i2, parentData: data6, parentDataProperty: i2, rootData })) {
                            vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                            errors = vErrors.length;
                          }
                          var valid3 = _errs13 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        validate53.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.fillStyle !== void 0) {
                      var _errs14 = errors;
                      if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                        vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.children !== void 0) {
                        var data9 = data.children;
                        var _errs15 = errors;
                        if (errors === _errs15) {
                          if (Array.isArray(data9)) {
                            var valid4 = true;
                            var len3 = data9.length;
                            for (var i3 = 0; i3 < len3; i3++) {
                              var _errs17 = errors;
                              if (typeof data9[i3] !== "string") {
                                validate53.errors = [{ instancePath: instancePath + "/children/" + i3, schemaPath: "#/properties/children/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid4 = _errs17 === errors;
                              if (!valid4) {
                                break;
                              }
                            }
                          } else {
                            validate53.errors = [{ instancePath: instancePath + "/children", schemaPath: "#/properties/children/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.itemProps !== void 0) {
                          var _errs19 = errors;
                          if (!validate66(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                            vErrors = vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.parentId !== void 0) {
                            var data12 = data.parentId;
                            var _errs20 = errors;
                            if (typeof data12 !== "string" && data12 !== null) {
                              validate53.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema45.properties.parentId.type }, message: "must be string,null" }];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.id !== void 0) {
                              var _errs22 = errors;
                              if (typeof data.id !== "string") {
                                validate53.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate53.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
var schema62 = { "type": "object", "additionalProperties": false, "properties": { "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "size": { "$ref": "#/definitions/Size" }, "className": { "type": "string", "const": "Mask" }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "children": { "type": "array", "items": { "type": "string" } }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalMaskData%2CJsonObject%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["children", "className", "fillStyle", "id", "itemProps", "parentId", "strokeStyle", "strokes"] };
var schema64 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
function validate81(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate81.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema64.properties, key0)) {
            validate81.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate81.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate81.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema64.properties.assets.items.properties, key1)) {
                              validate81.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate81.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate81.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate81.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate81.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate81.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate81.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                          vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                          errors = vErrors.length;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                        if (!valid7) {
                                          var _errs58 = errors;
                                          if (!Array.isArray(data18)) {
                                            var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                            if (vErrors === null) {
                                              vErrors = [err6];
                                            } else {
                                              vErrors.push(err6);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs58 === errors;
                                          valid7 = valid7 || _valid0;
                                        }
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate81.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.frame !== void 0) {
                                    var data20 = data17.frame;
                                    var _errs60 = errors;
                                    var _errs61 = errors;
                                    var valid11 = false;
                                    var _errs62 = errors;
                                    if (!validate71(data20, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                      vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                      errors = vErrors.length;
                                    }
                                    var _valid2 = _errs62 === errors;
                                    valid11 = valid11 || _valid2;
                                    if (!valid11) {
                                      var _errs63 = errors;
                                      if (data20 !== null) {
                                        var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err8];
                                        } else {
                                          vErrors.push(err8);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs63 === errors;
                                      valid11 = valid11 || _valid2;
                                    }
                                    if (!valid11) {
                                      var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err9];
                                      } else {
                                        vErrors.push(err9);
                                      }
                                      errors++;
                                      validate81.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs61;
                                      if (vErrors !== null) {
                                        if (_errs61) {
                                          vErrors.length = _errs61;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid10 = _errs60 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.extrema !== void 0) {
                                      var data21 = data17.extrema;
                                      var _errs65 = errors;
                                      if (errors === _errs65) {
                                        if (Array.isArray(data21)) {
                                          var valid12 = true;
                                          var len2 = data21.length;
                                          for (var i2 = 0; i2 < len2; i2++) {
                                            var data22 = data21[i2];
                                            var _errs67 = errors;
                                            var _errs68 = errors;
                                            if (errors === _errs68) {
                                              if (Array.isArray(data22)) {
                                                if (data22.length > 2) {
                                                  validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                  return false;
                                                } else {
                                                  if (data22.length < 2) {
                                                    validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                    return false;
                                                  } else {
                                                    var valid14 = true;
                                                    var len3 = data22.length;
                                                    for (var i3 = 0; i3 < len3; i3++) {
                                                      var data23 = data22[i3];
                                                      var _errs70 = errors;
                                                      if (!(typeof data23 == "number" && isFinite(data23))) {
                                                        validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                        return false;
                                                      }
                                                      var valid14 = _errs70 === errors;
                                                      if (!valid14) {
                                                        break;
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                return false;
                                              }
                                            }
                                            var valid12 = _errs67 === errors;
                                            if (!valid12) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                          return false;
                                        }
                                      }
                                      var valid10 = _errs65 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.isAspectRatioLocked !== void 0) {
                                        var _errs72 = errors;
                                        if (typeof data17.isAspectRatioLocked !== "boolean") {
                                          validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                          return false;
                                        }
                                        var valid10 = _errs72 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.uploaded !== void 0) {
                                          var data25 = data17.uploaded;
                                          var _errs74 = errors;
                                          var _errs75 = errors;
                                          var valid15 = false;
                                          var _errs76 = errors;
                                          if (errors === _errs76) {
                                            if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                                              for (var key4 in data25) {
                                                var _errs79 = errors;
                                                if (typeof data25[key4] !== "boolean") {
                                                  var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                  if (vErrors === null) {
                                                    vErrors = [err10];
                                                  } else {
                                                    vErrors.push(err10);
                                                  }
                                                  errors++;
                                                }
                                                var valid16 = _errs79 === errors;
                                                if (!valid16) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                              if (vErrors === null) {
                                                vErrors = [err11];
                                              } else {
                                                vErrors.push(err11);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid3 = _errs76 === errors;
                                          valid15 = valid15 || _valid3;
                                          if (!valid15) {
                                            var _errs81 = errors;
                                            if (typeof data25 !== "boolean") {
                                              var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                              if (vErrors === null) {
                                                vErrors = [err12];
                                              } else {
                                                vErrors.push(err12);
                                              }
                                              errors++;
                                            }
                                            var _valid3 = _errs81 === errors;
                                            valid15 = valid15 || _valid3;
                                          }
                                          if (!valid15) {
                                            var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                            validate81.errors = vErrors;
                                            return false;
                                          } else {
                                            errors = _errs75;
                                            if (vErrors !== null) {
                                              if (_errs75) {
                                                vErrors.length = _errs75;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate81.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate81.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs83 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate81.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs83 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs85 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate81.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs85 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs87 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate81.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs87 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs89 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate81.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs89 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data31 = data.matrix;
                              var _errs91 = errors;
                              var _errs92 = errors;
                              if (errors === _errs92) {
                                if (Array.isArray(data31)) {
                                  if (data31.length > 6) {
                                    validate81.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data31.length < 6) {
                                      validate81.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid18 = true;
                                      var len4 = data31.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data32 = data31[i4];
                                        var _errs94 = errors;
                                        if (!(typeof data32 == "number" && isFinite(data32))) {
                                          validate81.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid18 = _errs94 === errors;
                                        if (!valid18) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate81.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs91 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs96 = errors;
                                if (typeof data.name !== "string") {
                                  validate81.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs96 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data34 = data.opacity;
                                  var _errs98 = errors;
                                  if (!(typeof data34 == "number" && isFinite(data34))) {
                                    validate81.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs98 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate81.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate81.errors = vErrors;
  return errors === 0;
}
function validate75(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.children === void 0 && (missing0 = "children") || data.className === void 0 && (missing0 = "className") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes")) {
        validate75.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema62.properties, key0)) {
            validate75.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.innerShadows !== void 0) {
            var data0 = data.innerShadows;
            var _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                var len0 = data0.length;
                for (var i0 = 0; i0 < len0; i0++) {
                  var _errs4 = errors;
                  if (!validate54(data0[i0], { instancePath: instancePath + "/innerShadows/" + i0, parentData: data0, parentDataProperty: i0, rootData })) {
                    vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                    errors = vErrors.length;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate75.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.shadows !== void 0) {
              var data2 = data.shadows;
              var _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data2)) {
                  var valid2 = true;
                  var len1 = data2.length;
                  for (var i1 = 0; i1 < len1; i1++) {
                    var _errs7 = errors;
                    if (!validate54(data2[i1], { instancePath: instancePath + "/shadows/" + i1, parentData: data2, parentDataProperty: i1, rootData })) {
                      vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                      errors = vErrors.length;
                    }
                    var valid2 = _errs7 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate75.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.size !== void 0) {
                var data4 = data.size;
                var _errs8 = errors;
                var _errs9 = errors;
                if (errors === _errs9) {
                  if (Array.isArray(data4)) {
                    if (data4.length > 2) {
                      validate75.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data4.length < 2) {
                        validate75.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid4 = true;
                        var len2 = data4.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var data5 = data4[i2];
                          var _errs11 = errors;
                          if (!(typeof data5 == "number" && isFinite(data5))) {
                            validate75.errors = [{ instancePath: instancePath + "/size/" + i2, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid4 = _errs11 === errors;
                          if (!valid4) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate75.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.className !== void 0) {
                  var data6 = data.className;
                  var _errs13 = errors;
                  if (typeof data6 !== "string") {
                    validate75.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  if (data6 !== "Mask") {
                    validate75.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Mask" }, message: "must be equal to constant" }];
                    return false;
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.strokeStyle !== void 0) {
                    var _errs15 = errors;
                    if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                      vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs15 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.strokes !== void 0) {
                      var data8 = data.strokes;
                      var _errs16 = errors;
                      if (errors === _errs16) {
                        if (Array.isArray(data8)) {
                          var valid5 = true;
                          var len3 = data8.length;
                          for (var i3 = 0; i3 < len3; i3++) {
                            var _errs18 = errors;
                            if (!validate60(data8[i3], { instancePath: instancePath + "/strokes/" + i3, parentData: data8, parentDataProperty: i3, rootData })) {
                              vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                              errors = vErrors.length;
                            }
                            var valid5 = _errs18 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        } else {
                          validate75.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs16 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.fillStyle !== void 0) {
                        var _errs19 = errors;
                        if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                          vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.children !== void 0) {
                          var data11 = data.children;
                          var _errs20 = errors;
                          if (errors === _errs20) {
                            if (Array.isArray(data11)) {
                              var valid6 = true;
                              var len4 = data11.length;
                              for (var i4 = 0; i4 < len4; i4++) {
                                var _errs22 = errors;
                                if (typeof data11[i4] !== "string") {
                                  validate75.errors = [{ instancePath: instancePath + "/children/" + i4, schemaPath: "#/properties/children/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid6 = _errs22 === errors;
                                if (!valid6) {
                                  break;
                                }
                              }
                            } else {
                              validate75.errors = [{ instancePath: instancePath + "/children", schemaPath: "#/properties/children/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid0 = _errs20 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.itemProps !== void 0) {
                            var _errs24 = errors;
                            if (!validate81(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                              vErrors = vErrors === null ? validate81.errors : vErrors.concat(validate81.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs24 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.parentId !== void 0) {
                              var data14 = data.parentId;
                              var _errs25 = errors;
                              if (typeof data14 !== "string" && data14 !== null) {
                                validate75.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema62.properties.parentId.type }, message: "must be string,null" }];
                                return false;
                              }
                              var valid0 = _errs25 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.id !== void 0) {
                                var _errs27 = errors;
                                if (typeof data.id !== "string") {
                                  validate75.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs27 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate75.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate75.errors = vErrors;
  return errors === 0;
}
var schema68 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "Raster" }, "source": { "type": "string" }, "originalSource": { "type": "string" }, "crossOrigin": { "type": "string" }, "size": { "$ref": "#/definitions/Size" }, "radius": { "type": "array", "items": { "type": "number" }, "minItems": 4, "maxItems": 4 }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "itemProps": { "$ref": "#/definitions/ItemProps%3Cinterface-1158747822-11789-11954-1158747822-0-14894%2Calias-1158747822-11716-11789-1158747822-0-14894%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["className", "crossOrigin", "fillStyle", "id", "innerShadows", "itemProps", "originalSource", "parentId", "radius", "shadows", "size", "source", "strokeStyle", "strokes"] };
var schema70 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "FORMAT": { "$ref": "#/definitions/Format" }, "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
function validate95(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate95.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema70.properties, key0)) {
            validate95.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate95.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate95.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema70.properties.assets.items.properties, key1)) {
                              validate95.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate95.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate95.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate95.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate95.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate95.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate95.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "FORMAT" || key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!Array.isArray(data18)) {
                                          var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate95.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.FORMAT !== void 0) {
                                    var data20 = data17.FORMAT;
                                    var _errs59 = errors;
                                    if (typeof data20 !== "string") {
                                      validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/FORMAT", schemaPath: "#/definitions/Format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (data20 !== "svg") {
                                      validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/FORMAT", schemaPath: "#/definitions/Format/const", keyword: "const", params: { allowedValue: "svg" }, message: "must be equal to constant" }];
                                      return false;
                                    }
                                    var valid10 = _errs59 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.frame !== void 0) {
                                      var data21 = data17.frame;
                                      var _errs62 = errors;
                                      var _errs63 = errors;
                                      var valid12 = false;
                                      var _errs64 = errors;
                                      if (!validate71(data21, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                        vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid2 = _errs64 === errors;
                                      valid12 = valid12 || _valid2;
                                      if (!valid12) {
                                        var _errs65 = errors;
                                        if (data21 !== null) {
                                          var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        }
                                        var _valid2 = _errs65 === errors;
                                        valid12 = valid12 || _valid2;
                                      }
                                      if (!valid12) {
                                        var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err9];
                                        } else {
                                          vErrors.push(err9);
                                        }
                                        errors++;
                                        validate95.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs63;
                                        if (vErrors !== null) {
                                          if (_errs63) {
                                            vErrors.length = _errs63;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid10 = _errs62 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.extrema !== void 0) {
                                        var data22 = data17.extrema;
                                        var _errs67 = errors;
                                        if (errors === _errs67) {
                                          if (Array.isArray(data22)) {
                                            var valid13 = true;
                                            var len2 = data22.length;
                                            for (var i2 = 0; i2 < len2; i2++) {
                                              var data23 = data22[i2];
                                              var _errs69 = errors;
                                              var _errs70 = errors;
                                              if (errors === _errs70) {
                                                if (Array.isArray(data23)) {
                                                  if (data23.length > 2) {
                                                    validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                    return false;
                                                  } else {
                                                    if (data23.length < 2) {
                                                      validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                      return false;
                                                    } else {
                                                      var valid15 = true;
                                                      var len3 = data23.length;
                                                      for (var i3 = 0; i3 < len3; i3++) {
                                                        var data24 = data23[i3];
                                                        var _errs72 = errors;
                                                        if (!(typeof data24 == "number" && isFinite(data24))) {
                                                          validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                          return false;
                                                        }
                                                        var valid15 = _errs72 === errors;
                                                        if (!valid15) {
                                                          break;
                                                        }
                                                      }
                                                    }
                                                  }
                                                } else {
                                                  validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                  return false;
                                                }
                                              }
                                              var valid13 = _errs69 === errors;
                                              if (!valid13) {
                                                break;
                                              }
                                            }
                                          } else {
                                            validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                            return false;
                                          }
                                        }
                                        var valid10 = _errs67 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.isAspectRatioLocked !== void 0) {
                                          var _errs74 = errors;
                                          if (typeof data17.isAspectRatioLocked !== "boolean") {
                                            validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                            return false;
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                        if (valid10) {
                                          if (data17.uploaded !== void 0) {
                                            var data26 = data17.uploaded;
                                            var _errs76 = errors;
                                            var _errs77 = errors;
                                            var valid16 = false;
                                            var _errs78 = errors;
                                            if (errors === _errs78) {
                                              if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
                                                for (var key4 in data26) {
                                                  var _errs81 = errors;
                                                  if (typeof data26[key4] !== "boolean") {
                                                    var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                    if (vErrors === null) {
                                                      vErrors = [err10];
                                                    } else {
                                                      vErrors.push(err10);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid17 = _errs81 === errors;
                                                  if (!valid17) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                if (vErrors === null) {
                                                  vErrors = [err11];
                                                } else {
                                                  vErrors.push(err11);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid3 = _errs78 === errors;
                                            valid16 = valid16 || _valid3;
                                            if (!valid16) {
                                              var _errs83 = errors;
                                              if (typeof data26 !== "boolean") {
                                                var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                if (vErrors === null) {
                                                  vErrors = [err12];
                                                } else {
                                                  vErrors.push(err12);
                                                }
                                                errors++;
                                              }
                                              var _valid3 = _errs83 === errors;
                                              valid16 = valid16 || _valid3;
                                            }
                                            if (!valid16) {
                                              var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                              if (vErrors === null) {
                                                vErrors = [err13];
                                              } else {
                                                vErrors.push(err13);
                                              }
                                              errors++;
                                              validate95.errors = vErrors;
                                              return false;
                                            } else {
                                              errors = _errs77;
                                              if (vErrors !== null) {
                                                if (_errs77) {
                                                  vErrors.length = _errs77;
                                                } else {
                                                  vErrors = null;
                                                }
                                              }
                                            }
                                            var valid10 = _errs76 === errors;
                                          } else {
                                            var valid10 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate95.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate95.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs85 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate95.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs85 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs87 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate95.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs87 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs89 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate95.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs89 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs91 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate95.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs91 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data32 = data.matrix;
                              var _errs93 = errors;
                              var _errs94 = errors;
                              if (errors === _errs94) {
                                if (Array.isArray(data32)) {
                                  if (data32.length > 6) {
                                    validate95.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data32.length < 6) {
                                      validate95.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid19 = true;
                                      var len4 = data32.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data33 = data32[i4];
                                        var _errs96 = errors;
                                        if (!(typeof data33 == "number" && isFinite(data33))) {
                                          validate95.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid19 = _errs96 === errors;
                                        if (!valid19) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate95.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs93 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs98 = errors;
                                if (typeof data.name !== "string") {
                                  validate95.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs98 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data35 = data.opacity;
                                  var _errs100 = errors;
                                  if (!(typeof data35 == "number" && isFinite(data35))) {
                                    validate95.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs100 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate95.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate95.errors = vErrors;
  return errors === 0;
}
function validate89(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.crossOrigin === void 0 && (missing0 = "crossOrigin") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.innerShadows === void 0 && (missing0 = "innerShadows") || data.itemProps === void 0 && (missing0 = "itemProps") || data.originalSource === void 0 && (missing0 = "originalSource") || data.parentId === void 0 && (missing0 = "parentId") || data.radius === void 0 && (missing0 = "radius") || data.shadows === void 0 && (missing0 = "shadows") || data.size === void 0 && (missing0 = "size") || data.source === void 0 && (missing0 = "source") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes")) {
        validate89.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema68.properties, key0)) {
            validate89.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate89.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Raster") {
              validate89.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Raster" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.source !== void 0) {
              var _errs4 = errors;
              if (typeof data.source !== "string") {
                validate89.errors = [{ instancePath: instancePath + "/source", schemaPath: "#/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.originalSource !== void 0) {
                var _errs6 = errors;
                if (typeof data.originalSource !== "string") {
                  validate89.errors = [{ instancePath: instancePath + "/originalSource", schemaPath: "#/properties/originalSource/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.crossOrigin !== void 0) {
                  var _errs8 = errors;
                  if (typeof data.crossOrigin !== "string") {
                    validate89.errors = [{ instancePath: instancePath + "/crossOrigin", schemaPath: "#/properties/crossOrigin/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.size !== void 0) {
                    var data4 = data.size;
                    var _errs10 = errors;
                    var _errs11 = errors;
                    if (errors === _errs11) {
                      if (Array.isArray(data4)) {
                        if (data4.length > 2) {
                          validate89.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                          return false;
                        } else {
                          if (data4.length < 2) {
                            validate89.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                            return false;
                          } else {
                            var valid2 = true;
                            var len0 = data4.length;
                            for (var i0 = 0; i0 < len0; i0++) {
                              var data5 = data4[i0];
                              var _errs13 = errors;
                              if (!(typeof data5 == "number" && isFinite(data5))) {
                                validate89.errors = [{ instancePath: instancePath + "/size/" + i0, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                return false;
                              }
                              var valid2 = _errs13 === errors;
                              if (!valid2) {
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        validate89.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.radius !== void 0) {
                      var data6 = data.radius;
                      var _errs15 = errors;
                      if (errors === _errs15) {
                        if (Array.isArray(data6)) {
                          if (data6.length > 4) {
                            validate89.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/properties/radius/maxItems", keyword: "maxItems", params: { limit: 4 }, message: "must NOT have more than 4 items" }];
                            return false;
                          } else {
                            if (data6.length < 4) {
                              validate89.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/properties/radius/minItems", keyword: "minItems", params: { limit: 4 }, message: "must NOT have fewer than 4 items" }];
                              return false;
                            } else {
                              var valid3 = true;
                              var len1 = data6.length;
                              for (var i1 = 0; i1 < len1; i1++) {
                                var data7 = data6[i1];
                                var _errs17 = errors;
                                if (!(typeof data7 == "number" && isFinite(data7))) {
                                  validate89.errors = [{ instancePath: instancePath + "/radius/" + i1, schemaPath: "#/properties/radius/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                  return false;
                                }
                                var valid3 = _errs17 === errors;
                                if (!valid3) {
                                  break;
                                }
                              }
                            }
                          }
                        } else {
                          validate89.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/properties/radius/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs15 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.shadows !== void 0) {
                        var data8 = data.shadows;
                        var _errs19 = errors;
                        if (errors === _errs19) {
                          if (Array.isArray(data8)) {
                            var valid4 = true;
                            var len2 = data8.length;
                            for (var i2 = 0; i2 < len2; i2++) {
                              var _errs21 = errors;
                              if (!validate54(data8[i2], { instancePath: instancePath + "/shadows/" + i2, parentData: data8, parentDataProperty: i2, rootData })) {
                                vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                errors = vErrors.length;
                              }
                              var valid4 = _errs21 === errors;
                              if (!valid4) {
                                break;
                              }
                            }
                          } else {
                            validate89.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.innerShadows !== void 0) {
                          var data10 = data.innerShadows;
                          var _errs22 = errors;
                          if (errors === _errs22) {
                            if (Array.isArray(data10)) {
                              var valid5 = true;
                              var len3 = data10.length;
                              for (var i3 = 0; i3 < len3; i3++) {
                                var _errs24 = errors;
                                if (!validate54(data10[i3], { instancePath: instancePath + "/innerShadows/" + i3, parentData: data10, parentDataProperty: i3, rootData })) {
                                  vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                  errors = vErrors.length;
                                }
                                var valid5 = _errs24 === errors;
                                if (!valid5) {
                                  break;
                                }
                              }
                            } else {
                              validate89.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid0 = _errs22 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.strokeStyle !== void 0) {
                            var _errs25 = errors;
                            if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                              vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs25 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.strokes !== void 0) {
                              var data13 = data.strokes;
                              var _errs26 = errors;
                              if (errors === _errs26) {
                                if (Array.isArray(data13)) {
                                  var valid6 = true;
                                  var len4 = data13.length;
                                  for (var i4 = 0; i4 < len4; i4++) {
                                    var _errs28 = errors;
                                    if (!validate60(data13[i4], { instancePath: instancePath + "/strokes/" + i4, parentData: data13, parentDataProperty: i4, rootData })) {
                                      vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                                      errors = vErrors.length;
                                    }
                                    var valid6 = _errs28 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate89.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs26 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.fillStyle !== void 0) {
                                var _errs29 = errors;
                                if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                                  vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                                  errors = vErrors.length;
                                }
                                var valid0 = _errs29 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.itemProps !== void 0) {
                                  var _errs30 = errors;
                                  if (!validate95(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                                    vErrors = vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid0 = _errs30 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.parentId !== void 0) {
                                    var data17 = data.parentId;
                                    var _errs31 = errors;
                                    if (typeof data17 !== "string" && data17 !== null) {
                                      validate89.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema68.properties.parentId.type }, message: "must be string,null" }];
                                      return false;
                                    }
                                    var valid0 = _errs31 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.id !== void 0) {
                                      var _errs33 = errors;
                                      if (typeof data.id !== "string") {
                                        validate89.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                      }
                                      var valid0 = _errs33 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate89.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate89.errors = vErrors;
  return errors === 0;
}
var schema75 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "Shape" }, "type": { "$ref": "#/definitions/ShapeType" }, "size": { "$ref": "#/definitions/Size" }, "radius": { "$ref": "#/definitions/BorderRadius" }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalShapeData%2CJsonObject%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["className", "fillStyle", "id", "innerShadows", "itemProps", "parentId", "radius", "shadows", "size", "strokeStyle", "strokes", "type"] };
var schema76 = { "type": "string", "enum": ["rectangle", "ellipse"] };
var schema79 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
function validate108(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate108.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema79.properties, key0)) {
            validate108.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate108.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate108.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema79.properties.assets.items.properties, key1)) {
                              validate108.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate108.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate108.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate108.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate108.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate108.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate108.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                          vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                          errors = vErrors.length;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                        if (!valid7) {
                                          var _errs58 = errors;
                                          if (!Array.isArray(data18)) {
                                            var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                            if (vErrors === null) {
                                              vErrors = [err6];
                                            } else {
                                              vErrors.push(err6);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs58 === errors;
                                          valid7 = valid7 || _valid0;
                                        }
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate108.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.frame !== void 0) {
                                    var data20 = data17.frame;
                                    var _errs60 = errors;
                                    var _errs61 = errors;
                                    var valid11 = false;
                                    var _errs62 = errors;
                                    if (!validate71(data20, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                      vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                      errors = vErrors.length;
                                    }
                                    var _valid2 = _errs62 === errors;
                                    valid11 = valid11 || _valid2;
                                    if (!valid11) {
                                      var _errs63 = errors;
                                      if (data20 !== null) {
                                        var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err8];
                                        } else {
                                          vErrors.push(err8);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs63 === errors;
                                      valid11 = valid11 || _valid2;
                                    }
                                    if (!valid11) {
                                      var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err9];
                                      } else {
                                        vErrors.push(err9);
                                      }
                                      errors++;
                                      validate108.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs61;
                                      if (vErrors !== null) {
                                        if (_errs61) {
                                          vErrors.length = _errs61;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid10 = _errs60 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.extrema !== void 0) {
                                      var data21 = data17.extrema;
                                      var _errs65 = errors;
                                      if (errors === _errs65) {
                                        if (Array.isArray(data21)) {
                                          var valid12 = true;
                                          var len2 = data21.length;
                                          for (var i2 = 0; i2 < len2; i2++) {
                                            var data22 = data21[i2];
                                            var _errs67 = errors;
                                            var _errs68 = errors;
                                            if (errors === _errs68) {
                                              if (Array.isArray(data22)) {
                                                if (data22.length > 2) {
                                                  validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                  return false;
                                                } else {
                                                  if (data22.length < 2) {
                                                    validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                    return false;
                                                  } else {
                                                    var valid14 = true;
                                                    var len3 = data22.length;
                                                    for (var i3 = 0; i3 < len3; i3++) {
                                                      var data23 = data22[i3];
                                                      var _errs70 = errors;
                                                      if (!(typeof data23 == "number" && isFinite(data23))) {
                                                        validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                        return false;
                                                      }
                                                      var valid14 = _errs70 === errors;
                                                      if (!valid14) {
                                                        break;
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                return false;
                                              }
                                            }
                                            var valid12 = _errs67 === errors;
                                            if (!valid12) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                          return false;
                                        }
                                      }
                                      var valid10 = _errs65 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.isAspectRatioLocked !== void 0) {
                                        var _errs72 = errors;
                                        if (typeof data17.isAspectRatioLocked !== "boolean") {
                                          validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                          return false;
                                        }
                                        var valid10 = _errs72 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.uploaded !== void 0) {
                                          var data25 = data17.uploaded;
                                          var _errs74 = errors;
                                          var _errs75 = errors;
                                          var valid15 = false;
                                          var _errs76 = errors;
                                          if (errors === _errs76) {
                                            if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                                              for (var key4 in data25) {
                                                var _errs79 = errors;
                                                if (typeof data25[key4] !== "boolean") {
                                                  var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                  if (vErrors === null) {
                                                    vErrors = [err10];
                                                  } else {
                                                    vErrors.push(err10);
                                                  }
                                                  errors++;
                                                }
                                                var valid16 = _errs79 === errors;
                                                if (!valid16) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                              if (vErrors === null) {
                                                vErrors = [err11];
                                              } else {
                                                vErrors.push(err11);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid3 = _errs76 === errors;
                                          valid15 = valid15 || _valid3;
                                          if (!valid15) {
                                            var _errs81 = errors;
                                            if (typeof data25 !== "boolean") {
                                              var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                              if (vErrors === null) {
                                                vErrors = [err12];
                                              } else {
                                                vErrors.push(err12);
                                              }
                                              errors++;
                                            }
                                            var _valid3 = _errs81 === errors;
                                            valid15 = valid15 || _valid3;
                                          }
                                          if (!valid15) {
                                            var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                            validate108.errors = vErrors;
                                            return false;
                                          } else {
                                            errors = _errs75;
                                            if (vErrors !== null) {
                                              if (_errs75) {
                                                vErrors.length = _errs75;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate108.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate108.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs83 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate108.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs83 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs85 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate108.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs85 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs87 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate108.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs87 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs89 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate108.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs89 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data31 = data.matrix;
                              var _errs91 = errors;
                              var _errs92 = errors;
                              if (errors === _errs92) {
                                if (Array.isArray(data31)) {
                                  if (data31.length > 6) {
                                    validate108.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data31.length < 6) {
                                      validate108.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid18 = true;
                                      var len4 = data31.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data32 = data31[i4];
                                        var _errs94 = errors;
                                        if (!(typeof data32 == "number" && isFinite(data32))) {
                                          validate108.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid18 = _errs94 === errors;
                                        if (!valid18) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate108.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs91 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs96 = errors;
                                if (typeof data.name !== "string") {
                                  validate108.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs96 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data34 = data.opacity;
                                  var _errs98 = errors;
                                  if (!(typeof data34 == "number" && isFinite(data34))) {
                                    validate108.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs98 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate108.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate108.errors = vErrors;
  return errors === 0;
}
function validate102(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.innerShadows === void 0 && (missing0 = "innerShadows") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.radius === void 0 && (missing0 = "radius") || data.shadows === void 0 && (missing0 = "shadows") || data.size === void 0 && (missing0 = "size") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes") || data.type === void 0 && (missing0 = "type")) {
        validate102.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema75.properties, key0)) {
            validate102.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate102.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Shape") {
              validate102.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Shape" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.type !== void 0) {
              var data1 = data.type;
              var _errs4 = errors;
              if (typeof data1 !== "string") {
                validate102.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/definitions/ShapeType/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
              }
              if (!(data1 === "rectangle" || data1 === "ellipse")) {
                validate102.errors = [{ instancePath: instancePath + "/type", schemaPath: "#/definitions/ShapeType/enum", keyword: "enum", params: { allowedValues: schema76.enum }, message: "must be equal to one of the allowed values" }];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.size !== void 0) {
                var data2 = data.size;
                var _errs7 = errors;
                var _errs8 = errors;
                if (errors === _errs8) {
                  if (Array.isArray(data2)) {
                    if (data2.length > 2) {
                      validate102.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                      return false;
                    } else {
                      if (data2.length < 2) {
                        validate102.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                        return false;
                      } else {
                        var valid3 = true;
                        var len0 = data2.length;
                        for (var i0 = 0; i0 < len0; i0++) {
                          var data3 = data2[i0];
                          var _errs10 = errors;
                          if (!(typeof data3 == "number" && isFinite(data3))) {
                            validate102.errors = [{ instancePath: instancePath + "/size/" + i0, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid3 = _errs10 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    validate102.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.radius !== void 0) {
                  var data4 = data.radius;
                  var _errs12 = errors;
                  var _errs13 = errors;
                  if (errors === _errs13) {
                    if (Array.isArray(data4)) {
                      if (data4.length > 4) {
                        validate102.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/definitions/BorderRadius/maxItems", keyword: "maxItems", params: { limit: 4 }, message: "must NOT have more than 4 items" }];
                        return false;
                      } else {
                        if (data4.length < 4) {
                          validate102.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/definitions/BorderRadius/minItems", keyword: "minItems", params: { limit: 4 }, message: "must NOT have fewer than 4 items" }];
                          return false;
                        } else {
                          var valid5 = true;
                          var len1 = data4.length;
                          for (var i1 = 0; i1 < len1; i1++) {
                            var data5 = data4[i1];
                            var _errs15 = errors;
                            if (!(typeof data5 == "number" && isFinite(data5))) {
                              validate102.errors = [{ instancePath: instancePath + "/radius/" + i1, schemaPath: "#/definitions/BorderRadius/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                              return false;
                            }
                            var valid5 = _errs15 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        }
                      }
                    } else {
                      validate102.errors = [{ instancePath: instancePath + "/radius", schemaPath: "#/definitions/BorderRadius/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.shadows !== void 0) {
                    var data6 = data.shadows;
                    var _errs17 = errors;
                    if (errors === _errs17) {
                      if (Array.isArray(data6)) {
                        var valid6 = true;
                        var len2 = data6.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var _errs19 = errors;
                          if (!validate54(data6[i2], { instancePath: instancePath + "/shadows/" + i2, parentData: data6, parentDataProperty: i2, rootData })) {
                            vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                            errors = vErrors.length;
                          }
                          var valid6 = _errs19 === errors;
                          if (!valid6) {
                            break;
                          }
                        }
                      } else {
                        validate102.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs17 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.innerShadows !== void 0) {
                      var data8 = data.innerShadows;
                      var _errs20 = errors;
                      if (errors === _errs20) {
                        if (Array.isArray(data8)) {
                          var valid7 = true;
                          var len3 = data8.length;
                          for (var i3 = 0; i3 < len3; i3++) {
                            var _errs22 = errors;
                            if (!validate54(data8[i3], { instancePath: instancePath + "/innerShadows/" + i3, parentData: data8, parentDataProperty: i3, rootData })) {
                              vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                              errors = vErrors.length;
                            }
                            var valid7 = _errs22 === errors;
                            if (!valid7) {
                              break;
                            }
                          }
                        } else {
                          validate102.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                          return false;
                        }
                      }
                      var valid0 = _errs20 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.strokeStyle !== void 0) {
                        var _errs23 = errors;
                        if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                          vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs23 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.strokes !== void 0) {
                          var data11 = data.strokes;
                          var _errs24 = errors;
                          if (errors === _errs24) {
                            if (Array.isArray(data11)) {
                              var valid8 = true;
                              var len4 = data11.length;
                              for (var i4 = 0; i4 < len4; i4++) {
                                var _errs26 = errors;
                                if (!validate60(data11[i4], { instancePath: instancePath + "/strokes/" + i4, parentData: data11, parentDataProperty: i4, rootData })) {
                                  vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                                  errors = vErrors.length;
                                }
                                var valid8 = _errs26 === errors;
                                if (!valid8) {
                                  break;
                                }
                              }
                            } else {
                              validate102.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid0 = _errs24 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.fillStyle !== void 0) {
                            var _errs27 = errors;
                            if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                              vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs27 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.itemProps !== void 0) {
                              var _errs28 = errors;
                              if (!validate108(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                                vErrors = vErrors === null ? validate108.errors : vErrors.concat(validate108.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs28 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.parentId !== void 0) {
                                var data15 = data.parentId;
                                var _errs29 = errors;
                                if (typeof data15 !== "string" && data15 !== null) {
                                  validate102.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema75.properties.parentId.type }, message: "must be string,null" }];
                                  return false;
                                }
                                var valid0 = _errs29 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.id !== void 0) {
                                  var _errs31 = errors;
                                  if (typeof data.id !== "string") {
                                    validate102.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid0 = _errs31 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate102.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate102.errors = vErrors;
  return errors === 0;
}
var schema83 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "Text" }, "blocks": { "type": "array", "items": { "$ref": "#/definitions/TextBlock" } }, "style": { "$ref": "#/definitions/TextStyle" }, "size": { "$ref": "#/definitions/Size" }, "sizing": { "type": "array", "items": { "$ref": "#/definitions/TextSizing" }, "minItems": 2, "maxItems": 2 }, "autoLineHeight": { "type": "boolean", "deprecated": "Sketch plugin incorrectly put autoLineHeight here instead of in style" }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalTextData%2Calias-1158747822-13813-13963-1158747822-0-14894%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["blocks", "className", "id", "innerShadows", "itemProps", "parentId", "shadows", "size", "sizing", "style"] };
var schema90 = { "type": "string", "enum": ["absolute", "auto"] };
var schema85 = { "type": "object", "properties": { "align": { "$ref": "#/definitions/TextAlign" }, "color": { "$ref": "#/definitions/Color" }, "fontFamily": { "type": "string" }, "fontSize": { "type": "number" }, "fontSizeUnit": { "type": "string" }, "fontWeight": { "type": "number" }, "italic": { "type": "boolean" }, "letterSpacing": { "type": "number" }, "letterSpacingUnit": { "$ref": "#/definitions/TextUnit" }, "lineHeight": { "type": "number" }, "lineHeightUnit": { "$ref": "#/definitions/TextUnit" }, "autoLineHeight": { "type": "boolean", "description": "Only optional because Sketch plugin is not sending it in correct position" }, "strikethrough": { "type": "boolean" }, "underline": { "type": "boolean" } }, "required": ["align", "color", "fontFamily", "fontSize", "fontSizeUnit", "fontWeight", "italic", "letterSpacing", "letterSpacingUnit", "lineHeight", "lineHeightUnit", "strikethrough", "underline"], "additionalProperties": false };
var schema86 = { "type": "string", "enum": ["left", "right", "center", "justify"] };
var schema87 = { "type": "string", "enum": ["px", "%"] };
function validate117(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.align === void 0 && (missing0 = "align") || data.color === void 0 && (missing0 = "color") || data.fontFamily === void 0 && (missing0 = "fontFamily") || data.fontSize === void 0 && (missing0 = "fontSize") || data.fontSizeUnit === void 0 && (missing0 = "fontSizeUnit") || data.fontWeight === void 0 && (missing0 = "fontWeight") || data.italic === void 0 && (missing0 = "italic") || data.letterSpacing === void 0 && (missing0 = "letterSpacing") || data.letterSpacingUnit === void 0 && (missing0 = "letterSpacingUnit") || data.lineHeight === void 0 && (missing0 = "lineHeight") || data.lineHeightUnit === void 0 && (missing0 = "lineHeightUnit") || data.strikethrough === void 0 && (missing0 = "strikethrough") || data.underline === void 0 && (missing0 = "underline")) {
        validate117.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema85.properties, key0)) {
            validate117.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.align !== void 0) {
            var data0 = data.align;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate117.errors = [{ instancePath: instancePath + "/align", schemaPath: "#/definitions/TextAlign/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (!(data0 === "left" || data0 === "right" || data0 === "center" || data0 === "justify")) {
              validate117.errors = [{ instancePath: instancePath + "/align", schemaPath: "#/definitions/TextAlign/enum", keyword: "enum", params: { allowedValues: schema86.enum }, message: "must be equal to one of the allowed values" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.color !== void 0) {
              var _errs5 = errors;
              if (!validate28(data.color, { instancePath: instancePath + "/color", parentData: data, parentDataProperty: "color", rootData })) {
                vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.fontFamily !== void 0) {
                var _errs6 = errors;
                if (typeof data.fontFamily !== "string") {
                  validate117.errors = [{ instancePath: instancePath + "/fontFamily", schemaPath: "#/properties/fontFamily/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.fontSize !== void 0) {
                  var data3 = data.fontSize;
                  var _errs8 = errors;
                  if (!(typeof data3 == "number" && isFinite(data3))) {
                    validate117.errors = [{ instancePath: instancePath + "/fontSize", schemaPath: "#/properties/fontSize/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.fontSizeUnit !== void 0) {
                    var _errs10 = errors;
                    if (typeof data.fontSizeUnit !== "string") {
                      validate117.errors = [{ instancePath: instancePath + "/fontSizeUnit", schemaPath: "#/properties/fontSizeUnit/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.fontWeight !== void 0) {
                      var data5 = data.fontWeight;
                      var _errs12 = errors;
                      if (!(typeof data5 == "number" && isFinite(data5))) {
                        validate117.errors = [{ instancePath: instancePath + "/fontWeight", schemaPath: "#/properties/fontWeight/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                        return false;
                      }
                      var valid0 = _errs12 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.italic !== void 0) {
                        var _errs14 = errors;
                        if (typeof data.italic !== "boolean") {
                          validate117.errors = [{ instancePath: instancePath + "/italic", schemaPath: "#/properties/italic/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs14 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.letterSpacing !== void 0) {
                          var data7 = data.letterSpacing;
                          var _errs16 = errors;
                          if (!(typeof data7 == "number" && isFinite(data7))) {
                            validate117.errors = [{ instancePath: instancePath + "/letterSpacing", schemaPath: "#/properties/letterSpacing/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                            return false;
                          }
                          var valid0 = _errs16 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.letterSpacingUnit !== void 0) {
                            var data8 = data.letterSpacingUnit;
                            var _errs18 = errors;
                            if (typeof data8 !== "string") {
                              validate117.errors = [{ instancePath: instancePath + "/letterSpacingUnit", schemaPath: "#/definitions/TextUnit/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                              return false;
                            }
                            if (!(data8 === "px" || data8 === "%")) {
                              validate117.errors = [{ instancePath: instancePath + "/letterSpacingUnit", schemaPath: "#/definitions/TextUnit/enum", keyword: "enum", params: { allowedValues: schema87.enum }, message: "must be equal to one of the allowed values" }];
                              return false;
                            }
                            var valid0 = _errs18 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.lineHeight !== void 0) {
                              var data9 = data.lineHeight;
                              var _errs21 = errors;
                              if (!(typeof data9 == "number" && isFinite(data9))) {
                                validate117.errors = [{ instancePath: instancePath + "/lineHeight", schemaPath: "#/properties/lineHeight/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.lineHeightUnit !== void 0) {
                                var data10 = data.lineHeightUnit;
                                var _errs23 = errors;
                                if (typeof data10 !== "string") {
                                  validate117.errors = [{ instancePath: instancePath + "/lineHeightUnit", schemaPath: "#/definitions/TextUnit/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                if (!(data10 === "px" || data10 === "%")) {
                                  validate117.errors = [{ instancePath: instancePath + "/lineHeightUnit", schemaPath: "#/definitions/TextUnit/enum", keyword: "enum", params: { allowedValues: schema87.enum }, message: "must be equal to one of the allowed values" }];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.autoLineHeight !== void 0) {
                                  var _errs26 = errors;
                                  if (typeof data.autoLineHeight !== "boolean") {
                                    validate117.errors = [{ instancePath: instancePath + "/autoLineHeight", schemaPath: "#/properties/autoLineHeight/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                    return false;
                                  }
                                  var valid0 = _errs26 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.strikethrough !== void 0) {
                                    var _errs28 = errors;
                                    if (typeof data.strikethrough !== "boolean") {
                                      validate117.errors = [{ instancePath: instancePath + "/strikethrough", schemaPath: "#/properties/strikethrough/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                      return false;
                                    }
                                    var valid0 = _errs28 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.underline !== void 0) {
                                      var _errs30 = errors;
                                      if (typeof data.underline !== "boolean") {
                                        validate117.errors = [{ instancePath: instancePath + "/underline", schemaPath: "#/properties/underline/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                        return false;
                                      }
                                      var valid0 = _errs30 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate117.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate117.errors = vErrors;
  return errors === 0;
}
var schema91 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "valign": { "$ref": "#/definitions/VAlign" }, "padding": { "type": "number" }, "overflow": { "type": "boolean" }, "allowEmpty": { "type": "boolean" }, "layoutHash": { "type": "string" }, "version": { "type": "number" }, "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
var schema93 = { "type": "string", "enum": ["top", "center", "bottom"] };
function validate122(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate122.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema91.properties, key0)) {
            validate122.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate122.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate122.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema91.properties.assets.items.properties, key1)) {
                              validate122.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate122.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate122.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate122.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate122.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate122.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate122.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!func2.call(schema91.properties.data.properties.MARVEL_DESIGN_CREATOR.properties, key3)) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!Array.isArray(data18)) {
                                          var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate122.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.valign !== void 0) {
                                    var data20 = data17.valign;
                                    var _errs59 = errors;
                                    if (typeof data20 !== "string") {
                                      validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/valign", schemaPath: "#/definitions/VAlign/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (!(data20 === "top" || data20 === "center" || data20 === "bottom")) {
                                      validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/valign", schemaPath: "#/definitions/VAlign/enum", keyword: "enum", params: { allowedValues: schema93.enum }, message: "must be equal to one of the allowed values" }];
                                      return false;
                                    }
                                    var valid10 = _errs59 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.padding !== void 0) {
                                      var data21 = data17.padding;
                                      var _errs62 = errors;
                                      if (!(typeof data21 == "number" && isFinite(data21))) {
                                        validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/padding", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/padding/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid10 = _errs62 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.overflow !== void 0) {
                                        var _errs64 = errors;
                                        if (typeof data17.overflow !== "boolean") {
                                          validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/overflow", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/overflow/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                          return false;
                                        }
                                        var valid10 = _errs64 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.allowEmpty !== void 0) {
                                          var _errs66 = errors;
                                          if (typeof data17.allowEmpty !== "boolean") {
                                            validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/allowEmpty", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/allowEmpty/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                            return false;
                                          }
                                          var valid10 = _errs66 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                        if (valid10) {
                                          if (data17.layoutHash !== void 0) {
                                            var _errs68 = errors;
                                            if (typeof data17.layoutHash !== "string") {
                                              validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/layoutHash", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/layoutHash/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid10 = _errs68 === errors;
                                          } else {
                                            var valid10 = true;
                                          }
                                          if (valid10) {
                                            if (data17.version !== void 0) {
                                              var data25 = data17.version;
                                              var _errs70 = errors;
                                              if (!(typeof data25 == "number" && isFinite(data25))) {
                                                validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/version", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/version/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                return false;
                                              }
                                              var valid10 = _errs70 === errors;
                                            } else {
                                              var valid10 = true;
                                            }
                                            if (valid10) {
                                              if (data17.frame !== void 0) {
                                                var data26 = data17.frame;
                                                var _errs72 = errors;
                                                var _errs73 = errors;
                                                var valid12 = false;
                                                var _errs74 = errors;
                                                if (!validate71(data26, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                                  vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                                  errors = vErrors.length;
                                                }
                                                var _valid2 = _errs74 === errors;
                                                valid12 = valid12 || _valid2;
                                                if (!valid12) {
                                                  var _errs75 = errors;
                                                  if (data26 !== null) {
                                                    var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                                    if (vErrors === null) {
                                                      vErrors = [err8];
                                                    } else {
                                                      vErrors.push(err8);
                                                    }
                                                    errors++;
                                                  }
                                                  var _valid2 = _errs75 === errors;
                                                  valid12 = valid12 || _valid2;
                                                }
                                                if (!valid12) {
                                                  var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                  if (vErrors === null) {
                                                    vErrors = [err9];
                                                  } else {
                                                    vErrors.push(err9);
                                                  }
                                                  errors++;
                                                  validate122.errors = vErrors;
                                                  return false;
                                                } else {
                                                  errors = _errs73;
                                                  if (vErrors !== null) {
                                                    if (_errs73) {
                                                      vErrors.length = _errs73;
                                                    } else {
                                                      vErrors = null;
                                                    }
                                                  }
                                                }
                                                var valid10 = _errs72 === errors;
                                              } else {
                                                var valid10 = true;
                                              }
                                              if (valid10) {
                                                if (data17.extrema !== void 0) {
                                                  var data27 = data17.extrema;
                                                  var _errs77 = errors;
                                                  if (errors === _errs77) {
                                                    if (Array.isArray(data27)) {
                                                      var valid13 = true;
                                                      var len2 = data27.length;
                                                      for (var i2 = 0; i2 < len2; i2++) {
                                                        var data28 = data27[i2];
                                                        var _errs79 = errors;
                                                        var _errs80 = errors;
                                                        if (errors === _errs80) {
                                                          if (Array.isArray(data28)) {
                                                            if (data28.length > 2) {
                                                              validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                              return false;
                                                            } else {
                                                              if (data28.length < 2) {
                                                                validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                                return false;
                                                              } else {
                                                                var valid15 = true;
                                                                var len3 = data28.length;
                                                                for (var i3 = 0; i3 < len3; i3++) {
                                                                  var data29 = data28[i3];
                                                                  var _errs82 = errors;
                                                                  if (!(typeof data29 == "number" && isFinite(data29))) {
                                                                    validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                                    return false;
                                                                  }
                                                                  var valid15 = _errs82 === errors;
                                                                  if (!valid15) {
                                                                    break;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          } else {
                                                            validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                            return false;
                                                          }
                                                        }
                                                        var valid13 = _errs79 === errors;
                                                        if (!valid13) {
                                                          break;
                                                        }
                                                      }
                                                    } else {
                                                      validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                      return false;
                                                    }
                                                  }
                                                  var valid10 = _errs77 === errors;
                                                } else {
                                                  var valid10 = true;
                                                }
                                                if (valid10) {
                                                  if (data17.isAspectRatioLocked !== void 0) {
                                                    var _errs84 = errors;
                                                    if (typeof data17.isAspectRatioLocked !== "boolean") {
                                                      validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                                      return false;
                                                    }
                                                    var valid10 = _errs84 === errors;
                                                  } else {
                                                    var valid10 = true;
                                                  }
                                                  if (valid10) {
                                                    if (data17.uploaded !== void 0) {
                                                      var data31 = data17.uploaded;
                                                      var _errs86 = errors;
                                                      var _errs87 = errors;
                                                      var valid16 = false;
                                                      var _errs88 = errors;
                                                      if (errors === _errs88) {
                                                        if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                                          for (var key4 in data31) {
                                                            var _errs91 = errors;
                                                            if (typeof data31[key4] !== "boolean") {
                                                              var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                              if (vErrors === null) {
                                                                vErrors = [err10];
                                                              } else {
                                                                vErrors.push(err10);
                                                              }
                                                              errors++;
                                                            }
                                                            var valid17 = _errs91 === errors;
                                                            if (!valid17) {
                                                              break;
                                                            }
                                                          }
                                                        } else {
                                                          var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                          if (vErrors === null) {
                                                            vErrors = [err11];
                                                          } else {
                                                            vErrors.push(err11);
                                                          }
                                                          errors++;
                                                        }
                                                      }
                                                      var _valid3 = _errs88 === errors;
                                                      valid16 = valid16 || _valid3;
                                                      if (!valid16) {
                                                        var _errs93 = errors;
                                                        if (typeof data31 !== "boolean") {
                                                          var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                          if (vErrors === null) {
                                                            vErrors = [err12];
                                                          } else {
                                                            vErrors.push(err12);
                                                          }
                                                          errors++;
                                                        }
                                                        var _valid3 = _errs93 === errors;
                                                        valid16 = valid16 || _valid3;
                                                      }
                                                      if (!valid16) {
                                                        var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                                        if (vErrors === null) {
                                                          vErrors = [err13];
                                                        } else {
                                                          vErrors.push(err13);
                                                        }
                                                        errors++;
                                                        validate122.errors = vErrors;
                                                        return false;
                                                      } else {
                                                        errors = _errs87;
                                                        if (vErrors !== null) {
                                                          if (_errs87) {
                                                            vErrors.length = _errs87;
                                                          } else {
                                                            vErrors = null;
                                                          }
                                                        }
                                                      }
                                                      var valid10 = _errs86 === errors;
                                                    } else {
                                                      var valid10 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate122.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate122.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs95 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate122.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs95 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs97 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate122.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs97 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs99 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate122.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs99 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs101 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate122.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs101 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data37 = data.matrix;
                              var _errs103 = errors;
                              var _errs104 = errors;
                              if (errors === _errs104) {
                                if (Array.isArray(data37)) {
                                  if (data37.length > 6) {
                                    validate122.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data37.length < 6) {
                                      validate122.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid19 = true;
                                      var len4 = data37.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data38 = data37[i4];
                                        var _errs106 = errors;
                                        if (!(typeof data38 == "number" && isFinite(data38))) {
                                          validate122.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid19 = _errs106 === errors;
                                        if (!valid19) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate122.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs103 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs108 = errors;
                                if (typeof data.name !== "string") {
                                  validate122.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs108 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data40 = data.opacity;
                                  var _errs110 = errors;
                                  if (!(typeof data40 == "number" && isFinite(data40))) {
                                    validate122.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs110 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate122.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate122.errors = vErrors;
  return errors === 0;
}
function validate116(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.blocks === void 0 && (missing0 = "blocks") || data.className === void 0 && (missing0 = "className") || data.id === void 0 && (missing0 = "id") || data.innerShadows === void 0 && (missing0 = "innerShadows") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.shadows === void 0 && (missing0 = "shadows") || data.size === void 0 && (missing0 = "size") || data.sizing === void 0 && (missing0 = "sizing") || data.style === void 0 && (missing0 = "style")) {
        validate116.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema83.properties, key0)) {
            validate116.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate116.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Text") {
              validate116.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Text" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.blocks !== void 0) {
              var data1 = data.blocks;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    var _errs7 = errors;
                    if (errors === _errs7) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.text === void 0 && (missing1 = "text")) {
                          validate116.errors = [{ instancePath: instancePath + "/blocks/" + i0, schemaPath: "#/definitions/TextBlock/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs9 = errors;
                          for (var key1 in data2) {
                            if (!(key1 === "text")) {
                              validate116.errors = [{ instancePath: instancePath + "/blocks/" + i0, schemaPath: "#/definitions/TextBlock/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs9 === errors) {
                            if (data2.text !== void 0) {
                              if (typeof data2.text !== "string") {
                                validate116.errors = [{ instancePath: instancePath + "/blocks/" + i0 + "/text", schemaPath: "#/definitions/TextBlock/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate116.errors = [{ instancePath: instancePath + "/blocks/" + i0, schemaPath: "#/definitions/TextBlock/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate116.errors = [{ instancePath: instancePath + "/blocks", schemaPath: "#/properties/blocks/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.style !== void 0) {
                var _errs12 = errors;
                if (!validate117(data.style, { instancePath: instancePath + "/style", parentData: data, parentDataProperty: "style", rootData })) {
                  vErrors = vErrors === null ? validate117.errors : vErrors.concat(validate117.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs12 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.size !== void 0) {
                  var data5 = data.size;
                  var _errs13 = errors;
                  var _errs14 = errors;
                  if (errors === _errs14) {
                    if (Array.isArray(data5)) {
                      if (data5.length > 2) {
                        validate116.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                        return false;
                      } else {
                        if (data5.length < 2) {
                          validate116.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                          return false;
                        } else {
                          var valid5 = true;
                          var len1 = data5.length;
                          for (var i1 = 0; i1 < len1; i1++) {
                            var data6 = data5[i1];
                            var _errs16 = errors;
                            if (!(typeof data6 == "number" && isFinite(data6))) {
                              validate116.errors = [{ instancePath: instancePath + "/size/" + i1, schemaPath: "#/definitions/Size/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                              return false;
                            }
                            var valid5 = _errs16 === errors;
                            if (!valid5) {
                              break;
                            }
                          }
                        }
                      }
                    } else {
                      validate116.errors = [{ instancePath: instancePath + "/size", schemaPath: "#/definitions/Size/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs13 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.sizing !== void 0) {
                    var data7 = data.sizing;
                    var _errs18 = errors;
                    if (errors === _errs18) {
                      if (Array.isArray(data7)) {
                        if (data7.length > 2) {
                          validate116.errors = [{ instancePath: instancePath + "/sizing", schemaPath: "#/properties/sizing/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                          return false;
                        } else {
                          if (data7.length < 2) {
                            validate116.errors = [{ instancePath: instancePath + "/sizing", schemaPath: "#/properties/sizing/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                            return false;
                          } else {
                            var valid6 = true;
                            var len2 = data7.length;
                            for (var i2 = 0; i2 < len2; i2++) {
                              var data8 = data7[i2];
                              var _errs20 = errors;
                              if (typeof data8 !== "string") {
                                validate116.errors = [{ instancePath: instancePath + "/sizing/" + i2, schemaPath: "#/definitions/TextSizing/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (!(data8 === "absolute" || data8 === "auto")) {
                                validate116.errors = [{ instancePath: instancePath + "/sizing/" + i2, schemaPath: "#/definitions/TextSizing/enum", keyword: "enum", params: { allowedValues: schema90.enum }, message: "must be equal to one of the allowed values" }];
                                return false;
                              }
                              var valid6 = _errs20 === errors;
                              if (!valid6) {
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        validate116.errors = [{ instancePath: instancePath + "/sizing", schemaPath: "#/properties/sizing/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs18 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.autoLineHeight !== void 0) {
                      var _errs23 = errors;
                      if (typeof data.autoLineHeight !== "boolean") {
                        validate116.errors = [{ instancePath: instancePath + "/autoLineHeight", schemaPath: "#/properties/autoLineHeight/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs23 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.shadows !== void 0) {
                        var data10 = data.shadows;
                        var _errs25 = errors;
                        if (errors === _errs25) {
                          if (Array.isArray(data10)) {
                            var valid8 = true;
                            var len3 = data10.length;
                            for (var i3 = 0; i3 < len3; i3++) {
                              var _errs27 = errors;
                              if (!validate54(data10[i3], { instancePath: instancePath + "/shadows/" + i3, parentData: data10, parentDataProperty: i3, rootData })) {
                                vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                errors = vErrors.length;
                              }
                              var valid8 = _errs27 === errors;
                              if (!valid8) {
                                break;
                              }
                            }
                          } else {
                            validate116.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs25 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.innerShadows !== void 0) {
                          var data12 = data.innerShadows;
                          var _errs28 = errors;
                          if (errors === _errs28) {
                            if (Array.isArray(data12)) {
                              var valid9 = true;
                              var len4 = data12.length;
                              for (var i4 = 0; i4 < len4; i4++) {
                                var _errs30 = errors;
                                if (!validate54(data12[i4], { instancePath: instancePath + "/innerShadows/" + i4, parentData: data12, parentDataProperty: i4, rootData })) {
                                  vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                                  errors = vErrors.length;
                                }
                                var valid9 = _errs30 === errors;
                                if (!valid9) {
                                  break;
                                }
                              }
                            } else {
                              validate116.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                              return false;
                            }
                          }
                          var valid0 = _errs28 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.itemProps !== void 0) {
                            var _errs31 = errors;
                            if (!validate122(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                              vErrors = vErrors === null ? validate122.errors : vErrors.concat(validate122.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs31 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.parentId !== void 0) {
                              var data15 = data.parentId;
                              var _errs32 = errors;
                              if (typeof data15 !== "string" && data15 !== null) {
                                validate116.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema83.properties.parentId.type }, message: "must be string,null" }];
                                return false;
                              }
                              var valid0 = _errs32 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.id !== void 0) {
                                var _errs34 = errors;
                                if (typeof data.id !== "string") {
                                  validate116.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs34 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate116.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate116.errors = vErrors;
  return errors === 0;
}
var schema96 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "Path" }, "segments": { "type": "array", "items": { "$ref": "#/definitions/Segment" } }, "closed": { "type": "boolean" }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalPathData%2Calias-1158747822-11304-11400-1158747822-0-14894%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["className", "closed", "fillStyle", "id", "innerShadows", "itemProps", "parentId", "segments", "shadows", "strokeStyle", "strokes"] };
function validate130(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  var _errs2 = errors;
  if (errors === _errs2) {
    if (Array.isArray(data)) {
      if (data.length > 2) {
        var err0 = { instancePath, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.length < 2) {
          var err1 = { instancePath, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        } else {
          var valid2 = true;
          var len0 = data.length;
          for (var i0 = 0; i0 < len0; i0++) {
            var data0 = data[i0];
            var _errs4 = errors;
            if (!(typeof data0 == "number" && isFinite(data0))) {
              var err2 = { instancePath: instancePath + "/" + i0, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs4 === errors;
            if (!valid2) {
              break;
            }
          }
        }
      }
    } else {
      var err3 = { instancePath, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs6 = errors;
    var _errs7 = errors;
    if (errors === _errs7) {
      if (Array.isArray(data)) {
        if (data.length > 6) {
          var err4 = { instancePath, schemaPath: "#/definitions/BezierPoint/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        } else {
          if (data.length < 6) {
            var err5 = { instancePath, schemaPath: "#/definitions/BezierPoint/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          } else {
            var valid4 = true;
            var len1 = data.length;
            for (var i1 = 0; i1 < len1; i1++) {
              var data1 = data[i1];
              var _errs9 = errors;
              if (!(typeof data1 == "number" && isFinite(data1))) {
                var err6 = { instancePath: instancePath + "/" + i1, schemaPath: "#/definitions/BezierPoint/items/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
              var valid4 = _errs9 === errors;
              if (!valid4) {
                break;
              }
            }
          }
        }
      } else {
        var err7 = { instancePath, schemaPath: "#/definitions/BezierPoint/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    var _valid0 = _errs6 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    var err8 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
    validate130.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate130.errors = vErrors;
  return errors === 0;
}
var schema100 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "END_DECORATION": { "$ref": "#/definitions/LineDecoration" }, "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
var schema102 = { "type": "string", "enum": ["none", "triangleArrow"] };
function validate137(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate137.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema100.properties, key0)) {
            validate137.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate137.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate137.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema100.properties.assets.items.properties, key1)) {
                              validate137.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate137.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate137.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate137.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate137.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate137.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate137.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "END_DECORATION" || key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!Array.isArray(data18)) {
                                          var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/2/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate137.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.END_DECORATION !== void 0) {
                                    var data20 = data17.END_DECORATION;
                                    var _errs59 = errors;
                                    if (typeof data20 !== "string") {
                                      validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/END_DECORATION", schemaPath: "#/definitions/LineDecoration/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    if (!(data20 === "none" || data20 === "triangleArrow")) {
                                      validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/END_DECORATION", schemaPath: "#/definitions/LineDecoration/enum", keyword: "enum", params: { allowedValues: schema102.enum }, message: "must be equal to one of the allowed values" }];
                                      return false;
                                    }
                                    var valid10 = _errs59 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.frame !== void 0) {
                                      var data21 = data17.frame;
                                      var _errs62 = errors;
                                      var _errs63 = errors;
                                      var valid12 = false;
                                      var _errs64 = errors;
                                      if (!validate71(data21, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                        vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid2 = _errs64 === errors;
                                      valid12 = valid12 || _valid2;
                                      if (!valid12) {
                                        var _errs65 = errors;
                                        if (data21 !== null) {
                                          var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err8];
                                          } else {
                                            vErrors.push(err8);
                                          }
                                          errors++;
                                        }
                                        var _valid2 = _errs65 === errors;
                                        valid12 = valid12 || _valid2;
                                      }
                                      if (!valid12) {
                                        var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                        if (vErrors === null) {
                                          vErrors = [err9];
                                        } else {
                                          vErrors.push(err9);
                                        }
                                        errors++;
                                        validate137.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs63;
                                        if (vErrors !== null) {
                                          if (_errs63) {
                                            vErrors.length = _errs63;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid10 = _errs62 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.extrema !== void 0) {
                                        var data22 = data17.extrema;
                                        var _errs67 = errors;
                                        if (errors === _errs67) {
                                          if (Array.isArray(data22)) {
                                            var valid13 = true;
                                            var len2 = data22.length;
                                            for (var i2 = 0; i2 < len2; i2++) {
                                              var data23 = data22[i2];
                                              var _errs69 = errors;
                                              var _errs70 = errors;
                                              if (errors === _errs70) {
                                                if (Array.isArray(data23)) {
                                                  if (data23.length > 2) {
                                                    validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                    return false;
                                                  } else {
                                                    if (data23.length < 2) {
                                                      validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                      return false;
                                                    } else {
                                                      var valid15 = true;
                                                      var len3 = data23.length;
                                                      for (var i3 = 0; i3 < len3; i3++) {
                                                        var data24 = data23[i3];
                                                        var _errs72 = errors;
                                                        if (!(typeof data24 == "number" && isFinite(data24))) {
                                                          validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                          return false;
                                                        }
                                                        var valid15 = _errs72 === errors;
                                                        if (!valid15) {
                                                          break;
                                                        }
                                                      }
                                                    }
                                                  }
                                                } else {
                                                  validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                  return false;
                                                }
                                              }
                                              var valid13 = _errs69 === errors;
                                              if (!valid13) {
                                                break;
                                              }
                                            }
                                          } else {
                                            validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                            return false;
                                          }
                                        }
                                        var valid10 = _errs67 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.isAspectRatioLocked !== void 0) {
                                          var _errs74 = errors;
                                          if (typeof data17.isAspectRatioLocked !== "boolean") {
                                            validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                            return false;
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                        if (valid10) {
                                          if (data17.uploaded !== void 0) {
                                            var data26 = data17.uploaded;
                                            var _errs76 = errors;
                                            var _errs77 = errors;
                                            var valid16 = false;
                                            var _errs78 = errors;
                                            if (errors === _errs78) {
                                              if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
                                                for (var key4 in data26) {
                                                  var _errs81 = errors;
                                                  if (typeof data26[key4] !== "boolean") {
                                                    var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                    if (vErrors === null) {
                                                      vErrors = [err10];
                                                    } else {
                                                      vErrors.push(err10);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid17 = _errs81 === errors;
                                                  if (!valid17) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                if (vErrors === null) {
                                                  vErrors = [err11];
                                                } else {
                                                  vErrors.push(err11);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid3 = _errs78 === errors;
                                            valid16 = valid16 || _valid3;
                                            if (!valid16) {
                                              var _errs83 = errors;
                                              if (typeof data26 !== "boolean") {
                                                var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                if (vErrors === null) {
                                                  vErrors = [err12];
                                                } else {
                                                  vErrors.push(err12);
                                                }
                                                errors++;
                                              }
                                              var _valid3 = _errs83 === errors;
                                              valid16 = valid16 || _valid3;
                                            }
                                            if (!valid16) {
                                              var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                              if (vErrors === null) {
                                                vErrors = [err13];
                                              } else {
                                                vErrors.push(err13);
                                              }
                                              errors++;
                                              validate137.errors = vErrors;
                                              return false;
                                            } else {
                                              errors = _errs77;
                                              if (vErrors !== null) {
                                                if (_errs77) {
                                                  vErrors.length = _errs77;
                                                } else {
                                                  vErrors = null;
                                                }
                                              }
                                            }
                                            var valid10 = _errs76 === errors;
                                          } else {
                                            var valid10 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate137.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate137.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs85 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate137.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs85 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs87 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate137.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs87 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs89 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate137.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs89 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs91 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate137.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs91 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data32 = data.matrix;
                              var _errs93 = errors;
                              var _errs94 = errors;
                              if (errors === _errs94) {
                                if (Array.isArray(data32)) {
                                  if (data32.length > 6) {
                                    validate137.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data32.length < 6) {
                                      validate137.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid19 = true;
                                      var len4 = data32.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data33 = data32[i4];
                                        var _errs96 = errors;
                                        if (!(typeof data33 == "number" && isFinite(data33))) {
                                          validate137.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid19 = _errs96 === errors;
                                        if (!valid19) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate137.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs93 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs98 = errors;
                                if (typeof data.name !== "string") {
                                  validate137.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs98 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data35 = data.opacity;
                                  var _errs100 = errors;
                                  if (!(typeof data35 == "number" && isFinite(data35))) {
                                    validate137.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs100 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate137.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate137.errors = vErrors;
  return errors === 0;
}
function validate129(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.className === void 0 && (missing0 = "className") || data.closed === void 0 && (missing0 = "closed") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.innerShadows === void 0 && (missing0 = "innerShadows") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.segments === void 0 && (missing0 = "segments") || data.shadows === void 0 && (missing0 = "shadows") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes")) {
        validate129.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema96.properties, key0)) {
            validate129.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate129.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "Path") {
              validate129.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "Path" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.segments !== void 0) {
              var data1 = data.segments;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var _errs6 = errors;
                    if (!validate130(data1[i0], { instancePath: instancePath + "/segments/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
                      vErrors = vErrors === null ? validate130.errors : vErrors.concat(validate130.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate129.errors = [{ instancePath: instancePath + "/segments", schemaPath: "#/properties/segments/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.closed !== void 0) {
                var _errs7 = errors;
                if (typeof data.closed !== "boolean") {
                  validate129.errors = [{ instancePath: instancePath + "/closed", schemaPath: "#/properties/closed/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.shadows !== void 0) {
                  var data4 = data.shadows;
                  var _errs9 = errors;
                  if (errors === _errs9) {
                    if (Array.isArray(data4)) {
                      var valid2 = true;
                      var len1 = data4.length;
                      for (var i1 = 0; i1 < len1; i1++) {
                        var _errs11 = errors;
                        if (!validate54(data4[i1], { instancePath: instancePath + "/shadows/" + i1, parentData: data4, parentDataProperty: i1, rootData })) {
                          vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs11 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    } else {
                      validate129.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.innerShadows !== void 0) {
                    var data6 = data.innerShadows;
                    var _errs12 = errors;
                    if (errors === _errs12) {
                      if (Array.isArray(data6)) {
                        var valid3 = true;
                        var len2 = data6.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var _errs14 = errors;
                          if (!validate54(data6[i2], { instancePath: instancePath + "/innerShadows/" + i2, parentData: data6, parentDataProperty: i2, rootData })) {
                            vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                            errors = vErrors.length;
                          }
                          var valid3 = _errs14 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        validate129.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.strokeStyle !== void 0) {
                      var _errs15 = errors;
                      if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                        vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs15 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.strokes !== void 0) {
                        var data9 = data.strokes;
                        var _errs16 = errors;
                        if (errors === _errs16) {
                          if (Array.isArray(data9)) {
                            var valid4 = true;
                            var len3 = data9.length;
                            for (var i3 = 0; i3 < len3; i3++) {
                              var _errs18 = errors;
                              if (!validate60(data9[i3], { instancePath: instancePath + "/strokes/" + i3, parentData: data9, parentDataProperty: i3, rootData })) {
                                vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                                errors = vErrors.length;
                              }
                              var valid4 = _errs18 === errors;
                              if (!valid4) {
                                break;
                              }
                            }
                          } else {
                            validate129.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.fillStyle !== void 0) {
                          var _errs19 = errors;
                          if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                            vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.itemProps !== void 0) {
                            var _errs20 = errors;
                            if (!validate137(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                              vErrors = vErrors === null ? validate137.errors : vErrors.concat(validate137.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.parentId !== void 0) {
                              var data13 = data.parentId;
                              var _errs21 = errors;
                              if (typeof data13 !== "string" && data13 !== null) {
                                validate129.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema96.properties.parentId.type }, message: "must be string,null" }];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.id !== void 0) {
                                var _errs23 = errors;
                                if (typeof data.id !== "string") {
                                  validate129.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate129.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate129.errors = vErrors;
  return errors === 0;
}
var schema105 = { "type": "object", "additionalProperties": false, "properties": { "className": { "type": "string", "const": "CompoundPath" }, "shadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "innerShadows": { "type": "array", "items": { "$ref": "#/definitions/Shadow" } }, "strokeStyle": { "$ref": "#/definitions/StrokeStyle" }, "strokes": { "type": "array", "items": { "$ref": "#/definitions/Stroke" } }, "fillStyle": { "$ref": "#/definitions/FillStyle" }, "children": { "type": "array", "items": { "type": "string" } }, "itemProps": { "$ref": "#/definitions/ItemProps%3CLocalCompoundPathData%2CJsonObject%3E" }, "parentId": { "type": ["string", "null"] }, "id": { "type": "string" } }, "required": ["children", "className", "fillStyle", "id", "innerShadows", "itemProps", "parentId", "shadows", "strokeStyle", "strokes"] };
var schema106 = { "type": "object", "properties": { "applyMatrix": { "type": "boolean" }, "assets": { "type": "array", "items": { "type": "object", "properties": { "className": { "type": "string", "const": "Asset", "deprecated": "Only optional as Sketch plugin is incorrectly not sending this field" }, "name": { "type": "string" }, "prefix": { "type": "string" }, "suffix": { "type": "string" }, "scale": { "type": "number" }, "width": { "type": "number" }, "height": { "type": "number" }, "format": { "type": "string" }, "md5": { "type": "string" }, "url": { "type": "string" } }, "required": ["name", "prefix", "suffix", "scale", "width", "height", "format", "md5", "url"], "additionalProperties": false } }, "blendMode": { "$ref": "#/definitions/BlendMode" }, "blur": { "type": "number" }, "data": { "type": "object", "additionalProperties": { "$ref": "#/definitions/JsonObject" }, "properties": { "MARVEL_DESIGN_CREATOR": { "type": "object", "additionalProperties": { "anyOf": [{ "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "null" }, { "type": "boolean" }, { "type": "array", "items": { "$ref": "#/definitions/alias-1158747822-5345-5413-1158747822-0-14894" } }] }, { "$ref": "#/definitions/JsonObject" }, { "$ref": "#/definitions/JsonObject" }, { "type": "array" }] }, "properties": { "frame": { "anyOf": [{ "$ref": "#/definitions/Rectangle" }, { "type": "null" }] }, "extrema": { "type": "array", "items": { "$ref": "#/definitions/Point" } }, "isAspectRatioLocked": { "type": "boolean" }, "uploaded": { "anyOf": [{ "type": "object", "additionalProperties": { "type": "boolean" } }, { "type": "boolean" }] } } } } }, "flipX": { "type": "boolean" }, "flipY": { "type": "boolean" }, "isExportable": { "type": "boolean" }, "locked": { "type": "boolean" }, "matrix": { "$ref": "#/definitions/Matrix" }, "name": { "type": "string" }, "opacity": { "type": "number" } }, "required": ["applyMatrix", "assets", "blendMode", "blur", "data", "flipX", "flipY", "isExportable", "locked", "matrix", "name", "opacity"], "additionalProperties": false };
function validate150(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.applyMatrix === void 0 && (missing0 = "applyMatrix") || data.assets === void 0 && (missing0 = "assets") || data.blendMode === void 0 && (missing0 = "blendMode") || data.blur === void 0 && (missing0 = "blur") || data.data === void 0 && (missing0 = "data") || data.flipX === void 0 && (missing0 = "flipX") || data.flipY === void 0 && (missing0 = "flipY") || data.isExportable === void 0 && (missing0 = "isExportable") || data.locked === void 0 && (missing0 = "locked") || data.matrix === void 0 && (missing0 = "matrix") || data.name === void 0 && (missing0 = "name") || data.opacity === void 0 && (missing0 = "opacity")) {
        validate150.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema106.properties, key0)) {
            validate150.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.applyMatrix !== void 0) {
            var _errs2 = errors;
            if (typeof data.applyMatrix !== "boolean") {
              validate150.errors = [{ instancePath: instancePath + "/applyMatrix", schemaPath: "#/properties/applyMatrix/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.assets !== void 0) {
              var data1 = data.assets;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var data2 = data1[i0];
                    var _errs6 = errors;
                    if (errors === _errs6) {
                      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        var missing1 = void 0;
                        if (data2.name === void 0 && (missing1 = "name") || data2.prefix === void 0 && (missing1 = "prefix") || data2.suffix === void 0 && (missing1 = "suffix") || data2.scale === void 0 && (missing1 = "scale") || data2.width === void 0 && (missing1 = "width") || data2.height === void 0 && (missing1 = "height") || data2.format === void 0 && (missing1 = "format") || data2.md5 === void 0 && (missing1 = "md5") || data2.url === void 0 && (missing1 = "url")) {
                          validate150.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/required", keyword: "required", params: { missingProperty: missing1 }, message: "must have required property '" + missing1 + "'" }];
                          return false;
                        } else {
                          var _errs8 = errors;
                          for (var key1 in data2) {
                            if (!func2.call(schema106.properties.assets.items.properties, key1)) {
                              validate150.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" }];
                              return false;
                              break;
                            }
                          }
                          if (_errs8 === errors) {
                            if (data2.className !== void 0) {
                              var data3 = data2.className;
                              var _errs9 = errors;
                              if (typeof data3 !== "string") {
                                validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              if (data3 !== "Asset") {
                                validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/className", schemaPath: "#/properties/assets/items/properties/className/const", keyword: "const", params: { allowedValue: "Asset" }, message: "must be equal to constant" }];
                                return false;
                              }
                              var valid2 = _errs9 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data2.name !== void 0) {
                                var _errs11 = errors;
                                if (typeof data2.name !== "string") {
                                  validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/name", schemaPath: "#/properties/assets/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid2 = _errs11 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data2.prefix !== void 0) {
                                  var _errs13 = errors;
                                  if (typeof data2.prefix !== "string") {
                                    validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/prefix", schemaPath: "#/properties/assets/items/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                  }
                                  var valid2 = _errs13 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data2.suffix !== void 0) {
                                    var _errs15 = errors;
                                    if (typeof data2.suffix !== "string") {
                                      validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/suffix", schemaPath: "#/properties/assets/items/properties/suffix/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                      return false;
                                    }
                                    var valid2 = _errs15 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data2.scale !== void 0) {
                                      var data7 = data2.scale;
                                      var _errs17 = errors;
                                      if (!(typeof data7 == "number" && isFinite(data7))) {
                                        validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/scale", schemaPath: "#/properties/assets/items/properties/scale/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                        return false;
                                      }
                                      var valid2 = _errs17 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data2.width !== void 0) {
                                        var data8 = data2.width;
                                        var _errs19 = errors;
                                        if (!(typeof data8 == "number" && isFinite(data8))) {
                                          validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/width", schemaPath: "#/properties/assets/items/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid2 = _errs19 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data2.height !== void 0) {
                                          var data9 = data2.height;
                                          var _errs21 = errors;
                                          if (!(typeof data9 == "number" && isFinite(data9))) {
                                            validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/height", schemaPath: "#/properties/assets/items/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                            return false;
                                          }
                                          var valid2 = _errs21 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data2.format !== void 0) {
                                            var _errs23 = errors;
                                            if (typeof data2.format !== "string") {
                                              validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/format", schemaPath: "#/properties/assets/items/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                              return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data2.md5 !== void 0) {
                                              var _errs25 = errors;
                                              if (typeof data2.md5 !== "string") {
                                                validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/md5", schemaPath: "#/properties/assets/items/properties/md5/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                return false;
                                              }
                                              var valid2 = _errs25 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (data2.url !== void 0) {
                                                var _errs27 = errors;
                                                if (typeof data2.url !== "string") {
                                                  validate150.errors = [{ instancePath: instancePath + "/assets/" + i0 + "/url", schemaPath: "#/properties/assets/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                  return false;
                                                }
                                                var valid2 = _errs27 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        validate150.errors = [{ instancePath: instancePath + "/assets/" + i0, schemaPath: "#/properties/assets/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate150.errors = [{ instancePath: instancePath + "/assets", schemaPath: "#/properties/assets/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.blendMode !== void 0) {
                var data13 = data.blendMode;
                var _errs29 = errors;
                if (typeof data13 !== "string") {
                  validate150.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                  return false;
                }
                if (!(data13 === "normal" || data13 === "multiply" || data13 === "screen" || data13 === "overlay" || data13 === "darken" || data13 === "lighten" || data13 === "color-dodge" || data13 === "color-burn" || data13 === "hard-light" || data13 === "soft-light" || data13 === "difference" || data13 === "exclusion" || data13 === "hue" || data13 === "saturation" || data13 === "color" || data13 === "luminosity")) {
                  validate150.errors = [{ instancePath: instancePath + "/blendMode", schemaPath: "#/definitions/BlendMode/enum", keyword: "enum", params: { allowedValues: schema23.enum }, message: "must be equal to one of the allowed values" }];
                  return false;
                }
                var valid0 = _errs29 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.blur !== void 0) {
                  var data14 = data.blur;
                  var _errs32 = errors;
                  if (!(typeof data14 == "number" && isFinite(data14))) {
                    validate150.errors = [{ instancePath: instancePath + "/blur", schemaPath: "#/properties/blur/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                    return false;
                  }
                  var valid0 = _errs32 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.data !== void 0) {
                    var data15 = data.data;
                    var _errs34 = errors;
                    if (errors === _errs34) {
                      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                        var _errs36 = errors;
                        for (var key2 in data15) {
                          if (!(key2 === "MARVEL_DESIGN_CREATOR")) {
                            var _errs37 = errors;
                            if (!validate13(data15[key2], { instancePath: instancePath + "/data/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data15, parentDataProperty: key2, rootData })) {
                              vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                              errors = vErrors.length;
                            }
                            var valid4 = _errs37 === errors;
                            if (!valid4) {
                              break;
                            }
                          }
                        }
                        if (_errs36 === errors) {
                          if (data15.MARVEL_DESIGN_CREATOR !== void 0) {
                            var data17 = data15.MARVEL_DESIGN_CREATOR;
                            var _errs38 = errors;
                            if (errors === _errs38) {
                              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                var _errs40 = errors;
                                for (var key3 in data17) {
                                  if (!(key3 === "frame" || key3 === "extrema" || key3 === "isAspectRatioLocked" || key3 === "uploaded")) {
                                    var data18 = data17[key3];
                                    var _errs41 = errors;
                                    var _errs42 = errors;
                                    var valid7 = false;
                                    var _errs43 = errors;
                                    var _errs44 = errors;
                                    var valid8 = false;
                                    var _errs45 = errors;
                                    if (typeof data18 !== "string") {
                                      var err0 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                      if (vErrors === null) {
                                        vErrors = [err0];
                                      } else {
                                        vErrors.push(err0);
                                      }
                                      errors++;
                                    }
                                    var _valid1 = _errs45 === errors;
                                    valid8 = valid8 || _valid1;
                                    if (!valid8) {
                                      var _errs47 = errors;
                                      if (!(typeof data18 == "number" && isFinite(data18))) {
                                        var err1 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/1/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                        if (vErrors === null) {
                                          vErrors = [err1];
                                        } else {
                                          vErrors.push(err1);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs47 === errors;
                                      valid8 = valid8 || _valid1;
                                      if (!valid8) {
                                        var _errs49 = errors;
                                        if (data18 !== null) {
                                          var err2 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/2/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                          if (vErrors === null) {
                                            vErrors = [err2];
                                          } else {
                                            vErrors.push(err2);
                                          }
                                          errors++;
                                        }
                                        var _valid1 = _errs49 === errors;
                                        valid8 = valid8 || _valid1;
                                        if (!valid8) {
                                          var _errs51 = errors;
                                          if (typeof data18 !== "boolean") {
                                            var err3 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/3/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                              vErrors = [err3];
                                            } else {
                                              vErrors.push(err3);
                                            }
                                            errors++;
                                          }
                                          var _valid1 = _errs51 === errors;
                                          valid8 = valid8 || _valid1;
                                          if (!valid8) {
                                            var _errs53 = errors;
                                            if (errors === _errs53) {
                                              if (Array.isArray(data18)) {
                                                var valid9 = true;
                                                var len1 = data18.length;
                                                for (var i1 = 0; i1 < len1; i1++) {
                                                  var _errs55 = errors;
                                                  if (!validate14(data18[i1], { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1") + "/" + i1, parentData: data18, parentDataProperty: i1, rootData })) {
                                                    vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                                                    errors = vErrors.length;
                                                  }
                                                  var valid9 = _errs55 === errors;
                                                  if (!valid9) {
                                                    break;
                                                  }
                                                }
                                              } else {
                                                var err4 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf/4/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                                if (vErrors === null) {
                                                  vErrors = [err4];
                                                } else {
                                                  vErrors.push(err4);
                                                }
                                                errors++;
                                              }
                                            }
                                            var _valid1 = _errs53 === errors;
                                            valid8 = valid8 || _valid1;
                                          }
                                        }
                                      }
                                    }
                                    if (!valid8) {
                                      var err5 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/0/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err5];
                                      } else {
                                        vErrors.push(err5);
                                      }
                                      errors++;
                                    } else {
                                      errors = _errs44;
                                      if (vErrors !== null) {
                                        if (_errs44) {
                                          vErrors.length = _errs44;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var _valid0 = _errs43 === errors;
                                    valid7 = valid7 || _valid0;
                                    if (!valid7) {
                                      var _errs56 = errors;
                                      if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var _valid0 = _errs56 === errors;
                                      valid7 = valid7 || _valid0;
                                      if (!valid7) {
                                        var _errs57 = errors;
                                        if (!validate13(data18, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data17, parentDataProperty: key3, rootData })) {
                                          vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                                          errors = vErrors.length;
                                        }
                                        var _valid0 = _errs57 === errors;
                                        valid7 = valid7 || _valid0;
                                        if (!valid7) {
                                          var _errs58 = errors;
                                          if (!Array.isArray(data18)) {
                                            var err6 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf/3/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                            if (vErrors === null) {
                                              vErrors = [err6];
                                            } else {
                                              vErrors.push(err6);
                                            }
                                            errors++;
                                          }
                                          var _valid0 = _errs58 === errors;
                                          valid7 = valid7 || _valid0;
                                        }
                                      }
                                    }
                                    if (!valid7) {
                                      var err7 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err7];
                                      } else {
                                        vErrors.push(err7);
                                      }
                                      errors++;
                                      validate150.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs42;
                                      if (vErrors !== null) {
                                        if (_errs42) {
                                          vErrors.length = _errs42;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid6 = _errs41 === errors;
                                    if (!valid6) {
                                      break;
                                    }
                                  }
                                }
                                if (_errs40 === errors) {
                                  if (data17.frame !== void 0) {
                                    var data20 = data17.frame;
                                    var _errs60 = errors;
                                    var _errs61 = errors;
                                    var valid11 = false;
                                    var _errs62 = errors;
                                    if (!validate71(data20, { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", parentData: data17, parentDataProperty: "frame", rootData })) {
                                      vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
                                      errors = vErrors.length;
                                    }
                                    var _valid2 = _errs62 === errors;
                                    valid11 = valid11 || _valid2;
                                    if (!valid11) {
                                      var _errs63 = errors;
                                      if (data20 !== null) {
                                        var err8 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                        if (vErrors === null) {
                                          vErrors = [err8];
                                        } else {
                                          vErrors.push(err8);
                                        }
                                        errors++;
                                      }
                                      var _valid2 = _errs63 === errors;
                                      valid11 = valid11 || _valid2;
                                    }
                                    if (!valid11) {
                                      var err9 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/frame", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/frame/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                      if (vErrors === null) {
                                        vErrors = [err9];
                                      } else {
                                        vErrors.push(err9);
                                      }
                                      errors++;
                                      validate150.errors = vErrors;
                                      return false;
                                    } else {
                                      errors = _errs61;
                                      if (vErrors !== null) {
                                        if (_errs61) {
                                          vErrors.length = _errs61;
                                        } else {
                                          vErrors = null;
                                        }
                                      }
                                    }
                                    var valid10 = _errs60 === errors;
                                  } else {
                                    var valid10 = true;
                                  }
                                  if (valid10) {
                                    if (data17.extrema !== void 0) {
                                      var data21 = data17.extrema;
                                      var _errs65 = errors;
                                      if (errors === _errs65) {
                                        if (Array.isArray(data21)) {
                                          var valid12 = true;
                                          var len2 = data21.length;
                                          for (var i2 = 0; i2 < len2; i2++) {
                                            var data22 = data21[i2];
                                            var _errs67 = errors;
                                            var _errs68 = errors;
                                            if (errors === _errs68) {
                                              if (Array.isArray(data22)) {
                                                if (data22.length > 2) {
                                                  validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" }];
                                                  return false;
                                                } else {
                                                  if (data22.length < 2) {
                                                    validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" }];
                                                    return false;
                                                  } else {
                                                    var valid14 = true;
                                                    var len3 = data22.length;
                                                    for (var i3 = 0; i3 < len3; i3++) {
                                                      var data23 = data22[i3];
                                                      var _errs70 = errors;
                                                      if (!(typeof data23 == "number" && isFinite(data23))) {
                                                        validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2 + "/" + i3, schemaPath: "#/definitions/Point/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                                        return false;
                                                      }
                                                      var valid14 = _errs70 === errors;
                                                      if (!valid14) {
                                                        break;
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema/" + i2, schemaPath: "#/definitions/Point/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                                return false;
                                              }
                                            }
                                            var valid12 = _errs67 === errors;
                                            if (!valid12) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/extrema", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/extrema/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                          return false;
                                        }
                                      }
                                      var valid10 = _errs65 === errors;
                                    } else {
                                      var valid10 = true;
                                    }
                                    if (valid10) {
                                      if (data17.isAspectRatioLocked !== void 0) {
                                        var _errs72 = errors;
                                        if (typeof data17.isAspectRatioLocked !== "boolean") {
                                          validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/isAspectRatioLocked", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/isAspectRatioLocked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                                          return false;
                                        }
                                        var valid10 = _errs72 === errors;
                                      } else {
                                        var valid10 = true;
                                      }
                                      if (valid10) {
                                        if (data17.uploaded !== void 0) {
                                          var data25 = data17.uploaded;
                                          var _errs74 = errors;
                                          var _errs75 = errors;
                                          var valid15 = false;
                                          var _errs76 = errors;
                                          if (errors === _errs76) {
                                            if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                                              for (var key4 in data25) {
                                                var _errs79 = errors;
                                                if (typeof data25[key4] !== "boolean") {
                                                  var err10 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded/" + key4.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/additionalProperties/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                  if (vErrors === null) {
                                                    vErrors = [err10];
                                                  } else {
                                                    vErrors.push(err10);
                                                  }
                                                  errors++;
                                                }
                                                var valid16 = _errs79 === errors;
                                                if (!valid16) {
                                                  break;
                                                }
                                              }
                                            } else {
                                              var err11 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                              if (vErrors === null) {
                                                vErrors = [err11];
                                              } else {
                                                vErrors.push(err11);
                                              }
                                              errors++;
                                            }
                                          }
                                          var _valid3 = _errs76 === errors;
                                          valid15 = valid15 || _valid3;
                                          if (!valid15) {
                                            var _errs81 = errors;
                                            if (typeof data25 !== "boolean") {
                                              var err12 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf/1/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                              if (vErrors === null) {
                                                vErrors = [err12];
                                              } else {
                                                vErrors.push(err12);
                                              }
                                              errors++;
                                            }
                                            var _valid3 = _errs81 === errors;
                                            valid15 = valid15 || _valid3;
                                          }
                                          if (!valid15) {
                                            var err13 = { instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR/uploaded", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/properties/uploaded/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                                            if (vErrors === null) {
                                              vErrors = [err13];
                                            } else {
                                              vErrors.push(err13);
                                            }
                                            errors++;
                                            validate150.errors = vErrors;
                                            return false;
                                          } else {
                                            errors = _errs75;
                                            if (vErrors !== null) {
                                              if (_errs75) {
                                                vErrors.length = _errs75;
                                              } else {
                                                vErrors = null;
                                              }
                                            }
                                          }
                                          var valid10 = _errs74 === errors;
                                        } else {
                                          var valid10 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate150.errors = [{ instancePath: instancePath + "/data/MARVEL_DESIGN_CREATOR", schemaPath: "#/properties/data/properties/MARVEL_DESIGN_CREATOR/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        validate150.errors = [{ instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.flipX !== void 0) {
                      var _errs83 = errors;
                      if (typeof data.flipX !== "boolean") {
                        validate150.errors = [{ instancePath: instancePath + "/flipX", schemaPath: "#/properties/flipX/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                        return false;
                      }
                      var valid0 = _errs83 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.flipY !== void 0) {
                        var _errs85 = errors;
                        if (typeof data.flipY !== "boolean") {
                          validate150.errors = [{ instancePath: instancePath + "/flipY", schemaPath: "#/properties/flipY/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                          return false;
                        }
                        var valid0 = _errs85 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isExportable !== void 0) {
                          var _errs87 = errors;
                          if (typeof data.isExportable !== "boolean") {
                            validate150.errors = [{ instancePath: instancePath + "/isExportable", schemaPath: "#/properties/isExportable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                            return false;
                          }
                          var valid0 = _errs87 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.locked !== void 0) {
                            var _errs89 = errors;
                            if (typeof data.locked !== "boolean") {
                              validate150.errors = [{ instancePath: instancePath + "/locked", schemaPath: "#/properties/locked/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" }];
                              return false;
                            }
                            var valid0 = _errs89 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.matrix !== void 0) {
                              var data31 = data.matrix;
                              var _errs91 = errors;
                              var _errs92 = errors;
                              if (errors === _errs92) {
                                if (Array.isArray(data31)) {
                                  if (data31.length > 6) {
                                    validate150.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" }];
                                    return false;
                                  } else {
                                    if (data31.length < 6) {
                                      validate150.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/minItems", keyword: "minItems", params: { limit: 6 }, message: "must NOT have fewer than 6 items" }];
                                      return false;
                                    } else {
                                      var valid18 = true;
                                      var len4 = data31.length;
                                      for (var i4 = 0; i4 < len4; i4++) {
                                        var data32 = data31[i4];
                                        var _errs94 = errors;
                                        if (!(typeof data32 == "number" && isFinite(data32))) {
                                          validate150.errors = [{ instancePath: instancePath + "/matrix/" + i4, schemaPath: "#/definitions/Matrix/items/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                          return false;
                                        }
                                        var valid18 = _errs94 === errors;
                                        if (!valid18) {
                                          break;
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  validate150.errors = [{ instancePath: instancePath + "/matrix", schemaPath: "#/definitions/Matrix/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                                  return false;
                                }
                              }
                              var valid0 = _errs91 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== void 0) {
                                var _errs96 = errors;
                                if (typeof data.name !== "string") {
                                  validate150.errors = [{ instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                  return false;
                                }
                                var valid0 = _errs96 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.opacity !== void 0) {
                                  var data34 = data.opacity;
                                  var _errs98 = errors;
                                  if (!(typeof data34 == "number" && isFinite(data34))) {
                                    validate150.errors = [{ instancePath: instancePath + "/opacity", schemaPath: "#/properties/opacity/type", keyword: "type", params: { type: "number" }, message: "must be number" }];
                                    return false;
                                  }
                                  var valid0 = _errs98 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate150.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate150.errors = vErrors;
  return errors === 0;
}
function validate144(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.children === void 0 && (missing0 = "children") || data.className === void 0 && (missing0 = "className") || data.fillStyle === void 0 && (missing0 = "fillStyle") || data.id === void 0 && (missing0 = "id") || data.innerShadows === void 0 && (missing0 = "innerShadows") || data.itemProps === void 0 && (missing0 = "itemProps") || data.parentId === void 0 && (missing0 = "parentId") || data.shadows === void 0 && (missing0 = "shadows") || data.strokeStyle === void 0 && (missing0 = "strokeStyle") || data.strokes === void 0 && (missing0 = "strokes")) {
        validate144.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!func2.call(schema105.properties, key0)) {
            validate144.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.className !== void 0) {
            var data0 = data.className;
            var _errs2 = errors;
            if (typeof data0 !== "string") {
              validate144.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
              return false;
            }
            if (data0 !== "CompoundPath") {
              validate144.errors = [{ instancePath: instancePath + "/className", schemaPath: "#/properties/className/const", keyword: "const", params: { allowedValue: "CompoundPath" }, message: "must be equal to constant" }];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.shadows !== void 0) {
              var data1 = data.shadows;
              var _errs4 = errors;
              if (errors === _errs4) {
                if (Array.isArray(data1)) {
                  var valid1 = true;
                  var len0 = data1.length;
                  for (var i0 = 0; i0 < len0; i0++) {
                    var _errs6 = errors;
                    if (!validate54(data1[i0], { instancePath: instancePath + "/shadows/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
                      vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs6 === errors;
                    if (!valid1) {
                      break;
                    }
                  }
                } else {
                  validate144.errors = [{ instancePath: instancePath + "/shadows", schemaPath: "#/properties/shadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.innerShadows !== void 0) {
                var data3 = data.innerShadows;
                var _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data3)) {
                    var valid2 = true;
                    var len1 = data3.length;
                    for (var i1 = 0; i1 < len1; i1++) {
                      var _errs9 = errors;
                      if (!validate54(data3[i1], { instancePath: instancePath + "/innerShadows/" + i1, parentData: data3, parentDataProperty: i1, rootData })) {
                        vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate144.errors = [{ instancePath: instancePath + "/innerShadows", schemaPath: "#/properties/innerShadows/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.strokeStyle !== void 0) {
                  var _errs10 = errors;
                  if (!validate58(data.strokeStyle, { instancePath: instancePath + "/strokeStyle", parentData: data, parentDataProperty: "strokeStyle", rootData })) {
                    vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.strokes !== void 0) {
                    var data6 = data.strokes;
                    var _errs11 = errors;
                    if (errors === _errs11) {
                      if (Array.isArray(data6)) {
                        var valid3 = true;
                        var len2 = data6.length;
                        for (var i2 = 0; i2 < len2; i2++) {
                          var _errs13 = errors;
                          if (!validate60(data6[i2], { instancePath: instancePath + "/strokes/" + i2, parentData: data6, parentDataProperty: i2, rootData })) {
                            vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                            errors = vErrors.length;
                          }
                          var valid3 = _errs13 === errors;
                          if (!valid3) {
                            break;
                          }
                        }
                      } else {
                        validate144.errors = [{ instancePath: instancePath + "/strokes", schemaPath: "#/properties/strokes/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.fillStyle !== void 0) {
                      var _errs14 = errors;
                      if (!validate63(data.fillStyle, { instancePath: instancePath + "/fillStyle", parentData: data, parentDataProperty: "fillStyle", rootData })) {
                        vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.children !== void 0) {
                        var data9 = data.children;
                        var _errs15 = errors;
                        if (errors === _errs15) {
                          if (Array.isArray(data9)) {
                            var valid4 = true;
                            var len3 = data9.length;
                            for (var i3 = 0; i3 < len3; i3++) {
                              var _errs17 = errors;
                              if (typeof data9[i3] !== "string") {
                                validate144.errors = [{ instancePath: instancePath + "/children/" + i3, schemaPath: "#/properties/children/items/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid4 = _errs17 === errors;
                              if (!valid4) {
                                break;
                              }
                            }
                          } else {
                            validate144.errors = [{ instancePath: instancePath + "/children", schemaPath: "#/properties/children/type", keyword: "type", params: { type: "array" }, message: "must be array" }];
                            return false;
                          }
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.itemProps !== void 0) {
                          var _errs19 = errors;
                          if (!validate150(data.itemProps, { instancePath: instancePath + "/itemProps", parentData: data, parentDataProperty: "itemProps", rootData })) {
                            vErrors = vErrors === null ? validate150.errors : vErrors.concat(validate150.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.parentId !== void 0) {
                            var data12 = data.parentId;
                            var _errs20 = errors;
                            if (typeof data12 !== "string" && data12 !== null) {
                              validate144.errors = [{ instancePath: instancePath + "/parentId", schemaPath: "#/properties/parentId/type", keyword: "type", params: { type: schema105.properties.parentId.type }, message: "must be string,null" }];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.id !== void 0) {
                              var _errs22 = errors;
                              if (typeof data.id !== "string") {
                                validate144.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate144.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate144.errors = vErrors;
  return errors === 0;
}
function validate52(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  var _errs0 = errors;
  var valid0 = false;
  var _errs1 = errors;
  if (!validate53(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    var _errs2 = errors;
    if (!validate75(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      var _errs3 = errors;
      if (!validate89(data, { instancePath, parentData, parentDataProperty, rootData })) {
        vErrors = vErrors === null ? validate89.errors : vErrors.concat(validate89.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs3 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        var _errs4 = errors;
        if (!validate102(data, { instancePath, parentData, parentDataProperty, rootData })) {
          vErrors = vErrors === null ? validate102.errors : vErrors.concat(validate102.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs4 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          var _errs5 = errors;
          if (!validate116(data, { instancePath, parentData, parentDataProperty, rootData })) {
            vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs5 === errors;
          valid0 = valid0 || _valid0;
          if (!valid0) {
            var _errs6 = errors;
            if (!validate129(data, { instancePath, parentData, parentDataProperty, rootData })) {
              vErrors = vErrors === null ? validate129.errors : vErrors.concat(validate129.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs6 === errors;
            valid0 = valid0 || _valid0;
            if (!valid0) {
              var _errs7 = errors;
              if (!validate144(data, { instancePath, parentData, parentDataProperty, rootData })) {
                vErrors = vErrors === null ? validate144.errors : vErrors.concat(validate144.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs7 === errors;
              valid0 = valid0 || _valid0;
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    var err0 = { instancePath, schemaPath: "#/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate52.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
function validate11(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
      var missing0 = void 0;
      if (data.data === void 0 && (missing0 = "data") || data.items === void 0 && (missing0 = "items") || data.root === void 0 && (missing0 = "root") || data.tokens === void 0 && (missing0 = "tokens")) {
        validate11.errors = [{ instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: missing0 }, message: "must have required property '" + missing0 + "'" }];
        return false;
      } else {
        var _errs1 = errors;
        for (var key0 in data) {
          if (!(key0 === "data" || key0 === "tokens" || key0 === "root" || key0 === "items")) {
            validate11.errors = [{ instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" }];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.data !== void 0) {
            var _errs2 = errors;
            if (!validate12(data.data, { instancePath: instancePath + "/data", parentData: data, parentDataProperty: "data", rootData })) {
              vErrors = vErrors === null ? validate12.errors : vErrors.concat(validate12.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.tokens !== void 0) {
              var _errs3 = errors;
              if (!validate20(data.tokens, { instancePath: instancePath + "/tokens", parentData: data, parentDataProperty: "tokens", rootData })) {
                vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.root !== void 0) {
                var _errs4 = errors;
                if (!validate24(data.root, { instancePath: instancePath + "/root", parentData: data, parentDataProperty: "root", rootData })) {
                  vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.items !== void 0) {
                  var data3 = data.items;
                  var _errs5 = errors;
                  if (errors === _errs5) {
                    if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
                      for (var key1 in data3) {
                        var _errs8 = errors;
                        if (!validate52(data3[key1], { instancePath: instancePath + "/items/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), parentData: data3, parentDataProperty: key1, rootData })) {
                          vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
                          errors = vErrors.length;
                        }
                        var valid1 = _errs8 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate11.errors = [{ instancePath: instancePath + "/items", schemaPath: "#/properties/items/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
                      return false;
                    }
                  }
                  var valid0 = _errs5 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate11.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
function validate10(data, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.instancePath, instancePath = _c === void 0 ? "" : _c, parentData = _b.parentData, parentDataProperty = _b.parentDataProperty, _d = _b.rootData, rootData = _d === void 0 ? data : _d;
  var vErrors = null;
  var errors = 0;
  if (!validate11(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
    errors = vErrors.length;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
var validate_default = validate10;

// src/validate/index.ts
var validate = validate_default;

// src/testUtils/index.ts
var testUtils_exports = {};
__export(testUtils_exports, {
  canvasBuilder: () => canvasBuilder,
  dedentTree: () => dedentTree,
  fromJSX: () => render,
  fromJSXString: () => fromJSXString,
  fromTree: () => fromTree,
  groupBuilder: () => groupBuilder,
  toTree: () => toTree
});

// src/testUtils/testUtils.ts
function toTree(fragment, formatItem = ItemUtils_exports.getName) {
  let tree = "";
  for (const [item2, { depth }] of selectors_exports5.walk(fragment)) {
    const name = formatItem(item2) || `${ItemUtils_exports.getClassName(item2).toLowerCase()}0`;
    tree += `${"|   ".repeat(Math.max(depth - 1, 0))}${depth ? "|---" : ""}${name}
`;
  }
  return tree;
}
function dedentTree(tree) {
  return `${tree.replace(/^\s+/gm, "")}
`;
}
function fromTree(tree) {
  const lines = tree.trim().split("\n");
  const canvas = CanvasUtils_exports.create({ id: "canvas" });
  const fragment = FragmentUtils_exports.create(canvas);
  const ancestors = [];
  let lastDepth = 0;
  let lastId = "";
  const types = ["group", "ellipse", "rectangle"];
  const re = new RegExp(String.raw`\s*((?:\| {3})*(?:\|---\s*))?(${types.join("|")})(\d+)`, "i");
  for (const line of lines) {
    const matches = line.match(re);
    if (matches === null) {
      throw new Error("invalid tree syntax");
    }
    const [, separator, type, number] = matches;
    const id = `${type}${number}`;
    if (selectors_exports5.getItemById(fragment, id)) {
      throw new Error(`multiple items called "${id}" found, names must be unique`);
    }
    const depth = separator ? separator.split("|").length - 1 : 0;
    let item2;
    switch (type) {
      case "group":
        item2 = GroupUtils_exports.create({ id });
        break;
      case "ellipse":
        item2 = ShapeUtils_exports.createEllipse({ id });
        break;
      case "rectangle":
        item2 = ShapeUtils_exports.createRectangle({ id });
        break;
      default:
        throw new Error(`unrecognised item type ${type}`);
    }
    if (number !== "0") {
      ItemUtils_exports.mSetName(item2, id);
    }
    if (depth > lastDepth) {
      ancestors.push(lastId);
    } else if (depth < lastDepth) {
      ancestors.pop();
    }
    FragmentUtils_exports.mAppendItems(fragment, [item2], ancestors[ancestors.length - 1]);
    lastId = id;
    lastDepth = depth;
  }
  return fragment;
}

// src/testUtils/builders.ts
function createFragmentBuilder(fragment) {
  const insertShape = (item2, args) => {
    ItemUtils_exports.mSetName(item2, item2.id);
    ShapeUtils_exports.mSetSize(item2, (args == null ? void 0 : args.size) || [100, 100]);
    ItemUtils_exports.mTranslate(item2, (args == null ? void 0 : args.point) || [1, 1]);
    FragmentUtils_exports.mAppendItems(fragment, [item2]);
  };
  return {
    withRectangle(id, args) {
      const item2 = ShapeUtils_exports.createRectangle({ id });
      insertShape(item2, args);
      return this;
    },
    withEllipse(id, args) {
      const item2 = ShapeUtils_exports.createEllipse({ id });
      insertShape(item2, args);
      return this;
    },
    withGroup(id, callback) {
      const builder = groupBuilder(id);
      callback(builder);
      const group = builder.build();
      FragmentUtils_exports.mAppendFragments(fragment, [group]);
      return this;
    },
    build: () => {
      return fragment;
    }
  };
}
function canvasBuilder() {
  const canvas = CanvasUtils_exports.create();
  const fragment = FragmentUtils_exports.create(canvas);
  return createFragmentBuilder(fragment);
}
function groupBuilder(groupId) {
  const groupItem = GroupUtils_exports.create({ id: groupId });
  ItemUtils_exports.mSetName(groupItem, groupId);
  const fragment = FragmentUtils_exports.create(groupItem);
  return createFragmentBuilder(fragment);
}

// src/testUtils/jsxUtils.tsx
import React from "react";
import JsxParser from "react-jsx-parser";

// src/testUtils/designReconciler.ts
import Reconciler from "react-reconciler";
var itemCreator = {
  mGroup: GroupUtils_exports.create,
  mRectangle: ShapeUtils_exports.createRectangle,
  mEllipse: ShapeUtils_exports.createEllipse,
  mText: TextUtils_exports.create,
  mPath: PathUtils_exports.createPath,
  mRaster: RasterUtils_exports.create
};
Object.keys(itemCreator).forEach((key) => {
  itemCreator[key.toLowerCase()] = itemCreator[key];
});
var hostConfig = {
  supportsMutation: true,
  createInstance(type, props) {
    const creator = itemCreator[type];
    if (!creator) {
      throw new Error(`Unknown type: ${type}`);
    }
    const item2 = creator();
    ItemUtils_exports.mSetName(item2, `${props.id}`);
    const fragment = FragmentUtils_exports.create(item2);
    applyProps(fragment, props);
    return fragment;
  },
  appendInitialChild(parent, child) {
    if (typeof child === "string") {
      return;
    }
    FragmentUtils_exports.mAppendFragments(parent, [child]);
  },
  appendChild(parent, child) {
    if (typeof child === "string") {
      return;
    }
    FragmentUtils_exports.mAppendFragments(parent, [child]);
  },
  appendChildToContainer(parent, child) {
    if (typeof child === "string") {
      return;
    }
    FragmentUtils_exports.mAppendFragments(parent, [child]);
  },
  removeChild() {
  },
  prepareUpdate() {
    return null;
  },
  getPublicInstance() {
    return null;
  },
  getRootHostContext: () => {
    return null;
  },
  prepareForCommit: () => {
    return null;
  },
  resetAfterCommit: () => {
  },
  getChildHostContext: (parentHostContext) => {
    return parentHostContext;
  },
  shouldSetTextContent() {
    return false;
  },
  finalizeInitialChildren() {
    return false;
  },
  clearContainer() {
  },
  createTextInstance(text) {
    return text;
  },
  preparePortalMount() {
  },
  scheduleTimeout: setTimeout,
  cancelTimeout: clearTimeout,
  supportsHydration: false,
  supportsPersistence: false,
  now: performance.now,
  noTimeout: -1,
  queueMicrotask(fn) {
    fn();
  },
  isPrimaryRenderer: true
};
function assertIsOneOfType(item2, types, prop) {
  if (!types.some((type) => ItemUtils_exports.isOfType(item2, type))) {
    throw new Error(`Cannot apply ${prop} to ${item2.className}`);
  }
}
function applyProps(fragment, props) {
  const item2 = getRoot(fragment);
  Object.entries(props).forEach(([key, value]) => {
    switch (key) {
      case "id":
        ItemUtils_exports.mSetId(item2, `${value}`);
        break;
      case "size": {
        assertIsOneOfType(item2, ["Shape" /* Shape */, "Text" /* Text */, "Raster" /* Raster */], "size");
        const point = PointUtils_exports.coerce(value);
        if (ItemUtils_exports.isOfType(item2, "Shape" /* Shape */)) {
          ShapeUtils_exports.mSetSize(item2, point);
        } else if (ItemUtils_exports.isOfType(item2, "Text" /* Text */)) {
          TextUtils_exports.mSetSize(item2, point);
        } else if (ItemUtils_exports.isOfType(item2, "Raster" /* Raster */)) {
          RasterUtils_exports.mSetSize(item2, point);
        }
        break;
      }
      case "center": {
        assertIsOneOfType(item2, ["Shape" /* Shape */, "Raster" /* Raster */], "size");
        const point = PointUtils_exports.coerce(value);
        if (ItemUtils_exports.isOfType(item2, "Shape" /* Shape */)) {
          ShapeUtils_exports.mSetCenter(item2, point);
        } else if (ItemUtils_exports.isOfType(item2, "Raster" /* Raster */)) {
          RasterUtils_exports.mSetCenter(item2, point);
        }
        break;
      }
      case "fills":
        if (!ItemUtils_exports.isFillable(item2)) {
          throw new Error(`Cannot apply fill to ${item2}`);
        }
        ItemUtils_exports.mAddFills(item2, value.map((hex) => FillUtils_exports.createColorFill(ColorUtils_exports.createFromHex(`${hex}`))));
        break;
      case "content":
        assertIsOneOfType(item2, ["Text" /* Text */], "content");
        TextUtils_exports.mSetContent(item2, value);
        break;
      case "sizing":
        assertIsOneOfType(item2, ["Text" /* Text */], "sizing");
        if (!Array.isArray(value)) {
          throw new Error(`Text sizing array expected: ${value}`);
        }
        TextUtils_exports.mSetSizing(item2, value);
        break;
      case "matrix":
        ItemUtils_exports.mSetMatrix(item2, value);
        break;
      case "color": {
        assertIsOneOfType(item2, ["Text" /* Text */, "Path" /* Path */], "color");
        if (ItemUtils_exports.isOfType(item2, "Text" /* Text */)) {
          const opacity = ColorUtils_exports.getOpacity(TextUtils_exports.getColor(item2));
          const textColor = ColorUtils_exports.setOpacity(value, opacity);
          TextUtils_exports.mSetColor(item2, textColor);
        } else {
          const stroke = StrokeUtils_exports.createColorStroke(value);
          ItemUtils_exports.mAddStrokes(item2, [stroke]);
        }
        break;
      }
      case "opacity": {
        assertIsOneOfType(item2, ["Text" /* Text */], "opacity");
        TextUtils_exports.mSetOpacity(item2, value);
        break;
      }
      case "align":
        assertIsOneOfType(item2, ["Text" /* Text */], "align");
        TextUtils_exports.mSetAlign(item2, value);
        break;
      case "segments": {
        assertIsOneOfType(item2, ["Path" /* Path */], "segments");
        const segments = value.map((point) => {
          if (!Array.isArray(point) || point.length !== 2) {
            throw new Error(`Point expected: ${point}`);
          }
          const [x, y] = point.map((n) => {
            return typeof n === "string" ? parseFloat(n) : n;
          });
          if (!Number.isFinite(x)) {
            throw new Error(`point.x must be a valid number: ${x}`);
          }
          if (!Number.isFinite(y)) {
            throw new Error(`point.y must be a valid number: ${y}`);
          }
          return [x, y];
        });
        PathUtils_exports.mSetSegments(item2, segments);
        ItemUtils_exports.mAddStrokes(item2, [StrokeUtils_exports.create()]);
        break;
      }
      default:
        break;
    }
  });
}
var MyRenderer = Reconciler(hostConfig);
function render(element) {
  const canvas = CanvasUtils_exports.create();
  const artboard = ArtboardUtils_exports.create({ size: [400, 600] });
  const canvasWithArtboard = CanvasUtils_exports.mAddArtboard(canvas, artboard);
  const root = FragmentUtils_exports.create(canvasWithArtboard);
  const container = MyRenderer.createContainer(root, 0, false, null);
  MyRenderer.updateContainer(element, container, null, () => {
  });
  return root;
}

// src/testUtils/jsxUtils.tsx
function fromJSXString(jsxString) {
  return render(/* @__PURE__ */ React.createElement(JsxParser, {
    jsx: jsxString,
    renderInWrapper: false
  }));
}
export {
  ALL_EDGES,
  AXES,
  ActionMetaKey,
  ArtboardUtils_exports as ArtboardUtils,
  AssetUploadStatus,
  Axis,
  BlendMode,
  CanvasActionType,
  CanvasUtils_exports as CanvasUtils,
  ColorFormat,
  ColorUtils_exports as ColorUtils,
  CompoundPathUtils_exports as CompoundPathUtils,
  DATA_KEY,
  FillActionType,
  FillRule,
  FillUtils_exports as FillUtils,
  FontStyle,
  FontUtils_exports as FontUtils,
  FragmentUtils_exports as FragmentUtils,
  GradientType,
  GradientUtils_exports as GradientUtils,
  GroupUtils_exports as GroupUtils,
  HistoryActionType,
  INNER_EDGES,
  InnerEdge,
  ItemActionType,
  ItemClass,
  ItemUtils_exports as ItemUtils,
  LineDecoration,
  MaskUtils_exports as MaskUtils,
  MatrixUtils_exports as MatrixUtils,
  NumberUtils_exports as NumberUtils,
  OUTER_EDGES,
  OuterEdge,
  PathUtils_exports as PathUtils,
  PatternType,
  PatternUtils_exports as PatternUtils,
  PointUtils_exports as PointUtils,
  PropertyClass,
  RadiusActionType,
  RandomUtils_exports as RandomUtils,
  RasterUtils_exports as RasterUtils,
  RectangleUtils_exports as RectangleUtils,
  ShadowUtils_exports as ShadowUtils,
  ShapeType,
  ShapeUtils_exports as ShapeUtils,
  SizeUtils_exports as SizeUtils,
  SliceUtils_exports as SliceUtils,
  StrokeActionType,
  StrokeAlign,
  StrokeCap,
  StrokeJoin,
  StrokePosition,
  StrokeUtils_exports as StrokeUtils,
  testUtils_exports as TestUtils,
  TextActionType,
  TextAlign,
  TextDecoration,
  TextSizing,
  TextUnit,
  TextUtils_exports as TextUtils,
  TokenActionType,
  TokenType,
  TokenUtils_exports as TokenUtils,
  v1_exports as V1,
  VAlign,
  actionUtils_exports as actionUtils,
  actions_exports as actions,
  createDesign,
  createDesignReducer,
  createEmptyDesign,
  createSelectors,
  defaultState_default as defaultState,
  designReducer,
  enableHistory,
  enumArrayToDict,
  fontWeightNames,
  getClientId,
  mapFilterNullish,
  selectors_exports5 as selectors,
  serializer_exports as serializer,
  v4 as uuid,
  validate
};
